// firebase emulators:start --inspect-functions
import { Component, OnInit, ViewChild, ElementRef, NgZone, Renderer2, ViewChildren, QueryList, OnDestroy, ApplicationRef, HostListener, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { HotTableRegisterer } from "@handsontable/angular";
import Handsontable from 'handsontable';
import traverse from 'traverse';
import { HyperFormula, SimpleCellRange, CellValue, SimpleCellAddress } from 'hyperformula';
import { BaseScene } from './basescene';
import * as THREE from "three";
import { TransformControls } from './transformcontrols.js';
import { SplitComponent, SplitAreaDirective } from 'angular-split'
import { AngularFireDatabase, AngularFireObject } from '@angular/fire/compat/database';
import { BehaviorSubject, Observable, Subject, Subscription, firstValueFrom } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as Comlink from "comlink";
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { SnippetManager } from './snippetmanager';
import { CADNodeEngine } from './cadnodeengine';
import { Utils } from './utils';

import { debounceTime, filter, finalize, map, switchMap } from 'rxjs/operators';
import { ThreeUtils } from './threeutils';
import { FilesDialog } from '../files/files.component';
import { MaterialbComponent } from '../materialb/materialb.component';
import { DialogsubprojectComponent } from './dialogsubproject/dialogsubproject.component';
import { MonacoEditorComponent, MonacoEditorLoaderService } from '@materia-ui/ngx-monaco-editor';
import VBAAPI from './vbapi';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { InputdialogComponent } from '../inputdialog/inputdialog.component';
import { Config, DiffPatcher } from 'jsondiffpatch';
import { DialogsaveconfigComponent } from './dialogsaveconfig/dialogsaveconfig.component';
import { DialogdisclaimerComponent } from './dialogdisclaimer/dialogdisclaimer.component';
import { DialogmenuComponent } from './dialogmenu/dialogmenu.component';
import { ColorEvent } from 'ngx-color';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogdimensionsComponent } from './dialogdimensions/dialogdimensions.component';
import { DialogshapeComponent } from './dialogshape/dialogshape.component';
import { Taskmanager } from './taskmanager';


import { PublishDialog } from './dialogpublish';
// import { AngJsoneditorComponent, JsonEditorOptions } from 'ang-json-editor-13';
import { DialogfunctionsComponent } from './dialogfunctions/dialogfunctions.component';

//import { ViewportGizmo } from "three-viewport-gizmo";
//import { ViewportGizmo } from '../lib/ViewportGizmo';
import { GizmoOptions, ViewportGizmo } from "three-viewport-gizmo";

import { ToastrService } from 'ngx-toastr';


// https://hofk.de/main/discourse.threejs/2020/FatLineEdges/FatLineEdges.html
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js";
import { Wireframe } from "three/examples/jsm/lines/Wireframe.js";
import { LineSegmentsGeometry } from "three/examples/jsm/lines/LineSegmentsGeometry.js";
import { ScreenshotService } from 'app/services/screenshot.service';
import { AiPromptEditorComponent } from '../ai-prompt-editor/ai-prompt-editor.component';
import { CameraManager } from './camera-manager';
import { ScreenshotService2 } from '../services/screenshot.service';
import { CellStyleManager } from './cell-style-manager';
import { ProjectManager } from './projectmanager';
import { SheetHelper } from './sheet-helper';
import { ConfirmLeaveDialogComponent } from './confirm-leave-dialog.component';
import { YesnodialogComponent } from '../yesnodialog/yesnodialog.component';
// import { ComponentCanDeactivate } from '../guards/component-can-deactivate';
import { Location } from '@angular/common';
import { InteractionManager, SceneClickDependencies } from './interaction-manager';
import { ExportDialogComponent } from './export-dialog/export-dialog.component';
import { AIAgentComponent } from '../ai-agent/ai-agent.component';
import { Title } from '@angular/platform-browser';
import { SceneManager } from './scene-manager';
// import { NullTemplateVisitor } from '@angular/compiler';
import { ReportCreator } from '../services/report-creator';
import { Packer } from 'docx';
import { PartListDialogComponent } from '../part-list-dialog/part-list-dialog.component';
import { PartListService, PartListOptions } from '../part-list.service';
import { PartListManager } from './part-list-manager';
import { CameraFlight } from './camera-flight';
import * as TWEEN from '@tweenjs/tween.js';
import { UserTrackingService } from '../services/user-tracking.service';
import { SceneSlicer } from './scene-slicer';
import { SearchManager } from './search-manager'; // <-- Import SearchManager
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MultiImageSelectDialogComponent } from '../multi-image-select-dialog/multi-image-select-dialog.component';
import { InsertObjectDialogComponent } from '../insert-object-dialog/insert-object-dialog.component';
import { SheetOperationsManager, SheetOperationsDependencies } from './sheet-operations-manager';
import { ExportManager, ExportManagerDependencies } from './export-manager';
import { ObjectParametersDialogComponent, ObjectParametersDialogData } from './object-parameters-dialog/object-parameters-dialog.component';
import { FormulaCheckDialogComponent, FormulaCheckDialogData } from './formula-check-dialog/formula-check-dialog.component';

@Component({
    selector: 'app-editor',
    templateUrl: './editor.component.html',
    styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit, AfterViewInit, OnDestroy {
    [x: string]: any;
    public isDarkMode = true;
    inputPoint = null;
    inputPosition = null;
    inputSprite = null;
    cameraManager: CameraManager;
    cameraFlight: CameraFlight;
    sceneManager: SceneManager;
    private deactivating = new Subject<boolean>();

    // Add scene slicer property
    sceneSlicer: SceneSlicer;
    showSceneSlicer = false;

    // Add isAuthenticated property
    isAuthenticated = false;

    // Instantiate SearchManager
    searchManager: SearchManager; // <-- Declare SearchManager property

    // Sheet operations manager
    private sheetOperationsManager: SheetOperationsManager;

    // Export manager
    private exportManager: ExportManager;

    hoveredFaceCenterSprite: THREE.Sprite | null = null;
    hoveredFaceCenterOriginalMaterial: THREE.SpriteMaterial | null = null; // Changed to SpriteMaterial
    selectedFaceCenterSprite: THREE.Sprite | null = null;
    selectedObjectMenuSprite: THREE.Sprite | null = null;

    // HTML object menu icon properties

    objectMenuVisible: boolean = false;

    // Method to reset selected face center sprite
    resetSelectedFaceCenterSprite() {
        if (this.selectedFaceCenterSprite) {
            // Reset to original material
            if (this.selectedFaceCenterSprite.userData.originalMaterial) {
                this.selectedFaceCenterSprite.material = this.selectedFaceCenterSprite.userData.originalMaterial;
            }
            this.selectedFaceCenterSprite = null;
            this.updateThreeFrame();
        }
    }

    // Method to clear all selection highlights via interaction manager
    clearAllSelectionHighlights() {
        if (this.interactionManager) {
            this.interactionManager.clearAllSelectionHighlights();
        }

        // Also clear any editor-specific selection state
        this.resetSelectedFaceCenterSprite();

        // Clear selected object helper if it exists
        if (this.selectedObjectHelper) {
            this.scene.remove(this.selectedObjectHelper);
            this.selectedObjectHelper = null;
        }

        // Hide object menu
        this.objectMenuVisible = false;

        // Reset selected object reference
        this.selectedObject = null;

        this.updateThreeFrame();
    }

    hotid2 = 'hotInstance2';
    datasetsel: any[][] = [[1, 2, 3], [4, 5, 6], [7, 8, 9]];

    //  @ViewChild(AngJsoneditorComponent, { static: false }) jsoneditor: AngJsoneditorComponent;

    pickinfos = false;
    snippetManager: SnippetManager;
    autocompleteListControls = ['label', 'textbox', 'number', 'colorchooser', 'colorchooser (predefined palette)', 'colorchooser (custom colors)', 'image', 'button', 'savebutton', 'select', 'slider', 'expansion', 'checkbox', 'radio', 'tab', 'stepper', 'window', 'html', 'timer'];// TODO: externe tabellen
    autocompleteListPrimitives = ['', 'line', 'dimensionline', 'shape', 'surface', 'extrusion', 'sphere', 'capsule', 'cylinder', 'ibeam', 'cube', 'lathe', 'image3d', 'subtraction', 'textflat', 'gltf', 'group', 'light', 'gltfnode', 'text2d', 'overlay', 'overlayhtml', 'rectangle2d', 'image2d', 'chart', 'profile', 'connector', 'aluprofile', 'copy', 'grid', 'arrow', 'tube', 'union', 'ring']; // Added 'tube' and 'capsule'
    overlayTypes = ['overlay', 'image', 'rectangle2d', 'text2d', 'circle', 'ellipse', 'polygon', 'polyline', 'path', 'chart', 'overlayhtml'];
    cellinfo: string; // = "dsfsd";
    cellinfoleft = "0"; cellinfotop = "0";
    celltooltipleft = "0"; celltooltiptop = "0";
    cellactionvisible = false;
    cellactionleft = "0"; cellactiontop = "0";
    cellinfomenuvisible = false;
    cellactionmenuvisible = false;

    // Scene action menu properties
    sceneactionvisible = false;
    sceneactionleft = "0"; sceneactiontop = "0";
    sceneactionmenuvisible = false;
    justOpenedContextMenu = false;
    showprojectinfo = false;
    templatesItems: any;
    info: string;
    dataset: any;
    disableEditorDrag = false;
    disableguidrag = false;
    hotsettings: any;
    isCheckingFormula = false;

    // Cache for own projects to pass to insert object dialog
    private ownProjectsCache: any[] = [];
    private ownProjectsLoaded = false;

    slidingpanel = false;
    hfoptions = {
        licenseKey: 'gpl-v3',
        language: 'enGB',
        useColumnIndex: true,
        hiddenRows: true,
        noWrap: true,
        wordWrap: false,
        //  evaluateNullToZero: true
        //  chooseAddressMappingPolicy: 'AlwaysSparse'
    };
    showComments = 1;

    navigationType = "free";// center
    cad: CADNodeEngine;

    hf: HyperFormula;
    showTableMenu = false;
    showAIPromptEditor = false;
    aiPrompt = '';
    menuleft = '-280px';


    taskManager: Taskmanager;
    private hotRegisterer = new HotTableRegisterer();
    public hot: Handsontable;
    hotid = 'hotInstance';
    @ViewChild("rendererContainer") rendererContainer: ElementRef;
    @ViewChild("hot") hotContainer: ElementRef;

    valueSubject = new BehaviorSubject<any>(0);
    renderer;
    showSceneSettings = false;
    appguiVisible = true;
    backgroundSceneColor1: any;
    baseScene: BaseScene;
    scene = null;
    camera: any; // THREE.Camera;
    controls: any;
    viewportGizmo: ViewportGizmo;
    stats: any;
    clock: THREE.Clock;
    isMobile = false;
    showMenu = true;
    showSheetsmenu = false;
    scenemode = "select";
    mnuSelect = 2;
    tutorial: AngularFireObject<any>;
    tutorials: Observable<any[]>;
    showaccountmenu = false;
    SERVER = "https://us-central1-xbuild3d.cloudfunctions.net";  //http://localhost:5001/xbuild3d/us-central1";
    PROJECT: string;
    jsongui: any; jsongui2: any;
    files: any;
    loadingOverlay = true;
    selectedProjectName = "Main";
    debugInfos = false;

    excels: any;
    workers: Worker[];
    sheetid = 0;
    customerid: string;
    projectid: string;
    datasetids = []; datsetrows = [];
    cellformulas: any;
    fixedColumnsLeft = 0; fixedRowsTop = 0;
    project: any;
    showfiles = false;
    showGUIEditor = false; showScriptsEditor = false;
    curSelectionReadable: string;
    objectloader: THREE.ObjectLoader;

    changesQueue = [];

    tdstyles = [];

    selectedEnvMap: string;
    envMaps = [{ value: 'neutral' }, { value: 'technical' }, { value: 'sunset' }, { value: 'city' }];

    //monaco editor
    scripteditorOptions = { theme: 'vs-dark', language: 'javascript' };
    scriptcode: string = 'function xtest() {\nconsole.log("Hello world!"); console.log(globalThis["hftest"]); \n}';
    csseditorOptions = { theme: 'vs-dark', language: 'css' };
    csscode: string = '.class {\nbackground-color: #fff;\n}   .test{font-size:12px;} .test2{font-size:12px; color:red;}';
    monaceditor: MonacoEditorComponent;
    processing = true;
    vba: VBAAPI;
    interactionManager: InteractionManager;

    // Add breadcrumbs properties
    breadcrumbs: Array<{ name: string, path: string, isMain: boolean }> = [];
    showBreadcrumbs: boolean = false;

    //
    @HostListener('document:click', ['$event']) onDocumentClick(event) {
        // Check if we just opened a context menu to prevent it from closing immediately.
        if (this.justOpenedContextMenu) {
            return;
        }

        // Check if the click is on the context menu or its submenus
        const isMenuClick = event.target?.closest('.cellinfoback, .circular-menu-container, .circular-items, .cell-action-menu, .scene-action-menu, .object-action-menu, .cellaction, .contextmenuitem, .handsontable, .htCore, .ht_master, .wtHolder, .wtHider, .center-button, .item-button, .page-button, .hover-label') !== null;

        // Don't close context menu if clicking on the menu itself or spreadsheet
        if (isMenuClick) {
            return;
        }

        // If the click was outside the menu and not in the grace period, close menus.
        this.cellactionvisible = false;
        this.sceneactionvisible = false;
        this.cellinfovisible = false;
        this.cellactionmenuvisible = false;
        this.sceneactionmenuvisible = false;
        this.hideObjectMenu();

        this.scm = false;
        this.showSceneSettings = false;
        this.showSheetsmenu = false;
        this.showTableMenu = false;
        this.showOverlaymenu = false;
        this.showOverlaymenu1 = false;
        this.showothermenu = false;
        this.mnucolorvisible = false;
        this.mnucolorvisible2 = false;
        this.showaccountmenu = false;
        this.ss = false;
        this.scm = false;


        // Clear selection highlights when clicking outside of 3D objects
        // Check if the click is on the 3D canvas
        const isCanvasClick = event.target?.id === 'threecontainer' ||
            event.target?.closest('#threecontainer') !== null;

        if (isCanvasClick && !isMenuClick) {
            // Let the interaction manager handle canvas clicks
            // Selection clearing will be handled by the sceneClick method
        } else if (!isMenuClick) {
            // Clicking outside canvas and outside menus - clear selections
            this.clearAllSelectionHighlights();
        }

    }

    isShiftDown = false;
    isControlDown = false;
    showObjectInfos = false;
    @HostListener('document:keydown', ['$event']) onDocumentd(event) {
        if (event.key == "Shift") {
            this.isShiftDown = true;
        }
        if (event.key == "Control") {
            this.isControlDown = true;
        }
        if (this.isControlDown && event.key.toLowerCase() === "d") {
            event.preventDefault(); // Prevent browser's default behavior

            const canvasTarget = document.getElementById('threecontainer');
            if (!canvasTarget) return;

            const mouse = new THREE.Vector2();
            mouse.x = (event.layerX / canvasTarget.clientWidth) * 2 - 1;
            mouse.y = -(event.layerY / canvasTarget.clientHeight) * 2 + 1;

            const raycaster = new THREE.Raycaster();
            raycaster.setFromCamera(mouse, this.camera);

            // Get intersected objects based on current project context
            let intersects;
            const proobj = this.scene.getObjectByName(this.selectedSubprojectPath);
            if (proobj) {
                intersects = raycaster.intersectObjects(proobj.children, true);
            } else {
                intersects = raycaster.intersectObjects(this.scene.children, true);
            }

            // Find first valid intersection
            for (let i = 0; i < intersects?.length; i++) {
                if (!intersects[i].object.userData.isHelper && intersects[i].object.visible) {
                    const point = intersects[i].point;
                    const coordStr = `(${point.x.toFixed(2)},${point.y.toFixed(2)},${point.z.toFixed(2)})`;
                    navigator.clipboard.writeText(coordStr);
                    break;
                }
            }
        }

        // Ctrl+F shortcut for search
        if (event.ctrlKey && event.key === 'f') {
            event.preventDefault();
            this.searchManager?.focusSearchInput();
            return;
        }

        // Toggle wireframe mode on 'alt+w' key press
        if (event.key.toLowerCase() === 'w' && !this.isControlDown && !this.isShiftDown && this.isAltDown(event) && !this.isMetaDown(event)) {
            event.preventDefault(); // Prevent 'w' from being typed into any input fields
            this.toggleWireframeMode();
            return;
        }
    }

    private isAltDown(event: KeyboardEvent): boolean {
        return event.altKey;
    }

    private isMetaDown(event: KeyboardEvent): boolean {
        return event.metaKey;
    }


    toggleWireframeMode() {
        this.sceneManager.toggleWireframeMode();
    }

    beforekeydown = (e) => {
        // if (this.editcell) {
        //   var txtarea = document.getElementsByClassName('handsontableInput')[0] as any;

        //   this.setCaretToPos(txtarea, 2);
        // }
        try {
            if (!e.key) {
                //  e.stopImmediatePropagation();
                // e.preventDefault();
                return;
            }

            //    console.log("beforekeydown", e);
            if (e.key == "Alt" && !this.editcell) {
                if (this.curSelectedRow < SheetHelper.getOutputRow(this.dataset) && this.curSelectedCol < 2) {
                    this.contextmenuitem1 = 1;
                    this.cellactionmenuvisible = true;
                }
                if (this.curSelectedRow > SheetHelper.getOutputRow(this.dataset) && this.curSelectedCol < 2) {
                    this.contextmenuitem = 1;

                    this.cellactionmenuvisible = true;
                }
                if (this.cellinfovisible)
                    this.cellinfomenuvisible = !this.cellinfomenuvisible;
                if (this.celltoolsvisible) {

                    this.showcelltools();
                }
            }

            if (e.key == "Escape") {
                this.cellactionmenuvisible = false;
                this.sceneactionmenuvisible = false;
                this.cellinfomenuvisible = false;
                this.showOverlaymenu = false;
                this.showOverlaymenu1 = false;
                this.showothermenu = false;

                // Clear all selection highlights
                this.clearAllSelectionHighlights();

                // Check if a subproject is selected
                if (!this.isMainConfig) {
                    // Reset to main project
                    if (this.selectedObjectHelper)
                        this.scene.remove(this.selectedObjectHelper);
                    this.selectedNode = this.scene;
                    this.selectedSubprojectID = this.PROJECT;
                    this.selectedProjectName = null;
                    this.selectedSubprojectPath = null;
                    this.selectedprojectpath = "root^$" + this.sheetid;
                    this.isMainConfig = true;
                    this.jsongui2 = null;

                    // Reset materials/opacity
                    this.scene.traverse((child) => {
                        if (child.material) {
                            if (child.userData.opacity > 0.99)
                                child.material.transparent = false;
                            if (child.userData.opacity)
                                child.material.opacity = child.userData.opacity;
                        }

                    });
                    this.excels[this.PROJECT].createJsonGUI(0).then(gui => {
                        this.jsongui = gui;
                        this.csschange(this.project.csscode);
                        this.subprojectSelected();
                        this.updateThreeFrame();
                    });
                }
            }

            // menu1
            if (this.cellactionmenuvisible && this.curSelectedRow < SheetHelper.getOutputRow(this.dataset)) {
                if (e.key == "ArrowDown") {
                    this.contextmenuitem1++;
                    e.stopImmediatePropagation();
                }

                if (e.key == "ArrowUp") {

                    this.contextmenuitem1--;
                    e.stopImmediatePropagation();
                }


                if (e.key == "ArrowRight" && this.contextmenuitem1 == 9) {
                    this.contextmenuitem1 = 21;
                    this.showOverlaymenu1 = true;
                    e.stopImmediatePropagation();

                    return;
                }
                if (e.key == "ArrowLeft" && this.contextmenuitem1 > 20) {
                    this.contextmenuitem1 = 9;
                    this.showOverlaymenu1 = false;
                    e.stopImmediatePropagation();

                    return;

                }

                if (e.key == "Enter") {
                    var t = ['', 'label', 'textbox', 'number', 'checkbox', 'radio', 'PNG', 'select', 'slider', '', '',
                        '', '', '', '', '', '', '', '', '', '',
                        'button', 'expansion', 'colorchooser', 'colorchooser (predefined palette)', 'colorchooser (custom colors)', 'savebutton'];
                    if (this.contextmenuitem1 == 6)
                        this.showfilesDialog('PNG');
                    else if (this.contextmenuitem1 == 9)
                        this.showOverlaymenu1 = true;
                    else
                        this.addGui(t[this.contextmenuitem1], 'selected');

                    if (this.contextmenuitem1 != 9)
                        this.cellactionmenuvisible = false;

                    this.refs = null;
                    this.applyCellMeta();

                    e.stopImmediatePropagation();
                }

            }

            // menu2
            if (this.cellactionmenuvisible && this.curSelectedRow > SheetHelper.getOutputRow(this.dataset)) {
                if (e.key == "ArrowDown") {
                    this.contextmenuitem++;
                    e.stopImmediatePropagation();
                }

                if (e.key == "ArrowUp") {

                    this.contextmenuitem--;
                    e.stopImmediatePropagation();
                }

                if (e.key == "ArrowRight" && this.contextmenuitem == 9) {
                    this.contextmenuitem = 40;
                    this.showothermenu = true;
                    e.stopImmediatePropagation();

                    return;
                }
                if (e.key == "ArrowRight" && this.contextmenuitem == 10) {  // showSheetsmenu showOverlaymenu
                    this.contextmenuitem = 21;
                    this.showSheetsmenu = true;
                    e.stopImmediatePropagation();
                    return;
                }
                if (e.key == "ArrowRight" && this.contextmenuitem == 11) {  // showSheetsmenu showOverlaymenu
                    this.contextmenuitem = 30;
                    this.showOverlaymenu = true;
                    e.stopImmediatePropagation();
                    return;
                }

                if (e.key == "ArrowLeft" && this.contextmenuitem > 19 && this.contextmenuitem < 30) {
                    this.contextmenuitem = 10;
                    this.showSheetsmenu = false;
                    e.stopImmediatePropagation();
                    return;
                }
                if (e.key == "ArrowLeft" && this.contextmenuitem > 29) {
                    this.contextmenuitem = 11;
                    this.showOverlaymenu = false;
                    e.stopImmediatePropagation();
                    return;
                }

                if (e.key == "Enter") {
                    var t = ['', 'extrusion', '', 'line', 'shape', 'cube', 'cylinder', 'textflat', '', '', '',
                        '', '', '', '', '', '', '', '', '', '',
                        '', '', '', '', '', '', '', '', '', '',
                        'overlay', 'text2d', ' rectangle2d', 'image2d', 'chart', "", "", "", "", "",
                        'subtraction', 'sphere', 'surface', "light", "profile"];
                    if (this.contextmenuitem == 2)
                        this.showfilesDialog('gltf');
                    else if (this.contextmenuitem == 9)
                        this.showSheetsmenu = true;
                    else if (this.contextmenuitem == 10)
                        this.showOverlaymenu = true;
                    else if (this.contextmenuitem == 11)
                        this.addProject();
                    else if (this.contextmenuitem > 11 && this.contextmenuitem < 30)
                        this.addPrimitive('sheet: ' + this.project?.sheets[this.contextmenuitem].name, 'selected');
                    else
                        this.addPrimitive(t[this.contextmenuitem], 'selected');

                    if (this.contextmenuitem != 10)
                        this.cellactionmenuvisible = false;
                    e.stopImmediatePropagation();
                }

            }

        } catch (e) {
            console.warn("beforekeydown", e);
        }
    }

    @HostListener('document:keyup', ['$event']) onDocumentup(event) {
        if (event.key == "Shift") this.isShiftDown = false;
        if (event.key == "Control") this.isControlDown = false;
    }

    // darkmode
    switchMode() {
        // if (document.body.classList.contains('darkmode')) {
        //   document.body.classList.remove("darkmode");
        // } else {
        //   document.body.classList.add("darkmode");
        //    }
    }

    scripteditorInit($event: any) {
        console.log("scripteditorInit", $event);

    }
    csseditorInit($event) {
        console.log("csseditorInit", $event);
        $event.trigger("editor", "editor.action.formatDocument");
    }

    csschange($e, issubconfig = false) {
        if (!issubconfig)
            this.project.csscode = $e;
        //   console.log("csschange", this.project.csscode);
        // TODO: auch wechseln, bei configwechsel
        var htmlid = "customcss_" + this.projectid;
        if (document.getElementById(htmlid))
            document.getElementById(htmlid).remove();

        // Build your `<link>` dynamically
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.id = htmlid;
        link.href = 'data:text/css;charset=UTF-8,' + encodeURIComponent($e); // TODO: css von project
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    updateScene($event) {
        console.log("updateScene", this.project.sceneSettings.directionalIntensity, $event);
        this.baseScene.updateScene(this.project.sceneSettings, this.camera);

        this.updateThreeFrame();
    }

    ss = false;
    scm = false;
    async test() {


        console.log("test", this.scm);

        var cellrange = {
            start: { row: 0, col: 0, sheet: this.sheetid },
            end: { row: 0, col: 0, sheet: this.sheetid }
        };
        var t = await this.excels[this.PROJECT].cut(cellrange);
        var p = await this.excels[this.PROJECT].paste({ sheet: 0, row: 0, col: 4 });
        console.log("paste", p);
        this.scm = !this.scm;
    }
    timersEnabled = true;
    timers = []; intervals = [];
    async timerfunction(t, clock: THREE.Clock) {
        var interval = setInterval(async () => {
            //  console.log("timerfunction", t.name, clock);
            if (this.project.sceneSettings.showAnimations) {
                //        var delta = clock.getDelta();
                //  for (var i = 0; i < this.timers.length; i++) {
                var isenabled = await this.excels[this.PROJECT].getCellSerialized({ sheet: 0, row: t.row, col: 6 });
                isenabled = isenabled == "true" ? true : false;

                if (!isenabled)
                    clock.stop();
                if (isenabled) {
                    if (!clock.running) {

                        clock.start();
                    }

                    var elapsed = clock.getElapsedTime();


                    var changes = await this.excels[this.PROJECT].setCellContents({ sheet: 0, row: t.row, col: 4 }, elapsed);
                    //  }
                    await globalThis.API.updateUI(); // warum auch immer das geht aber applyCellMeta nicht?!

                    // var eventinfo = {
                    //   point: intersects[0].point,
                    //   distance: intersects[0].distance,
                    // }

                    var jsfunction2 = t.changefunction;

                    if (jsfunction2) {
                        //        var es = JSON.stringify(eventinfo);
                        //       if (!es) es = "null";
                        //      jsfgffunction2 = jsfunction2.replace("event", es);
                        //       var ud = this.sceneobjectMouseOver;
                        //       if (ud) ud = JSON.stringify(ud);
                        //       else ud = "null";
                        //       jsfunction2 = jsfunction2.replace("object", ud);
                        eval(this.project.scriptcode + "  " + jsfunction2 + ";");
                    }      //      console.log("timer", elapsed, delta);

                }
                //      this.applyCellMeta();
            }
        }, t.interval);
    }


    clocks = [];
    async createTimers() {
        this.timers = await this.excels[this.PROJECT].getTimers();
        console.log("createTimers", this.timers);
        //
        // var timer = {
        //   name: name, row: j, sheet: i, interval: interval, changefunction: changefunction
        // };

        // neu: timer mit expression
        //await this.excels[this.PROJECT].changeNamedExpression("time100", 100);

        this.intervals = [];
        for (var i = 0; i < this.timers.length; i++) {
            var clock = new THREE.Clock();
            this.clocks.push(clock);
            var t = this.timers[i];
            this.timerfunction(t, this.clocks[i]);
            // var interval = setInterval(async () => {
            //   if (this.project.sceneSettings.showAnimations) {
            //     console.log("timer", t.name);
            //     var delta = clock.getDelta();
            //     var elapsed = clock.getElapsedTime();
            //     //   for (var i = 0; i < this.timers.length; i++) {
            //     var isenabled = await this.excels[this.PROJECT].getCellSerialized({ sheet: 0, row: t.row, col: 6 });
            //     isenabled = isenabled == "true" ? true : false;
            //     if (isenabled)
            //       var changes = await this.excels[this.PROJECT].setCellContents({ sheet: 0, row: t.row, col: 4 }, elapsed);
            //     //  }
            //     await globalThis.API.updateUI(); // warum auch immer das geht aber applyCellMeta nicht?!

            //     var jsfunction2 = t.changefunction;

            //     if (jsfunction2) {
            //       //        var es = JSON.stringify(eventinfo);
            //       //       if (!es) es = "null";
            //       //      jsfunction2 = jsfunction2.replace("event", es);
            //       //       var ud = this.sceneobjectMouseOver;
            //       //       if (ud) ud = JSON.stringify(ud);
            //       //       else ud = "null";
            //       //       jsfunction2 = jsfunction2.replace("object", ud);
            //       eval(this.project.scriptcode + "  " + jsfunction2 + ";");
            //     }      //      console.log("timer", elapsed, delta);

            //     //      this.applyCellMeta();
            //   }
            // }, t.interval);
            // this.intervals.push(interval);
        }

    }

    diffpatchGUI(jsongui: any, jsongui2: any): any {
        var conf: Config;
        conf = {
            arrays: {
                detectMove: true,
                includeValueOnMove: false
            },
            textDiff: {
                minLength: 60
            },
            propertyFilter: function (name, context) {
                return name.slice(0, 1) !== '$';
            },
            cloneDiffValues: false
        };

        var jsondiffpatch = new DiffPatcher(conf);
        var delta = jsondiffpatch.diff(this.jsongui, jsongui);
        //  jsondiffpatch.patch(this.jsongui, jsongui);
        //    this.jsongui = jsondiffpatch.patch(this.jsongui, delta);
        this.jsongui = jsondiffpatch.patch(this.jsongui, delta);
        //  this.jsongui2 = jsongui;
    }

    transformControl: any;
    cellStyleManager: CellStyleManager;

    // public jsonEditorOptions: JsonEditorOptions;
    constructor(private cdr: ChangeDetectorRef, private toastr: ToastrService, private screenshotService: ScreenshotService, private monacoLoaderService: MonacoEditorLoaderService, public sanitized: DomSanitizer, private ngZone: NgZone,
        public storage: AngularFireStorage, public dialog: MatDialog, public http: HttpClient, private rtdb: AngularFireDatabase, public auth: AngularFireAuth, public afs: AngularFirestore, public router: Router, public snackBar: MatSnackBar, private appRef: ApplicationRef, private route: ActivatedRoute, private zone: NgZone, public ngrenderer: Renderer2, private location: Location, private titleService: Title, private partListService: PartListService, private userTracking: UserTrackingService, private screenshotService2: ScreenshotService2, private partListManager: PartListManager, private sheetOpsManager: SheetOperationsManager, private exportMgr: ExportManager) {
        // Initialize SceneManager - this will create and manage scene, renderer, camera, etc.
        this.sceneManager = new SceneManager(null, null, false); // Will be properly initialized in ngAfterViewInit

        // Get references to scene and renderer from SceneManager
        this.scene = this.sceneManager.scene;
        this.renderer = this.sceneManager.renderer;
        this.baseScene = this.sceneManager.baseScene;

        this.cad = new CADNodeEngine();
        this.snippetManager = new SnippetManager();
        this.objectloader = new THREE.ObjectLoader();
        this.sheetOperationsManager = sheetOpsManager;
        this.exportManager = exportMgr;

        this.hf = HyperFormula.buildEmpty(this.hfoptions as any);

        this.hotsettings = {
            // TODO  editor: CustomEditor,
            licenseKey: 'non-commercial-and-evaluation',
            currentRowClassName: 'currentRow',
            wordWrap: false,

        };


        Handsontable.renderers.registerRenderer('customStylesRenderer', (hotInstance, TD, ...rest) => {

            //    console.log('stylesoverride in renderer:', this.project?.settings?.stylesoverride); // <--- ADD THIS LINE
            Handsontable.renderers.getRenderer('text')(hotInstance, TD, ...rest);
            if (rest?.length > 1) {
                if (this.project?.settings?.stylesoverride) {
                    var r = rest[0];
                    var c = rest[1];
                    try {
                        var meta = this.hot?.getCellMeta(r, c);
                    } catch (error) {
                    }
                    // TODO: direkt aus this.tdstyles holen

                    if (meta?.stylemeta?.background) {
                        TD.style.background = meta.stylemeta.background;
                    }
                    if (meta?.stylemeta?.foreground) {
                        TD.style.color = meta.stylemeta.foreground;
                    }
                }

            }

            // Handsontable.renderers.TextRenderer.apply(this, arguments);

            // Then modify CSS to allow overflow
            // TD.style.overflow = 'hidden';
            TD.style.textOverflow = 'ellipsis';
            // TD.style.whiteSpace = 'nowrap';
            // TD.style.maxWidth = '100%'; // Ensure cell doesn't expand

            // TD.style.overflow = 'visible';
            // TD.style.whiteSpace = 'nowrap';
            // TD.style.maxWidth = 'none';
        });

        this.cellStyleManager = new CellStyleManager(this.afs);
        //https://stackoverflow.com/questions/51150422/how-to-detect-click-outside-of-an-element-in-angular
        this.ngrenderer.listen('window', 'click', (e: Event) => {
            //   console.log("window click", e);
            this.showaccountmenu = false;
            for (var i = 0; i < this.project?.sheets?.length; i++) {
                this.project.sheets[i].visible = false;
            }
        });
        // this.jsonEditorOptions = new JsonEditorOptions()

        // this.jsonEditorOptions.modes = ['view']; // set all allowed modes
        // this.jsonEditorOptions.mode = 'view'; //set only one mode
        // this.jsonEditorOptions.expandAll = true;

        //    this.jsonEditorOptions.statusBar = false;
        //  this.jsonEditorOptions.mainMenuBar = false;
        //    this.jsonEditorOptions.navigationBar = false;
        // this.jsonEditorOptions.theme = 1;

        // Add navigation handling
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                const currentUrl = this.router.url;

                if ((event as any).navigationTrigger === 'popstate') {
                    // Store the attempted navigation URL
                    const targetUrl = event.url;

                    const timeSinceLastSave = Date.now() - this.lastSaveTime;

                    if (timeSinceLastSave > 10000) {
                        // Cancel the current navigation by navigating back to current URL
                        this.router.navigate([currentUrl], { skipLocationChange: true }).then(() => {
                            const dialogRef = this.dialog.open(ConfirmLeaveDialogComponent, {
                                width: '400px',
                                disableClose: true,
                                data: { timeSinceLastSave: Math.floor(timeSinceLastSave / 1000) }
                            });

                            dialogRef.afterClosed().subscribe(result => {
                                if (result) {
                                    // User confirmed leaving
                                    this.deactivating.next(true);
                                    this.deactivating.complete();
                                    // Navigate to the original target URL
                                    this.router.navigateByUrl(targetUrl);
                                } else {
                                    // User cancelled - stay on page
                                    this.deactivating.next(false);
                                    this.deactivating.complete();
                                    // Ensure we stay on current URL
                                    history.pushState(null, '', currentUrl);
                                }
                            });
                        });
                    } else {
                        // No unsaved changes, navigate to target
                        this.router.navigateByUrl(targetUrl);
                    }
                }
            }
        });
    }

    // Store the previous size of the right (AI agent) panel
    previousRightPanelSize: number = 25; // Default size (e.g., 25%)
    // Store the previous sizes of all panels when hiding
    previousPanelSizes: number[] | null = null;


    toggleAIPromptEditor() {
        this.showAIPromptEditor = !this.showAIPromptEditor;
        const splitInstance = this.splitEl; // Use @ViewChild reference

        if (splitInstance && splitInstance.setVisibleAreaSizes) {
            if (this.showAIPromptEditor) {
                // Showing the editor: Restore the previous layout if available, otherwise use defaults
                const sizesToRestore = this.previousPanelSizes || [30, 45, 25]; // Default: [Left, Middle, Right]

                // Ensure the right panel size is restored correctly if it was 0
                if (sizesToRestore[2] === 0) {
                    sizesToRestore[2] = this.previousRightPanelSize > 0 ? this.previousRightPanelSize : 25; // Use stored size or default
                    sizesToRestore[1] = 100 - sizesToRestore[0] - sizesToRestore[2]; // Adjust middle
                }

                setTimeout(() => {
                    splitInstance.setVisibleAreaSizes(sizesToRestore);
                    // Save the restored sizes to project settings
                    if (this.project?.settings) {
                        this.project.settings.splitSizes = {
                            left: sizesToRestore[0],
                            middle: sizesToRestore[1],
                            right: sizesToRestore[2]
                        };
                    }
                    // Trigger resize update after setting sizes
                    setTimeout(() => this.onResize(null), 50);
                }, 0);
                this.previousPanelSizes = null; // Clear stored sizes after restoring

            } else {
                // Hiding the editor: Store current sizes and minimize the right panel
                const currentSizesRaw = splitInstance.getVisibleAreaSizes(); // Get percentages [left, middle, right]

                // Convert sizes to numbers, handling potential "*"
                const currentSizes = currentSizesRaw.map(s => typeof s === 'string' ? 0 : s); // Treat '*' as 0 for calculation

                if (currentSizes && currentSizes.length === 3) {
                    this.previousPanelSizes = [...currentSizes]; // Store the current layout (as numbers)
                    // Store the last known size > 0 for the right panel, or use default
                    const rightPanelSizeNum = Number(currentSizes[2]);
                    if (rightPanelSizeNum > 1) { // Use a threshold > 0 to avoid storing tiny values
                        this.previousRightPanelSize = rightPanelSizeNum;
                    } else if (!this.previousRightPanelSize || this.previousRightPanelSize <= 1) {
                        this.previousRightPanelSize = 25; // Fallback to default if current or stored is tiny/zero
                    }

                    // Calculate new middle size to take up the hidden space
                    const leftSize = Number(currentSizes[0]);
                    const middleSize = Number(currentSizes[1]) + Number(currentSizes[2]); // Middle panel takes the space
                    const rightSize = 0;

                    setTimeout(() => {
                        splitInstance.setVisibleAreaSizes([leftSize, middleSize, rightSize]);
                        // Save the new sizes to project settings
                        if (this.project?.settings) {
                            this.project.settings.splitSizes = {
                                left: leftSize,
                                middle: middleSize,
                                right: rightSize
                            };
                        }
                        // Trigger resize update after setting sizes
                        setTimeout(() => this.onResize(null), 50);
                    }, 0);
                } else {
                    // Fallback if sizes aren't as expected
                    console.warn("Could not get valid current split sizes. Using default hide state.");
                    this.previousRightPanelSize = 25; // Reset to default
                    this.previousPanelSizes = null;
                    setTimeout(() => {
                        splitInstance.setVisibleAreaSizes([30, 70, 0]); // Default hide state
                        // Save the new sizes to project settings
                        if (this.project?.settings) {
                            this.project.settings.splitSizes = {
                                left: 30,
                                middle: 70,
                                right: 0
                            };
                        }
                        // Trigger resize update after setting sizes
                        setTimeout(() => this.onResize(null), 50);
                    }, 0);
                }
            }
        } else {
            console.warn("Could not find SplitComponent instance via @ViewChild or setVisibleAreaSizes method is missing.");
        }
        // Ensure Angular detects changes, although onResize might handle this too
        this.cdr.detectChanges();
    }





    color1: any; color2: any;
    setCellBackground(e) {
        this.updateSheetOperationsDependencies();
        this.sheetOperationsManager.setCellBackground(e);
    }

    resetCellBackground() {
        this.updateSheetOperationsDependencies();
        this.sheetOperationsManager.resetCellBackground();
        this.color1 = null;
    }

    resetCellForeground() {
        this.updateSheetOperationsDependencies();
        this.sheetOperationsManager.resetCellForeground();
        this.color2 = null;
    }

    setCellForeground(e) {
        this.updateSheetOperationsDependencies();
        this.sheetOperationsManager.setCellForeground(e);
    }

    async applyCellMeta() {
        this.updateSheetOperationsDependencies();
        await this.sheetOperationsManager.applyCellMeta();
    }

    toload = [];

    getConfigSheets(configs: any, list: any) {  // TODO: funzt nicth mit public von anderen
        console.log('getconfigs', configs);
        if (Object.keys(configs).length === 0 || !configs) {
            return;
        }

        for (const l in configs) {
            console.log('l', l);
            var c = configs[l];
            var userid = this.customerid;
            if (c.userid) userid = c.userid;
            list.push(userid + '_' + c.id);  // TODO: funzt nicth mit public von anderen
            this.getConfigSheets(c.configurations, list);
        }
    }


    impersonationId: string;
    leftpanelvisible = true; isEditMode = false;
    configid: string;

    @ViewChild('viewportGizmo') viewportGizmoElement: ElementRef;

    async ngAfterViewInit() {
        // Use the projectid and configid that were set in ngOnInit via route.params
        // If they weren't set (for backward compatibility), get them from the snapshot
        if (!this.projectid) {
            this.projectid = this.route.snapshot.paramMap.get('projectid');
        }

        if (!this.configid) {
            this.configid = this.route.snapshot.paramMap.get('configid');
        }

        var dbpath = "/projects/userprojects/" + this.customerid + "/" + this.projectid;
        // public
        if (this.route.snapshot.url[0].path == "p") {
            this.leftpanelvisible = false;
            this.isEditMode = false;
            dbpath = "projectspublic" + "/" + this.projectid;

            // Check if user is authenticated to show top bar
            // if (this.auth.user) {
            //   this.auth.user.subscribe(user => {
            //     if (user) {
            //       // User is authenticated, show top bar
            //       this.leftpanelvisible = true;
            //     } else {
            //       // User is not authenticated, keep top bar hidden
            //       this.leftpanelvisible = false;
            //     }
            //   });
            // } else {
            //   // No auth user observable, keep top bar hidden
            //   this.leftpanelvisible = false;
            // }
        }

        if (this.route.snapshot.url[0].path == "e") {
            this.isEditMode = true;
        }

        this.leftpanelvisible = this.isEditMode;

        // Initialize SceneManager with proper dependencies (project will be null initially)
        this.sceneManager = new SceneManager(this.rendererContainer, null, this.isMobile);
        this.sceneManager.setupthreejs();

        // Update references after SceneManager setup
        this.scene = this.sceneManager.scene;
        this.renderer = this.sceneManager.renderer;
        this.camera = this.sceneManager.camera;
        this.controls = this.sceneManager.controls;
        this.baseScene = this.sceneManager.baseScene;
        this.cameraManager = this.sceneManager.cameraManager;
        this.transformControl = this.sceneManager.transformControl;
        this.clock = this.sceneManager.clock;

        // Initialize interaction manager
        this.interactionManager = new InteractionManager(this.scene, this.camera, this.renderer, this.cursorType);
        this.cursorSubscription = this.interactionManager.cursorTypeChange.subscribe((cursorType: string) => {
            console.log('cursorType', cursorType);
            this.ngZone.run(() => {
                this.cursorType = cursorType;
            });
        });

        this.sceneSlicer = new SceneSlicer(this.scene, this.renderer, this.camera);

        this.cad.interactionManager = this.interactionManager;

        // tasks
        if (this.route.snapshot.url[0].path == "tasks") {
            // this.splitleft = 0;

            this.leftpanelwidth = 0;
            if (this.leftpanelwidth > 9000) this.leftpanelwidth = 0;
            this.threecontainerwidth = window.innerWidth - this.leftpanelwidth;

            this.initview();
            this.updateThreeFrame();
            this.loadingOverlay = false;
            this.taskManager = new Taskmanager(this.afs, this.storage, this.renderer, this.camera, this.scene, this.controls);
            this.scene.fog = null;
            return;
        }
        else {
            this.excelSync();
            this.auth.authState.subscribe(async x => {
                try {
                    this.customerid = x?.uid;

                    // impersonation
                    this.impersonationId = this.route.snapshot.queryParamMap.get('impersonationId');
                    if (this.impersonationId) {
                        this.customerid = this.impersonationId;
                        console.log('Impersonating customer ID:', this.customerid);
                    }

                    console.log("authstate sub: ", x);
                    if (this.isEditMode)
                        dbpath = "/projects/userprojects/" + this.customerid + "/" + this.projectid;

                    this.toload = [];
                    var pr = (await this.afs.doc(dbpath).get().toPromise());   //.subscribe(data => {

                    // project loaded project json
                    this.project = pr.data();
                    if (!this.customerid) this.customerid = this.project.userid; //TODO: prüfen!!!
                    if (!this.project.sceneSettings)
                        this.project.sceneSettings = this.baseScene.sceneSettings
                    else
                        this.baseScene.sceneSettings = this.project.sceneSettings;

                    console.log('project', this.project);

                    // Update SceneManager with loaded project
                    this.sceneManager.project = this.project;

                    // Add colWidths to each sheet in project if not exist
                    if (this.project.sheets) {
                        for (let sheetId in this.project.sheets) {
                            if (!this.project.sheets[sheetId].colWidths) {
                                this.project.sheets[sheetId].colWidths = new Array(300).fill(100);
                            }
                        }
                    }


                    if (!this.project.cameras)
                        this.addCamera();
                    // if (this.project?.initialcamera) {
                    //   this.camera.matrix.fromArray(JSON.parse(this.project.initialcamera));
                    //   this.camera.matrix.decompose(this.camera.position, this.camera.quaternion, this.camera.scale);
                    // }
                    // if (this.isEditMode && this.project?.camera) {
                    //   this.camera.matrix.fromArray(JSON.parse(this.project.camera));
                    //   this.camera.matrix.decompose(this.camera.position, this.camera.quaternion, this.camera.scale);

                    // }

                    // Note: Camera state will be loaded later after SceneManager initialization


                } catch (error) {
                    console.error("Failed to load project data", error);


                    this.toastr.error(error.message, null, { positionClass: 'toast-bottom-center', });
                    //   this.snackBar.open("Error loading project data: " + error.message, null, { duration: 15000, panelClass: ['snackbar-error'] });
                }


                try {
                    if (!this.project.settings) {
                        this.project.settings = {};
                        this.project.settings.cameraZoom = true;

                        this.project.settings.cameraZoomPointer = false;
                        this.project.settings.subprojectSelectable = false;
                        this.project.settings.cameraPan = true;

                    }
                    if (!this.project.sceneSettings.dirAngle)
                        this.project.sceneSettings.dirAngle = 0;

                    // Initialize menuSettings if it doesn't exist
                    if (!this.project.menuSettings) {
                        this.project.menuSettings = {};
                    }

                    // Set default values for menu position and size if not already set
                    if (!this.project.menuSettings.menuleft) {
                        this.project.menuSettings.menuleft = '10px';
                    }
                    if (!this.project.menuSettings.menutop) {
                        this.project.menuSettings.menutop = '10px';
                    }
                    if (!this.project.menuSettings.width) {
                        this.project.menuSettings.width = 400; // Default width
                    }
                    if (!this.project.menuSettings.height) {
                        this.project.menuSettings.height = 600; // Default height
                    }
                    if (!this.project.menuSettings.menufloat) {
                        this.project.menuSettings.menufloat = 'left';
                    }
                    if (this.project.menuSettings.menuminimized === undefined) {
                        this.project.menuSettings.menuminimized = false;
                    }

                    // Initialize originalPosition if not present and menu is not minimized
                    if (!this.project.menuSettings.originalPosition && !this.project.menuSettings.menuminimized) {
                        this.project.menuSettings.originalPosition = {
                            left: this.project.menuSettings.menuleft,
                            top: this.project.menuSettings.menutop
                        };
                    }

                    // Initialize originalDimensions if not present
                    if (!this.project.menuSettings.originalDimensions) {
                        this.project.menuSettings.originalDimensions = {
                            width: this.project.menuSettings.width,
                            height: this.project.menuSettings.height
                        };
                    }

                    console.log("loaded project.menuSettings", this.project.menuSettings);

                    // Wait for the view to be initialized, then apply the saved dimensions and position
                    setTimeout(() => {
                        this.applyGuiPanelSettings();
                    }, 300);

                    this.changeHandling();

                    this.baseScene.updateScene(this.project.sceneSettings, this.camera);
                    this.project.id = pr.id;
                    this.toload.push(this.customerid + '_' + this.projectid);
                    this.PROJECT = this.toload[0];

                    this.getConfigSheets(this.project.configurations, this.toload);
                    // remove duplicates from list
                    this.toload = this.toload.filter((v, i, a) => a.indexOf(v) === i);
                    console.log('toload ', this.toload);

                    this.autocompleteListPrimitives.push('');
                    for (var i = 0; i < this.project.sheets.length; i++) {
                        this.autocompleteListPrimitives.push("sheet: " + this.project.sheets[i].name);
                    }
                    //      });


                } catch (error) {
                    console.error("Failed to load project data", error);
                    this.toastr.error(error.message, null, { positionClass: 'toast-bottom-center', });
                    //        this.snackBar.open("Error loading project data: " + error.message, null, { duration: 15000, panelClass: ['snackbar-error'] });
                }

                try {
                    // toload.push('userid-assemblyclass-2');
                    this.files = this.toload;
                    this.workers = [];
                    this.excels = {};
                    var promises = [];
                    for (var i = 0; i < this.toload.length; i++) {
                        const w = new Worker(new URL('./../app.worker', import.meta.url), { type: 'module' });
                        this.workers.push(w);
                        this.excels[this.toload[i]] = Comlink.wrap(this.workers[i]) as any;
                        var p = this.excels[this.toload[i]].load(this.toload[i], this.project.sheets);
                        promises.push(p);
                    }

                    var t0 = performance.now();
                    var promisesresult = await Promise.all(promises).catch(reason => {
                        console.error(reason)
                    });
                    console.log('promisesresult', promisesresult);
                    var t1 = performance.now();
                    console.log("webworker loads took " + (t1 - t0) + " milliseconds.");

                    // Handle cell errors inline since this is initial loading
                    const cells = promisesresult[0].cells;
                    for (var i = 0; i < cells.length; i++) {
                        for (var j = 0; j < cells[i].length; j++) {
                            if (cells[i][j]?.type == 'VALUE' || cells[i][j]?.type == 'ERROR') {
                                cells[i][j] = "#." + cells[i][j]?.message;
                            }
                        }
                    }
                    this.dataset = cells;
                    this.datasetids = promisesresult[0].datasetids;
                    this.cellformulas = promisesresult[0].cellvalues;

                    var res1 = await this.excels[this.PROJECT].addNamedExpression("screensize", "0,0");

                    await this.excels[this.PROJECT].addNamedExpression("screenwidth", 0);
                    await this.excels[this.PROJECT].addNamedExpression("screenheight", 0);

                    if (this.isEditMode) {
                        this.excels[this.PROJECT].setCurrentSheetId(this.sheetid);
                        this.excels[this.PROJECT].monitorCellFormulas();
                    }


                    // config params
                    if (this.configid) {
                        var configpath = "/configs/" + this.customerid + "/" + this.projectid + "/" + this.configid;
                        var configmodel = (await this.afs.doc(configpath).get().toPromise()).data();   //.subscribe(data => {
                        console.log('configmodel', configmodel);
                        this.project.configmodel = configmodel;
                    }
                    if (this.project.configmodel) {
                        var outputRowsObject = await this.excels[this.PROJECT].getConfiguration(0, this.project.configmodel.inputs, this.project.configmodel.vals, true);
                        var outputRowsP = outputRowsObject.map(row => row.data);
                        var outputRowIndexes = outputRowsObject.map(row => row.rowindex);
                        console.log('sheet 0 outputRowsP', outputRowsP);

                        for (var i = 1; i < outputRowsP.length; i += 1) {
                            for (var j = 0; j < outputRowsP[i].length - 1; j++) {
                                var rowindex = outputRowsP[i][outputRowsP[i].length - 1];
                                this.dataset[rowindex][j] = outputRowsP[i][j];
                            }
                        }
                    }

                } catch (error) {
                    console.error("Failed to load project data", error);
                    this.toastr.error("Error loading project data: " + error.message, null, { positionClass: 'toast-bottom-center', });
                    //       this.snackBar.open("Error loading project data: " + error.message, null, { duration: 15000, panelClass: ['snackbar-error'] });
                }

                try {
                    if (this.leftpanelvisible) {

                        this.hot = this.hotRegisterer.getInstance(this.hotid); //.loadData([['new', 'data']]);
                        this.hot.addHook('afterColumnResize', (newSize, column) => {
                            //  this.saveColumnWidth(column, newSize);
                            console.log("afterColumnResize", column, newSize);
                            this.project.sheets[this.sheetid].colWidths[column] = newSize;
                        });

                        this.hot.updateSettings({
                            autoWrapRow: false,
                            autoWrapCol: false,
                            // wordWrap: true, in renderer mit check auf zelle rechts

                            afterOnCellMouseOver: (event, coords) => {
                                const td = this.hot.getCell(coords.row, coords.col);
                                if (td?.scrollWidth > td?.clientWidth) {
                                    const value = this.hot.getDataAtCell(coords.row, coords.col);
                                    // Show tooltip with full content
                                    // You can use a tooltip library or title attribute
                                    td.title = value;
                                }
                            },
                            // renderer: function (instance, td, row, col, prop, value, cellProperties) {
                            //   // Apply the default text renderer first
                            //   Handsontable.renderers.TextRenderer.apply(this, arguments);

                            //   // Then modify CSS to allow overflow
                            //   td.style.overflow = 'hidden';
                            //   td.style.textOverflow = 'ellipsis';
                            //   td.style.whiteSpace = 'nowrap';
                            //   td.style.maxWidth = '100%'; // Ensure cell doesn't expand
                            // }
                        });

                        if (this.hot)
                            this.applyCellMeta();
                    }

                    // td styles - will be loaded by SheetOperationsManager when needed
                    this.tdstyles = [];

                    this.jsongui = await this.excels[this.PROJECT].createJsonGUI(this.sheetid);

                    //   this.setSceneSettings()
                    this.gridchange();
                    this.sceneManager.initview((event) => {
                        console.log("dragging-changed", event, this.transformControl.object);
                        if (this.transformControl.object?.userData?.row) {
                            var o = this.transformControl.object;
                            var ud = this.transformControl.object.userData;
                            for (var i = 0; i < ud.commentrow.length; i++) {
                                if (ud.commentrow[i] == "x") {
                                    this.dataset[ud.rowindex][i] = o.position.x;
                                    this.excels[this.PROJECT].setCellContents({ row: ud.rowindex, col: i, sheet: ud.sheetid }, o.position.x);
                                }
                                if (ud.commentrow[i] == "y") {
                                    this.dataset[ud.rowindex][i] = o.position.y;
                                    this.excels[this.PROJECT].setCellContents({ row: ud.rowindex, col: i, sheet: ud.sheetid }, o.position.y);
                                }
                                if (ud.commentrow[i] == "z") {
                                    this.dataset[ud.rowindex][i] = o.position.z;
                                    this.excels[this.PROJECT].setCellContents({ row: ud.rowindex, col: i, sheet: ud.sheetid }, o.position.z);
                                }
                            }

                            if (this.isEditMode)
                                this.hot.render();
                        }
                        this.controls.enabled = !event.value;
                    });

                    // Update references after initview
                    this.cameraFlight = this.sceneManager.cameraFlight;
                    this.transformControl = this.sceneManager.transformControl;

                    this.initAdditionalComponents();

                    this.toggleAIPromptEditor();

                    this.createModel(this.scene, this.dataset, this.PROJECT);
                    console.log("jsongui", this.jsongui);
                    // API ------------------------------------
                    globalThis.scene = this.scene;
                    globalThis.excels = this.excels;
                    globalThis.subprojectSelected = this.selectedSubprojectID;
                    globalThis.project = this.project;
                    this.vba = new VBAAPI(this.excels, this.hot, this.scene, this.dataset, this, this.controls, this.transformControl, this.project, this.afs);
                    await this.vba.createScripts();
                    globalThis.ActiveWorkbook = this.vba.ActiveWorkbook;

                    globalThis.updateUI = this.applyCellMeta;
                    globalThis.API = this.vba;
                    this.createTimers();
                    Utils.basecsschange(this.project.id, this.project.menuSettings);
                    this.csschange(this.project.csscode);

                    await this.vba.executeScript("ONLOADED()");
                    //----------------------------------------



                    if (this.isEditMode) {
                        // Restore saved split sizes if they exist
                        if (this.project?.settings?.splitSizes && this.splitEl) {
                            const savedSizes = this.project.settings.splitSizes;
                            console.log('Restoring saved split sizes:', savedSizes);

                            // Apply saved sizes to the split component after loading is complete
                            setTimeout(() => {
                                this.splitEl.setVisibleAreaSizes([
                                    savedSizes.left,
                                    savedSizes.middle,
                                    savedSizes.right
                                ]);

                                // Update panel widths based on restored sizes
                                this.leftpanelwidth = Math.round(Number(savedSizes.left) / 100.0 * window.innerWidth) * 1 / 1.0;
                                this.threecontainerwidth = Math.round(Number(savedSizes.middle) / 100.0 * window.innerWidth) * 1 / 1.0;
                                this.agentpanelwidth = Math.round(Number(savedSizes.right) / 100.0 * window.innerWidth) * 1 / 1.0;

                                // Show split panels after loading is complete
                                this.loadingOverlay = false;

                                // Trigger resize update after setting sizes
                                setTimeout(() => this.onResize(null), 50);
                            }, 300); // Increased delay to ensure everything is properly loaded
                        } else {
                            // Use displayedAreas for three split areas (default behavior)
                            const areas = this.splitEl.displayedAreas;
                            this.leftpanelwidth = Math.round(Number(areas[0].size) / 100.0 * window.innerWidth) * 1 / 1.0;
                            this.threecontainerwidth = Math.round(Number(areas[1].size) / 100.0 * window.innerWidth) * 1 / 1.0;
                            this.agentpanelwidth = Math.round(Number(areas[2].size) / 100.0 * window.innerWidth) * 1 / 1.0;

                            // Show split panels after loading is complete
                            this.loadingOverlay = false;
                        }
                    } else {
                        this.leftpanelwidth = 0;
                        this.threecontainerwidth = window.innerWidth;
                        this.agentpanelwidth = 0;
                        this.loadingOverlay = false;
                    }

                    // Fallback timeout to ensure loading screen doesn't stay forever
                    setTimeout(() => {
                        if (this.loadingOverlay) {
                            console.warn('Loading screen timeout reached, hiding loading overlay');
                            this.loadingOverlay = false;
                        }
                    }, 5000); // 5 second fallback timeout
                    if (this.leftpanelwidth > 9000) this.leftpanelwidth = 0;
                    this.threecontainerwidth = window.innerWidth - this.leftpanelwidth;

                    // Setup viewport gizmo through SceneManager
                    this.sceneManager.setupViewportGizmo(this.threecontainerwidth);
                    this.viewportGizmo = this.sceneManager.viewportGizmo;

                    // Load saved camera view if it exists (after SceneManager initialization)
                    if (this.project?.cameraview) {
                        const cameraState = JSON.parse(this.project.cameraview);

                        // Restore complete camera state
                        this.camera.matrix.fromArray(cameraState.matrix);
                        this.camera.position.fromArray(cameraState.position);
                        this.camera.quaternion.fromArray(cameraState.quaternion);
                        this.camera.zoom = cameraState.zoom;
                        this.controls.target.fromArray(cameraState.target);

                        // Update camera matrices
                        this.camera.matrix.decompose(this.camera.position, this.camera.quaternion, this.camera.scale);
                        this.camera.updateProjectionMatrix();

                        // Update controls
                        this.controls.update();

                        console.log('Camera state restored from project.cameraview');
                    }

                    if (this.project.sceneSettings.iso) {
                        this.sceneManager.setIsometricView(true);
                        this.camera = this.sceneManager.camera; // Update camera reference
                        this.controls = this.sceneManager.controls; // Update controls reference
                        this.onResize(null);
                    }
                } catch (error) {
                    console.error("Failed to load project data", error);
                    this.toastr.error(error.message, null, { positionClass: 'toast-bottom-center', });
                    //     this.snackBar.open("Error loading project data: " + error.message, null, { duration: 15000, panelClass: ['snackbar-error'] });
                }

                try {
                    eval(this.project.scriptcode); // erste ausführung von eval zur javascript ausführung zB gui erstellung über jquery
                } catch (error) {
                    console.error("Failed to load project scriptcode", error);
                    this.toastr.error(error.message, null, { positionClass: 'toast-bottom-center', });
                    //     this.snackBar.open("Error loading project data: " + error.message, null, { duration: 15000, panelClass: ['snackbar-error'] });
                }

                this.sceneManager.updateThreeFrame();

                // Set up proximity effect callback for on-demand rendering
                this.sceneManager.onUpdateFrame = () => {
                    this.updateConnectorProximityEffect();
                };

                // Debug: Check for connectors in scene after model creation
                setTimeout(() => {
                    this.debugConnectorsInScene();
                }, 2000); // Wait 2 seconds for model to be fully created

                // Setup InteractionManager dependencies after all initialization is complete
                this.setupInteractionManagerDependencies();

                // Refresh interactive objects after initial model creation
                if (this.interactionManager) {
                    this.interactionManager.refreshInteractiveObjects();
                }

                // Set up title update when project name changes
                this.updateTitle();
                // Watch for project name changes
                this.afs.doc(`projects/${this.project.id}`).valueChanges().subscribe((project: any) => {
                    if (project?.name) {
                        this.updateTitle();
                    }
                });

            });
        }
        var isSaving = false;
        document.addEventListener('keydown', async e => {
            //if (e.ctrlKey && e.key === 'e') {
            if (!isSaving)
                if (e.metaKey && e.key === 'e' || e.ctrlKey && e.key === 's') {
                    console.log("saving");
                    isSaving = true;
                    this.processing = true;  // Show processing indicator
                    e.preventDefault();
                    try {
                        await this.saveCells();
                        // update model
                        if (this.editval)
                            await this.sheetChange(this.editcell, this.editval, this.editval);

                        await ThreeUtils.clearScene(this.scene);
                        await this.applyCellMeta();
                        this.jsongui = await this.excels[this.PROJECT].createJsonGUI(this.sheetid);
                        await this.createModel(this.scene, this.dataset, this.PROJECT);

                        await this.afs.doc("projects/userprojects/" + this.customerid + "/" + this.project.id).update(JSON.parse(JSON.stringify(this.project)));

                        // this.snackBar.open("Save completed", "", {
                        //   duration: 2000,
                        //   panelClass: ['success-snackbar']
                        // });
                    } catch (error) {
                        this.snackBar.open("Error saving: " + error.message, "", {
                            duration: 4000,
                            panelClass: ['error-snackbar']
                        });
                    } finally {
                        this.processing = false;  // Hide processing indicator
                        await new Promise(resolve => setTimeout(resolve, 4000));
                        isSaving = false;
                    }
                }
        });


        this.subscriptions.add(
            this.valueSubject.pipe(
                debounceTime(2),  // Debounce inputs to reduce frequency
                switchMap(async inputValue => {
                    // Skip processing if inputValue is invalid or if still creating
                    if (this.iscreating || !inputValue || typeof inputValue !== 'object') {
                        if (this.iscreating) {
                            // If a generation is ongoing, save the latest input to be processed later
                            this.lastInputValue = inputValue;
                        }
                        return [] as any;  // Return an empty observable
                    } else {

                        this.iscreating = true;
                        await this.sheetChangeWrapper(inputValue);
                        // Start generation immediately if nothing is currently generating
                        this.iscreating = false;
                        if (this.isEditMode)
                            this.hot?.render();
                    }
                })
            ).subscribe(model => {

                // TODO: wir nach cell editierung ausgelöst?!

                // console.log('subscribption', model)
                /*     if ((model as any).length > 0) {
                      console.log('Model generated:', model);
                    } */
                //      this.isGenerating = false;
                // Check if there is a queued last input to process next
                if (this.lastInputValue !== null) {
                    let nextInput = this.lastInputValue;
                    this.lastInputValue = null;  // Reset last input value
                    this.valueSubject.next(nextInput);  // Re-emit the last input
                }
            })
        );

        // Add event listeners for mobile-specific events
        if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
            // Add orientation change handler for mobile devices
            window.addEventListener('orientationchange', () => {
                // Wait for the orientation change to complete
                setTimeout(() => {
                    this.onResize(null);
                    this.updateThreeFrame();
                }, 200);
            });

            // Force touch action to allow pinch-zoom
            const rendererElement = this.renderer?.domElement;
            if (rendererElement) {
                rendererElement.style.touchAction = 'none';

                // Additional touch event listeners to ensure rendering updates
                rendererElement.addEventListener('touchend', () => {
                    this.updateThreeFrame();
                });

                // Ensure pinch gesture is recognized
                let initialDistance = 0;
                rendererElement.addEventListener('touchstart', (e) => {
                    if (e.touches.length === 2) {
                        initialDistance = Math.hypot(
                            e.touches[0].pageX - e.touches[1].pageX,
                            e.touches[0].pageY - e.touches[1].pageY
                        );
                    }
                });

                rendererElement.addEventListener('touchmove', (e) => {
                    if (e.touches.length === 2) {
                        // Calculate pinch distance
                        const currentDistance = Math.hypot(
                            e.touches[0].pageX - e.touches[1].pageX,
                            e.touches[0].pageY - e.touches[1].pageY
                        );

                        // Force rendering update during pinch gestures
                        this.updateThreeFrame();
                    }
                });
            }
        }

        // Add connector event listener
        window.addEventListener('connectorSelected', (event: CustomEvent) => {
            this.handleConnectorSelection(event.detail);
        });
    }

    /**
     * Handles connector selection events
     * @param connectorData The connector data from the event
     */
    private handleConnectorSelection(connectorData: any) {
        console.log('[EDITOR] Connector selected event received:', connectorData);

        // Update any UI elements to show connector information
        if (connectorData && connectorData.label) {
            // Show the scene action menu at the mouse pointer position
            this.showSceneActionMenu(connectorData.mouseEvent);

            // Set a dummy row selection for the context menu to work
            // Use a row that's in the output section (below outputrow)
            this.curSelectedRow = this.findNextAvailableOutputRow();

            // Store connector information for potential use
            this.selectedConnectorInfo = {
                label: connectorData.label,
                position: connectorData.position,
                normal: connectorData.normal,
                type: connectorData.type,
                outputid: connectorData.outputid || connectorData.label // Use outputid if available, fallback to label
            };

            // Trigger change detection to update the UI
            this.cdr.detectChanges();

            console.log('[EDITOR] Scene action menu configured:', {
                visible: this.sceneactionvisible,
                left: this.sceneactionleft,
                top: this.sceneactiontop,
                connectorLabel: this.selectedConnectorInfo.label,
                connectorOutputId: this.selectedConnectorInfo.outputid
            });
        }

        // Example: Show a toast notification
        this.snackBar.open(`Connector ${connectorData.label} selected`, 'Close', {
            duration: 3000,
            panelClass: ['connector-snackbar']
        });
    }

    // Property to store selected connector information
    public selectedConnectorInfo: any = null;

    // Add property to store selected refpos instead of using clipboard
    private selectedRefPos: string | null = null;

    // Properties to store potential selection objects for click detection
    private potentialSelectionObject: THREE.Object3D | null = null;
    private potentialSelectionEvent: any = null;

    private findNextAvailableOutputRow(): number {
        const outputRow = SheetHelper.getOutputRow(this.dataset);
        let lastObjectRow = outputRow;

        // Find the last row with actual output object data
        for (let i = outputRow + 1; i < this.dataset.length; i++) {
            const rowData = this.dataset[i];
            if (rowData && rowData[0] && rowData[0] !== '' && rowData[0] !== '#' &&
                rowData[1] && rowData[1] !== '' &&
                (this.isInList(this.autocompleteListPrimitives, rowData[1]) || rowData[1]?.startsWith('project'))) {
                lastObjectRow = i;
            }
        }

        // Return the row after the last object plus one empty row buffer
        return lastObjectRow + 2;
    }

    private initAdditionalComponents() {
        // Defer getting the Handsontable instance and dependent setup
        setTimeout(() => {
            try {
                this.hot = this.hotRegisterer.getInstance(this.hotid);

                if (this.hot) {
                    // Setup that depends on this.hot
                    this.cdr.detectChanges(); // Detect changes *after* getting hot instance
                    this.onResize(null);

                    if (this.isEditMode) {
                        this.splitDragEnd({ sizes: [this.splitleft, 100 - this.splitleft] });
                        this.hot.render(); // Safe to call render here
                    }

                    // TODO: autoformat?
                    this.monacoLoaderService.isMonacoLoaded$.pipe(
                        filter(isLoaded => isLoaded),
                    ).subscribe((x) => {
                        console.log("monaco loaded", x, monaco);
                    });

                    // Initialize sheet operations manager after hot is available
                    this.initializeSheetOperationsManager();

                    // Initialize export manager after project is loaded
                    this.initializeExportManager();

                    this.applyCellMeta();
                    this.hot.render();
                    this.hot.rootElement?.focus();
                    this.hot.refreshDimensions();

                } else {
                    console.warn(`Handsontable instance with id '${this.hotid}' not found after timeout.`);
                    // Handle case where instance is still not found - basic layout updates
                    this.cdr.detectChanges();
                    this.onResize(null);
                }
            } catch (error) {
                console.error("Error getting Handsontable instance inside setTimeout:", error);
            }
        }, 0); // Use setTimeout with 0 delay
    }

    private initializeSheetOperationsManager() {
        const deps: SheetOperationsDependencies = {
            excels: this.excels,
            hot: this.hot,
            project: this.project,
            dataset: this.dataset,
            cellformulas: this.cellformulas,
            afs: this.afs,
            http: this.http,
            dialog: this.dialog,
            toastr: this.toastr,
            customerid: this.customerid,
            projectid: this.projectid,
            sheetid: this.sheetid,
            isEditMode: this.isEditMode,
            tdstyles: this.tdstyles,
            refs: this.refs,
            curSelectedRow: this.curSelectedRow,
            cellStyleManager: this.cellStyleManager
        };

        this.sheetOperationsManager.setDependencies(deps);
    }

    private updateSheetOperationsDependencies() {
        if (this.sheetOperationsManager) {
            this.initializeSheetOperationsManager();
        }
    }

    private initializeExportManager() {
        const deps: ExportManagerDependencies = {
            scene: this.scene,
            camera: this.camera,
            renderer: this.renderer,
            project: this.project,
            customerid: this.customerid,
            projectid: this.projectid,
            afs: this.afs,
            dialog: this.dialog,
            toastr: this.toastr,
            screenshotService2: this.screenshotService2,
            updateThreeFrame: () => this.updateThreeFrame(),
            updateLastSaveTime: () => this.updateLastSaveTime()
        };

        this.exportManager.setDependencies(deps);
    }


    toggleMenu() {
        if (!this.project?.menuSettings) return;

        // Store the original position and dimensions when first minimizing
        if (!this.project.menuSettings.menuminimized) {
            if (!this.project.menuSettings.originalPosition) {
                this.project.menuSettings.originalPosition = {
                    left: this.project.menuSettings.menuleft,
                    top: this.project.menuSettings.menutop
                };
            }
            if (!this.project.menuSettings.originalDimensions) {
                this.project.menuSettings.originalDimensions = {
                    width: this.project.menuSettings.width || 400,
                    height: this.project.menuSettings.height || 600
                };
            }
        }

        if (this.project.menuSettings.menuminimized) {
            // Restore from minimized state - restore both position and dimensions
            if (this.project.menuSettings.originalPosition) {
                this.project.menuSettings.menuleft = this.project.menuSettings.originalPosition.left;
                this.project.menuSettings.menutop = this.project.menuSettings.originalPosition.top;
            } else {
                this.project.menuSettings.menuleft = '10px';
                this.project.menuSettings.menutop = '10px';
            }

            // Restore original dimensions
            if (this.project.menuSettings.originalDimensions) {
                this.project.menuSettings.width = this.project.menuSettings.originalDimensions.width;
                this.project.menuSettings.height = this.project.menuSettings.originalDimensions.height;
            }
        } else {
            // Minimize - move panel completely off screen to the left, only toggle button visible
            const width = this.project.menuSettings.width || 400;
            this.project.menuSettings.menuleft = (-width) + 'px';
        }

        this.project.menuSettings.menuminimized = !this.project.menuSettings.menuminimized;

        // Apply the changes immediately
        this.applyGuiPanelSettings();
        this.updateLastSaveTime();
    }

    getToggleButtonPosition() {
        if (!this.project?.menuSettings) {
            return { left: '10px', top: '220px' };
        }

        // Get ACTUAL current dimensions from the DOM element for accurate positioning
        const guiPanel = document.getElementById('gui-panel');
        let currentWidth = this.project.menuSettings.width || 400;
        let currentHeight = this.project.menuSettings.height || 600;
        let currentLeft = parseInt(this.project.menuSettings.menuleft?.replace('px', '') || '0');
        let currentTop = parseInt(this.project.menuSettings.menutop?.replace('px', '') || '0');

        // If panel exists, get REAL dimensions and position from DOM
        if (guiPanel) {
            const rect = guiPanel.getBoundingClientRect();
            const computedStyle = window.getComputedStyle(guiPanel);

            currentWidth = rect.width;
            currentHeight = rect.height;
            currentLeft = parseInt(computedStyle.left?.replace('px', '') || '0');
            currentTop = parseInt(computedStyle.top?.replace('px', '') || '0');
        }

        let left: string;
        let top: string;

        if (this.project.menuSettings.menuminimized) {
            // When minimized, position the toggle button at the left edge of the screen
            left = '0px';
            // Use the original top position or a default
            const originalTop = this.project.menuSettings.originalPosition?.top || this.project.menuSettings.menutop || '10px';
            top = (parseInt(originalTop.replace('px', '')) + Math.min(currentHeight / 2 - 30, 220)) + 'px';
        } else {
            // When expanded, position the button at the right edge of the panel using REAL dimensions
            if (this.project.menuSettings.menufloat === 'right') {
                // For right-aligned menus
                left = (currentLeft - 32) + 'px';
            } else {
                // For left-aligned menus
                left = (currentLeft + currentWidth) + 'px';
            }
            // Position the button vertically at the center of the menu using REAL dimensions
            top = (currentTop + Math.min(currentHeight / 2 - 30, 220)) + 'px';
        }

        return { left, top };
    }

    async cloneproject() {
        if (this.isCloning) return; // Prevent multiple simultaneous clone operations

        this.isCloning = true;
        try {
            this.loadingOverlay = true;
            await ProjectManager.cloneProject(this.project, this.customerid, this.http, this.afs, this.snackBar);
        } finally {
            this.isCloning = false;
            this.loadingOverlay = false;
        }
    }

    async saveproject() {
        this.processing = true;
        this.processingMessage = 'Saving...';
        try {
            // Create config model before saving
            var configModel = await this.createConfigModel();
            this.project.configmodel = {
                ...this.project.configmodel,
                ...configModel
            };

            // Use ExportManager to save the project
            await this.exportManager.saveProject(this.excels, this.hot, this.PROJECT);
            console.log('savedproject', this.project);
        } catch (error) {
            this.snackBar.open("Error saving: " + error.message);
        } finally {
            this.processing = false;
            this.processingMessage = '';
        }
    }

    async saveCells() {
        this.cellformulas = await this.excels[this.PROJECT].getSheetSerializedByIndex(this.sheetid);
        await this.exportManager.saveCells(this.excels, this.hot, this.PROJECT);
    }

    excelSync() {
        // excel sync
        this.afs.collection("cellupdates/" + this.projectid + "/excelupdates").valueChanges({ idField: 'id' }).subscribe(data => {
            for (var i = 0; i < data.length; i++) {
                console.log('cellupdate', JSON.parse((data[i] as any).valueAfter)); // data[i]);
                console.log('del', "cellupdates/" + this.projectid + "/excelupdates/" + (data[i] as any).id)
                this.afs.doc("cellupdates/" + this.projectid + "/excelupdates/" + (data[i] as any).id).delete();
            }
        });
    }

    async createConfigModel(): Promise<any> {
        // root params
        var newsnippet = await this.excels[this.PROJECT].getSnippet(this.project.sheets[0].name);

        // projects
        var configModel = { inputs: newsnippet.values[0], vals: newsnippet.values[1] };
        this.scene.traverse((child) => {
            try {

                if (child.userData?.typ?.toUpperCase().startsWith("PROJECT") || child.userData?.typ?.toUpperCase().startsWith("SHEET")) {
                    var path = child.userData.path;
                    if (path?.startsWith("^")) {

                        path = "root" + path;
                    }

                    if (child.userData.refposobj) {
                        delete child.userData.refposobj;
                    }



                    configModel[path] = child.userData;

                    //      Utils.setValue(configModel, path, child.userData);
                    //  console.log('child', child, child.name);
                }
            } catch (e) {
                console.log('createConfigModel error', e);
            }
        });

        console.log('configModel', configModel)
        return configModel;
    }

    stylesoverride(e) {
        console.log('stylesoverride', e, this.project?.settings?.stylesoverride);
        this.updateSheetOperationsDependencies();
        this.sheetOperationsManager.stylesoverride(e.checked);
    }


    // object is in list 
    isInList(list, object) {
        for (var i = 0; i < list.length; i++) {
            if (JSON.stringify(list[i]) == JSON.stringify(object)) {
                return true;
            }
        }
        return false;
    }

    // TODO: ggf in ww
    overlays: any = { root: {} }; showOverlaymenu = false;
    showOverlaymenu1 = false; showothermenu = false;
    contextmenuitem = -1;
    contextmenuitem1 = -1;
    overlayarray: any = [];
    async createModel(rootNode: any, dataset: any, CONFIGURATION: string) {
        this.processing = true;
        this.processingMessage = 'Building model...';
        try {
            console.log("createModel", this.dataset);
            var newnodes = [];
            this.outputrow = SheetHelper.getOutputRow(this.dataset);


            for (var j = this.outputrow + 1; j < dataset.length; j++) {
                try {

                    var typ = dataset[j][1];
                    var objectname = "$" + this.sheetid + "#" + dataset[j][0];
                    var commentrow = SheetHelper.getCommentRow(dataset, j);

                    if (commentrow && typ) {
                        // overlaytypes is in ist
                        if (this.isInList(this.overlayTypes, typ)) {
                            // 2d overlays 
                            objectname = "root^$" + this.sheetid + "#" + dataset[j][0];
                            var overlay = await this.createOverlay(j, objectname, dataset[j], commentrow, typ);
                        }
                        else {

                            // row[1].toUpperCase().startsWith('SHEET:'){

                            // }
                            //  console.log('createCADNode ', objectname, typ);
                            console.log('createCADNode ', objectname, typ, dataset[j], typ, this.sheetid);
                            var newnode = await this.cad.createOrUpdateCADNode(j, this.sheetid, objectname, dataset[j], commentrow, rootNode, this.excels, CONFIGURATION, this.toload, this.workers, this.customerid, this.projectid, this.project.configmodel, 0);


                            if (newnode) {
                                //    newnode.name = objectname;
                                rootNode.add(newnode);
                                newnodes.push(newnode);
                            }
                        }
                        //  this.updateThreeFrame();
                    }
                } catch (e) {
                    console.log('createModel error', e);
                }
            }

            console.log('newnodes', newnodes, this.scene);
            this.updateThreeFrame();
            return newnodes;
        } finally {
            this.processing = false;
            this.processingMessage = '';
        }
    }

    async createChart(params) {
        var sheetid = 0; // zunächst nur overlays aus 1.sheet aus mainconfig
        var from = await this.excels[this.PROJECT].simpleCellAddressFromString(params.values.split(':')[0], sheetid);
        var to = await this.excels[this.PROJECT].simpleCellAddressFromString(params.values.split(':')[1], sheetid);
        var table = await this.excels[this.PROJECT].getRangeValues({ start: from, end: to });
        params.chartvalues = Utils.transformTableToNgxChartsModel(table);
        return params.chartvalues;
    }
    async createOverlay(j, objectname, row, commentrow, typ) {
        var overlayname = "root"
        var params = Utils.mapRowToParams(row, commentrow);
        params.typ = typ;
        if (!this.overlays[overlayname][objectname])
            this.overlays[overlayname][objectname] = {};
        if (params.typ == "chart") {
            this.createChart(params);
        }
        if (params.typ == "overlayhtml") {


        }
        this.overlays[overlayname][objectname] = params;
        this.overlays[overlayname][objectname].objectname = objectname;
        // json keys to array
        var ovkeys = Object.keys(this.overlays.root);
        this.overlayarray = [];
        for (var i = 0; i < ovkeys.length; i++) {
            this.overlayarray.push(this.overlays.root[ovkeys[i]]);
        }
    }
    async updateOverlay(j, objectname, row, commentrow, typ) {
        var overlayname = "root"
        var params = Utils.mapRowToParams(row, commentrow);
        params.typ = typ;
        if (!this.overlays[overlayname][objectname])
            this.overlays[overlayname][objectname] = {};
        if (params.typ == "chart") {
            var v = await this.createChart(params);
            this.overlays[overlayname][objectname] = this.diffchart(this.overlays[overlayname][objectname], params);
            this.overlays[overlayname][objectname].chartvalues = params.chartvalues;
        }
        else
            this.overlays[overlayname][objectname] = params;
        this.overlays[overlayname][objectname].objectname = objectname;
        // json keys to array
        //  var ovkeys = Object.keys(this.overlays.root);
        //    this.overlayarray = [];
        var found = false;
        for (var i = 0; i < this.overlayarray.length; i++) {
            if (this.overlayarray[i].objectname == objectname) {
                found = true;
                this.overlayarray[i] = this.overlays.root[objectname];
                break;

            }
        }
        if (!found) {
            if (!this.overlayarray) this.overlayarray = [];
            this.overlayarray.push(this.overlays.root[objectname]);
        }
    }

    diffchart(params, newparams) {
        var conf: Config;
        conf = {
            arrays: {
                detectMove: true,
                includeValueOnMove: false
            },
            textDiff: {
                minLength: 60
            },
            propertyFilter: function (name, context) {
                return name.slice(0, 1) !== '$';
            },
            cloneDiffValues: false
        };
        var jsondiffpatch = new DiffPatcher(conf);
        var delta = jsondiffpatch.diff(params, newparams);
        var r = jsondiffpatch.patch(params, delta);
        return r;
    }




    dataset2: any;
    updatecount = 0;
    async updateModel(exportedchanges, olddata, scenenode) {
        this.processing = true;
        this.processingMessage = 'Updating model...';
        try {
            console.log('updatemodel', exportedchanges);
            var rowupdated = [];

            for (var j = 0; j < exportedchanges?.length; j++) {
                var change = exportedchanges[j];
                var a = change.address;
                if (!a) continue;
                var sheetid = a.sheet;

                var dataset = this.dataset
                if (!this.isMainConfig)
                    dataset = this.dataset2;
                // TODO: check was geupdated wurde und nur zeilenweise updaten
                var outputrow = SheetHelper.getOutputRow(dataset);
                // gelöscht
                if (dataset[a.row][1] == "" && a.row > outputrow && dataset[a.row][0] != "#" && olddata) {
                    if (!this.isInList(rowupdated, { sheet: a.sheet, row: a.row })) {
                        // übergeordnete projekte nicht selektiert?
                        // var nname = parent.name.replace(this.selectedprojectpath, "");
                        // var n = "#" + nname.split('#')[1].split('^')[0];
                        // var nname2 = this.selectedprojectpath + n;
                        // if (!this.selectedprojectpath.endsWith("^$0"))
                        //   nname2 = this.selectedprojectpath + "^$0" + n;
                        // var nobj = this.scene.getObjectByName(nname2);
                        // if (nobj) {
                        //   this.selectedprojectpath = nname2;
                        //   parent = nobj;
                        // }



                        var name = SheetHelper.getOldNameByRow(olddata, a.row);
                        var objectnameold = "$" + sheetid + "#" + name; // todo: subprojects
                        var objectname = this.selectedprojectpath + "#" + name;
                        objectname = Utils.preNames(this.scene) + "^" + objectname;
                        objectname = objectname?.replace("root^root^", "root^");

                        rowupdated.push({ sheet: a.sheet, row: a.row });

                        var toremoveobject = this.scene.getObjectByName(objectname);
                        if (toremoveobject)
                            this.scene.remove(toremoveobject);

                    }
                }

                if (dataset[a.row][1] != null && dataset[a.row][1] != "" && a.row > outputrow && dataset[a.row][0] != "#") {
                    //
                    if (!this.isInList(rowupdated, { sheet: a.sheet, row: a.row })) {

                        rowupdated.push({ sheet: a.sheet, row: a.row });
                        var typ = dataset[a.row][1];
                        var objectname = "root^$" + sheetid + "#" + dataset[a.row][0]; // TODO falsch für unterprojekte
                        objectname = Utils.preNames(this.scene) + "^" + objectname;
                        objectname = objectname?.replace("root^root^", "root^");


                        var subtraction = null;

                        // TODO: subprojekte erst auf Änderung x,y,z,rx,ry,rz,tx,ty,tz,material,visible checken, dann erst remove/add

                        // TODO funzt nicht mit gedropppten rows 
                        var hr = SheetHelper.getHeadRow(dataset, a.row);
                        if (hr != 0)// {//hr = a.row - 1;// TODO über jack
                            //  try {

                            if (dataset[hr][a.col]?.startsWith("node")) { // == "nodematerial") {
                                if (objectname) {
                                    var object = this.scene.getObjectByName(objectname);
                                    var nodename = dataset[a.row - 1][a.col].split('=')[1];

                                    var statement = dataset[a.row][a.col];
                                    var prop = statement?.split('=')[0];
                                    var value = statement?.split('=')[1];
                                    // hier wird die node nur updated --------------------
                                    this.cad.updateNodel(prop, nodename, value, object);
                                    // -----------------------------------------------
                                }
                            }
                            //          } catch (error) {
                            //            console.warn('updateModel', error);
                            //           }
                            //      }
                            else {
                                var isover = false;
                                if (objectname) {
                                    if (scenenode) {
                                        var object = scenenode?.getObjectByName(objectname);


                                        if (object == this.sceneobjectSelected)
                                            isover = true;

                                    }

                                    // while (object) {
                                    //   //      console.log(objectname, object);
                                    //   // bestimmte Attribute werden direkt im model gesetzt => TODO: zweite prüfung in createORupdateNode nötig?
                                    //   var hr = SheetHelper.getHeadRow(dataset, a.row);

                                    //   if (this.dataset[hr][a.col] == "x" || this.dataset[hr][a.col] == "y" || this.dataset[hr][a.col] == "z" ||
                                    //     this.dataset[hr][a.col] == "rx" || this.dataset[hr][a.col] == "ry" || this.dataset[hr][a.col] == "rz" ||
                                    //     this.dataset[hr][a.col] == "sx" || this.dataset[hr][a.col] == "sy" || this.dataset[hr][a.col] == "sz" ||
                                    //     this.dataset[hr][a.col].startsWith("node") || this.dataset[hr][a.col] == "visible"
                                    //   )
                                    //     break;
                                    //   if (object) {
                                    //      console.log('remove', objectname)
                                    //      // if (object.userData.subtraction) {

                                    //      //   var subtraction = scenenode.getObjectByName(object.userData.subtraction);
                                    //      //   console.log('subtraction', object.userData.subtraction, subtraction);

                                    //      // }
                                    //      scenenode.remove(object);

                                    //   }
                                    //     //      console.log('remove', objectname)
                                    //     // if (object.userData.subtraction) {

                                    //     //   var subtraction = scenenode.getObjectByName(object.userData.subtraction);
                                    //     //   console.log('subtraction', object.userData.subtraction, subtraction);

                                    //     // }
                                    //     scenenode.remove(object);

                                    //   }
                                    //   object = scenenode.getObjectByName(objectname);

                                    // }
                                }
                                // get subproject node

                                // var subnode = this.scene;

                                if (!this.selectedSubprojectID)
                                    this.selectedSubprojectID = this.PROJECT;

                                var commentrow = SheetHelper.getCommentRow(dataset, a.row); // dataset[a.row - 1]

                                if (this.isInList(this.overlayTypes, typ)) {
                                    // 2d overlays 
                                    var overlay = await this.updateOverlay(j, objectname, dataset[a.row], commentrow, typ);
                                }
                                else {
                                    // 3d model node estellen -----------------------------------------------
                                    var newnode = await this.cad.createOrUpdateCADNode(a.row, sheetid, objectname, dataset[a.row], commentrow, scenenode, this.excels, this.selectedSubprojectID, this.toload, this.workers, this.customerid, this.projectid, this.project.configModel, sheetid);

                                    if (newnode?.userData)
                                        if (newnode.userData.typ == "gltf" && newnode.userData.cadstate == "created") {
                                            var dim = JSON.parse(JSON.stringify(newnode)).object;
                                            await this.handleDimensionsDialog(dim, a.row, commentrow);
                                            rowupdated.push({ sheet: a.sheet, row: a.row });
                                        }

                                    // postprocess cuts and boudnignsboxes and connections

                                }

                                if (subtraction) {
                                    scenenode = scenenode; //?
                                    var rowindex = subtraction.userData.rowindex;
                                    var row = subtraction.userData.row;
                                    commentrow = subtraction.userData.commentrow;
                                    var name = subtraction.userData.path;
                                    scenenode.remove(subtraction);
                                    var newnode = await this.cad.createOrUpdateCADNode(rowindex, sheetid, name, row, commentrow, scenenode, this.excels, this.selectedSubprojectID, this.toload, this.workers, this.customerid, this.projectid, this.project.configModel, sheetid);

                                }

                                if (isover && newnode)
                                    this.sceneobjectSelected = newnode;
                            }
                    }
                }

            }

            // this.updateSelectedObjectHelpe();
            console.log("this.sceneobjectSelected", this.sceneobjectSelected);
            this.handleObjectSelectionByRows(this.curSelectedRow);//TODO: nicht bei scene nclick und invisible
            this.updateSelectedObjectHelpe();
            this.higlightProject(); // Re-position helper after model updates

            this.updateThreeFrame();

            // Refresh interactive objects after model updates
            if (this.interactionManager) {
                this.interactionManager.refreshInteractiveObjects();
            }

            //  this.project.configmodel = await this.createConfigModel(); // muss nach rendering passieren, da sonst flackern!
            this.processing = false;
        } finally {
            this.processing = false;
            this.processingMessage = '';
        }
    }


    async copyFormulas(i: number, event: any) {
        console.log('copyFormulas', i);
        this.updateSheetOperationsDependencies();
        await this.sheetOperationsManager.copyFormulas(i, event);
    }
    async clearSheet(i: number, event: any) {
        console.log('clearSheet', i);
        this.updateSheetOperationsDependencies();
        const result = await this.sheetOperationsManager.clearSheet(i, event);
        this.dataset = result.dataset;
        this.cellformulas = result.cellformulas;
    }
    renameSheet(i: number, event: any) {
        console.log('renameSheet', i);
        this.updateSheetOperationsDependencies();
        this.sheetOperationsManager.renameSheet(i, event);
    }
    removeSheet(i: number, event: any) {
        console.log('removeSheet', i);
        this.updateSheetOperationsDependencies();
        this.sheetOperationsManager.removeSheet(i, event);
    }

    async addNewSheet() {
        console.log('addNewSheet');
        this.loadingOverlay = true;

        try {
            this.updateSheetOperationsDependencies();
            const result = await this.sheetOperationsManager.addNewSheet();
            this.setSheetIndex(null, result.sheetId);
            this.toastr.success('New sheet added successfully');
        } catch (error) {
            console.error('Error adding sheet:', error);
            this.toastr.error(error.message || 'Error adding sheet');
        } finally {
            this.loadingOverlay = false;
        }
    }

    additionalColumns = 5;
    additionalRows = 100;
    dlgresizetable = false;
    resizeTables() {
        this.loadingOverlay = true;
        this.dlgresizetable = false;
        this.updateSheetOperationsDependencies();
        this.sheetOperationsManager.resizeTables(this.additionalColumns, this.additionalRows);
    }


    @ViewChild('aiPromptEditor') aiPromptEditor: AiPromptEditorComponent;

    async handleAIITeration(iterationdata: any) {
        if (!this.customerid) {
            this.toastr.error('User ID not available. Cannot deduct credits.', 'Error');
            return;
        }
        const canProceed = await this.deductUserCredits(this.customerid);
        if (!canProceed) return;

        console.log('handleAIITeration', iterationdata);
        var data = iterationdata.data;
        var iteration = iterationdata.iteration;
        var sheetId = iterationdata.sheetId !== undefined ? iterationdata.sheetId : this.sheetid;

        // Pass the data with the correct sheetId to handleTableDataCopy
        await this.handleTableDataCopy({ data: data, run: null, sheetId: sheetId });

        // send screenshots to ai prompt editor
        //  this.aiPromptEditor.nextIteration();
    }

    async saveChatHistory(chatHistoryEvent: any) {
        // Guard against project being undefined initially
        if (!this.project) {
            console.warn("saveChatHistory called before project was loaded. Skipping.");
            return;
        }

        if (!this.project.chatHistory) {
            this.project.chatHistory = {};
        }

        // Extract the actual chat history array from the emitted event object
        const actualChatHistoryArray = chatHistoryEvent?.[this.sheetid];

        // Check if the extracted history is actually an array before proceeding
        if (!Array.isArray(actualChatHistoryArray)) {
            console.error('Received invalid chat history format. Expected an array for sheet ', this.sheetid, ' but got:', chatHistoryEvent);
            // this.toastr.error('Failed to save chat history due to invalid format.', 'Save Error');
            return; // Exit if the format is incorrect
        }

        // Save the extracted array directly for the current sheetid
        this.project.chatHistory[this.sheetid] = actualChatHistoryArray;

        // No need to call saveproject() here unless you specifically want to save the entire project
        // every time the chat history changes. This might be too frequent.
        // Consider saving less often or when the user explicitly saves the project.
        // await this.saveproject();
        this.updateLastSaveTime(); // Mark project as having unsaved changes
    }

    /// from ai prompt editor
    async handleTableDataCopy(event) {
        if (!this.customerid) {
            this.toastr.error('User ID not available. Cannot deduct credits.', 'Error');
            return;
        }
        // Check if this is a direct call or part of an iteration
        // If it's from a direct UI interaction that should cost credits, deduct here.
        // If it's called internally by handleAIITeration, credits are already deducted.
        // For now, assuming it might be called directly and costs credits.
        // TODO: Refine this logic if handleTableDataCopy is only called after handleAIITeration
        const isDirectAICall = !event.isInternalCall; // Add an isInternalCall flag if needed

        if (isDirectAICall) { // Assuming a direct call for now.
            const canProceed = await this.deductUserCredits(this.customerid);
            if (!canProceed) return;
        }

        var data = event.data;
        var thissheetid = this.sheetid;
        var sheetId = event.sheetId;
        console.log('Received table data:', data, thissheetid, sheetId);

        if (thissheetid != null)
            if (thissheetid != sheetId) {
                //      await this.excels[this.PROJECT].setCellContents({ sheet: run, row: i, col: 0 }, "");
                // Remove "OUTPUTID" from the first column if present in the target sheet
                // Get range v alues for the target sheet to find OUTPUTID
                const range = {
                    start: { row: 0, col: 0, sheet: sheetId },
                    end: { row: 100, col: 0, sheet: sheetId } // Check first 100 rows of first column
                };
                const values = await this.excels[this.PROJECT].getRangeValues(range);

                // Find row with OUTPUTID and clear it if found
                for (let i = 0; i < values.length; i++) {
                    if (values[i][0] === "OUTPUTID") {
                        await this.excels[this.PROJECT].setCellContents({ sheet: sheetId, row: i, col: 0 }, "");
                        break;
                    }
                }

                this.project.sheets[sheetId].state = " [done]";
                setTimeout(() => {
                    this.project.sheets[sheetId].state = null;
                    this.cdr.detectChanges(); // Ensure UI updates
                }, 15000);

                var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: sheetId, row: 0, col: 0 }, data);

                return;
            }

        // Remove "OUTPUTID" from the first column if present
        for (let i = 0; i < this.dataset.length; i++) {
            if (this.dataset[i][0] === "OUTPUTID") {
                this.dataset[i][0] = "";
                this.cellformulas[i][0] = "";
                await this.excels[this.PROJECT].setCellContents({ sheet: sheetId, row: i, col: 0 }, "");
                break; // Assuming "OUTPUTID" appears only once
            }
        }
        for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].length; j++) {
                this.dataset[i][j] = data[i][j];
                this.cellformulas[i][j] = data[i][j];
            }
        }
        // Update the dataset and cellformulas
        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < data[i].length; j++) {
                this.dataset[i][j] = data[i][j];
                this.cellformulas[i][j] = data[i][j];
            }
        }

        var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: sheetId, row: 0, col: 0 }, data);
        //    var cell = { row: row, col: 1, sheet: this.sheetid };
        //    this.sheetChange(cell, newsnippet.values, newsnippet.values, true);

        var cellranget = {
            start: { row: 0, col: 0, sheet: sheetId },
            end: { row: data.length - 1, col: data[0].length - 1, sheet: sheetId }
        };
        const updatedCellValues = await this.excels[this.PROJECT].getRangeValues(cellranget);
        for (let i = 0; i < updatedCellValues.length; i++) {
            for (let j = 0; j < updatedCellValues[i].length; j++) {
                this.dataset[i][j] = this.handleCellError(updatedCellValues[i][j]);
            }
        }

        this.applyCellMeta();

        // Re-create the JSON GUI
        //this.jsongui = await this.excels[this.PROJECT].createJsonGUI(sheetId);
        var newnodes = await this.recreateModel();
        //  var newnodes = await this.createModel(this.scene, this.dataset, this.PROJECT);
        ThreeUtils.zoomObject(this.camera, this.controls, newnodes);
        this.updateThreeFrame();
    }


    async updateControls(exportedchanges, srcchange) {
        var rowupdated = [];

        var uihaschanges = false;
        for (var j = 0; j < exportedchanges?.length; j++) {
            var change = exportedchanges[j];
            var a = change.address;
            var v = change.newValue;

            this.outputrow = SheetHelper.getOutputRow(this.dataset);

            if (!(srcchange.col == 2 && srcchange.row == a.row)) // src control nicht aendern, da fokuc springt (uind nicht nöötig)
                if (this.dataset[a.row][1] != null && this.dataset[a.row][1] != "" && a.row < this.outputrow) {
                    //
                    if (!this.isInList(rowupdated, { sheet: a.sheet, row: a.row })) {

                        rowupdated.push({ sheet: a.sheet, row: a.row });
                        var typ = this.dataset[a.row][1];
                        var objectname = this.dataset[a.row][0];

                        uihaschanges = true;
                        // remove all objects from three js scene
                        // var objects = this.scene.children;
                        // for (var i = 0; i < objects.length; i++) {
                        //   var object = objects[i];
                        //   if (object.name == objectname) {
                        //     this.scene.remove(object);
                        //   }
                        // }

                        globalThis.paths = [];
                        globalThis.editnodes = [];
                        var newjsongui = await traverse(this.jsongui).forEach(function (value) {
                            if (typeof (value) === "object" && value) {
                                if (value.controlName == objectname) {
                                    var paths = this.path;
                                    globalThis.paths.push(paths);
                                    globalThis.editnodes.push(value);
                                }

                            }
                        });

                        for (var i = 0; i < globalThis.paths.length; i++) {
                            var path = globalThis.paths[i];
                            var oldobj = globalThis.editnodes[i];

                            var parentnode = this.jsongui; // TODO
                            var result = await this.excels[this.PROJECT].createNodesFromRow({}, this.dataset, a.row, a.sheet, null, false, true);
                            var newnode = result.rootnode.childs[0];
                            console.log('createControlNode ', a, oldobj, path);
                            var n = JSON.parse(JSON.stringify(this.jsongui));
                            //  Utils.setValue2(this.jsongui, path, newnode);
                            //            this.diffpatchGUI(n);
                            uihaschanges = true;
                            //    uihaschanges          Utils.setValue2(this.jsongui, path, newnode);
                        }
                        //          var newnode = //(this.dataset[a.row], this.dataset[a.row - 1]);

                    }
                }

            // timer restart
            if (this.dataset[a.row][1] == "timer") {
                if (a.col == 6)
                    for (var x = 0; x < this.timers.length; x++) {
                        var timer = this.timers[x];
                        if (timer.name == this.dataset[a.row][0]) {
                            if (v == false) {
                                // clearInterval(this.intervals[x]);
                                this.clocks[x].stop();
                                break;
                            }
                            if (v == true) {
                                // var step = this.dataset[a.row][3];
                                // var clock = new THREE.Clock();
                                // this.clocks[x] = clock;
                                this.clocks[x].start();

                                // this.intervals[x] = setInterval(async () => {
                                //   var changes = await this.excels[this.PROJECT].setCellContents({ sheet: 0, row: this.timers[x].row, col: 4 }, 0);
                                //   //   this.timers[x].clock = new THREE.Clock();
                                //   this.timerfunction(this.timers[x], this.clocks[x]);
                                // }, step);


                                // = setInterval(this.timerfunction(null,null), step);
                                break;
                            }
                        }
                    }
            }
        }



        // temp hack
        this.outputrow = SheetHelper.getOutputRow(this.dataset);
        let changesBeforeOutputRow = false;
        for (var j = 0; j < exportedchanges?.length; j++) {
            var change = exportedchanges[j];
            var a = change.address;
            var v = change.newValue;
            if (a.row < this.outputrow && a.col != 2 && a.col != 3) {
                changesBeforeOutputRow = true;
                break;
            }
        }

        //    console.log('###Changes before output row:', changesBeforeOutputRow);

        if (changesBeforeOutputRow) {
            var jsongui = await this.excels[this.PROJECT].createJsonGUI(this.sheetid); //TODO: nur bei change erstellen

            //console.log("######jsongui", jsongui);
            // TODO: diffpatch staatt neu erstelen
            // this.jsongui = jsongui;

            this.diffpatchGUI(jsongui, this.jsongui);
        }


    }


    async handleDimensionsDialog(node, row, commentrow) {
        const dialogRef = this.dialog.open(DialogdimensionsComponent, {
            width: '550px',
            data: { node: node },
        });

        dialogRef.afterClosed().subscribe(async result => {
            console.log('The dialog was closed', result);

            if (result) {
                var factor = result.factor;
                var upaxis = result.upaxis;

                // this.cellformulas[this.selectedRange[0]][this.selectedRange[1]] = result;
                // this.cellformulas[cell.row][cell.col] = result;

                //(node as THREE.Object).scale.set(result, result, result);
                var n = SheetHelper.getParameterIndex(commentrow, 'sx') as any;
                var cell = { row: this.selectedRange[0] + 1, col: n, sheet: this.sheetid };
                await this.sheetChange(cell, factor, 1, false, false);
                var n = SheetHelper.getParameterIndex(commentrow, 'sy') as any;
                var cell = { row: this.selectedRange[0] + 1, col: n, sheet: this.sheetid };
                await this.sheetChange(cell, factor, 1, false, false);
                var n = SheetHelper.getParameterIndex(commentrow, 'sz') as any;
                var cell = { row: this.selectedRange[0] + 1, col: n, sheet: this.sheetid };
                await this.sheetChange(cell, factor, 1, false, false);

                if (upaxis == 'X') {
                    var n = SheetHelper.getParameterIndex(commentrow, 'ry') as any;
                    var cell = { row: this.selectedRange[0] + 1, col: n, sheet: this.sheetid };
                    await this.sheetChange(cell, "=PI()/2", 0);
                }
                if (upaxis == 'Y') {
                    var n = SheetHelper.getParameterIndex(commentrow, 'rx') as any;
                    var cell = { row: this.selectedRange[0] + 1, col: n, sheet: this.sheetid };
                    await this.sheetChange(cell, "=PI()/2", 0);
                }

            }
        });
    }

    addCamera() {
        if (!this.project.cameras) {
            this.project.cameras = [];
        }

        // Save complete camera state
        const cameraState = {
            matrix: this.camera.matrix.toArray(),
            position: this.camera.position.toArray(),
            quaternion: this.camera.quaternion.toArray(),
            zoom: this.camera.zoom,
            target: this.controls.target.toArray()
        };

        this.project.cameras.push(JSON.stringify(cameraState));
        //    this.saveproject(); // Save to persist the new camera
    }

    currentcamindex = 1;
    loadCamera(i: number) {
        this.currentcamindex = i + 1;
        const cameraState = JSON.parse(this.project.cameras[i]);

        // Restore complete camera state
        this.camera.matrix.fromArray(cameraState.matrix);
        this.camera.position.fromArray(cameraState.position);
        this.camera.quaternion.fromArray(cameraState.quaternion);
        this.camera.zoom = cameraState.zoom;
        this.controls.target.fromArray(cameraState.target);

        // Update camera matrices
        this.camera.matrix.decompose(this.camera.position, this.camera.quaternion, this.camera.scale);
        this.camera.updateProjectionMatrix();

        // Update controls
        this.controls.update();

        this.updateThreeFrame();
    }

    async copyImpersonated() {
        const user = await this.auth.currentUser;
        const userId = user?.uid;
        console.log('Current User ID:', userId);


        var p = JSON.parse(JSON.stringify(this.project));
        var pid = p.id;
        delete p.id;
        p.name = p.name + "_copy_";
        let currentDate = new Date();
        p.name += currentDate.getFullYear() + "-" +
            ("0" + (currentDate.getMonth() + 1)).slice(-2) + "-" +
            ("0" + currentDate.getDate()).slice(-2) + " " +
            ("0" + currentDate.getHours()).slice(-2) + "-" +
            ("0" + currentDate.getMinutes()).slice(-2);
        p.createtime = new Date().getTime();
        p.lastsave = p.createtime;
        var newdoc = await this.afs.collection("projects/userprojects/" + userId).add(p);
        var npid = newdoc.id;
        this.loadingOverlay = true;
        let attempt = 0;
        const maxAttempts = 7;
        const attemptInterval = 400; // milliseconds

        const cloneProject = async () => {
            try {
                const response = await this.http.post(this.SERVER + "/copySheets", { customerid: this.customerid, userId: userId, projectid: pid, newprojectid: npid, sheetscount: 5 }).toPromise();
                console.log('clone result', response);
                this.loadingOverlay = false;
                this.snackBar.open("Project duplicated. Go To Dashboard to load copy.", null, { duration: 3000 });
            } catch (error) {
                if (attempt < maxAttempts) {
                    setTimeout(() => {
                        attempt++;
                        cloneProject();
                    }, attemptInterval);
                } else {
                    console.error('Failed to clone project after ' + maxAttempts + ' attempts', error);
                    this.snackBar.open("Failed to duplicate project. Please try again.", null, { duration: 3000 });
                }
            }
        };
        cloneProject();

    }




    onRightClick($event, index) {
        console.log('onRightClick', $event);
        for (var i = 0; i < this.project.sheets.length; i++) {
            this.project.sheets[i].visible = false;
        }
        this.project.sheets[index].visible = true;
        return false;
    }
    async setSheetIndex(event, i) {
        console.log('setSheetIndex ', i, event);
        if (this.processing) {
            this.snackBar.open("Please wait for the current operation to complete.", null, { duration: 3000 });
            return;
        }

        try {
            this.sheetid = i;

            // Update dependencies and use the manager
            this.updateSheetOperationsDependencies();
            const result = await this.sheetOperationsManager.setSheetIndex(event, i);

            // Update local properties with results
            this.dataset = result.dataset;
            this.datasetids = result.datasetids;
            this.cellformulas = result.cellformulas;

            // Continue with the rest of the original logic
            ThreeUtils.clearScene(this.scene);

            const startTime = performance.now();
            this.jsongui = await this.excels[this.PROJECT].createJsonGUI(this.sheetid);
            const endTime = performance.now();
            console.log(`createJsonGUI took ${endTime - startTime} milliseconds`);

            const modelStartTime = performance.now();
            await this.createModel(this.scene, this.dataset, this.PROJECT);
            const modelEndTime = performance.now();
            console.log(`createModel took ${modelEndTime - modelStartTime} milliseconds`);

            this.selectedprojectpath = "root^$" + this.sheetid;
            this.excels[this.PROJECT].setCurrentSheetId(this.sheetid);
            this.updateThreeFrame();

            // Use manager for cell metadata
            await this.sheetOperationsManager.applyCellMeta();
            this.hot.render();

            // Clear search results when changing sheets
            this.searchManager?.clearSearch();
        } catch (error) {
            console.error('Error switching sheet:', error);
            this.toastr.error('Error switching sheet: ' + error.message);
        }
    }
    selectedObject = null;
    selectedObjectHelper: any;// THREE.BoxHelper;
    selectedWidget = null;

    updateSelectedObjectHelpe() {
        if (this.project.sceneSettings.showHelpers && this.isEditMode) {

            if (this.selectedObjectHelper)
                this.scene.remove(this.selectedObjectHelper);

            // Remove existing menu sprite if it exists
            if (this.selectedObjectMenuSprite) {
                this.scene.remove(this.selectedObjectMenuSprite);
                this.selectedObjectMenuSprite = null;
            }

            // Hide object menu
            this.objectMenuVisible = false;

            if (this.selectedObject) {
                this.selectedObject.updateMatrix();
                this.selectedObject.updateMatrixWorld();

                //   this.selectedObjectHelper = new THREE.BoxHelper(this.selectedObject, 0xff44ff);
                // var bb = ThreeUtils.getBoundingBox(this.selectedObject);
                // var box = new THREE.Box3(bb.min, bb.max); // create a bounding box from min and max
                var bb = ThreeUtils.getBBox(this.selectedObject);
                var box = new THREE.Box3(bb.min, bb.max);
                const boxGeometry2 = new THREE.BoxGeometry(
                    box.max.x - box.min.x,
                    box.max.y - box.min.y,
                    box.max.z - box.min.z
                );
                const center = new THREE.Vector3();
                bb.getCenter(center);

                const edgesGeometry2 = new THREE.EdgesGeometry(boxGeometry2);
                const lineGeometry2 = new LineSegmentsGeometry().fromEdgesGeometry(edgesGeometry2);
                const lineMaterial = new LineMaterial({
                    color: 0xff00ff,  // Choose the color as needed
                    linewidth: 4,  // Adjust the line width for visibility
                    resolution: new THREE.Vector2(window.innerWidth, window.innerHeight),  // Necessary for LineMaterial
                    transparent: true,
                    opacity: 0.5  // Set 0.5 opacity for bounding box edges
                });
                const wireframe2 = new Wireframe(lineGeometry2, lineMaterial);
                wireframe2.position.copy(center);
                //  wireframe2.position.add(this.selectedObject.position);
                wireframe2.scale.set(1.1, 1.1, 1.1);
                wireframe2.computeLineDistances();

                this.scene.add(wireframe2);
                this.selectedObjectHelper = wireframe2;

                // Note: Object menu is already shown via showObjectMenu() above

                if (this.selectedObject.material) {
                    //  this.selectedObject.material.transparent = true;
                    // this.selectedObject.material.opacity = 0.7;
                }

                this.scene.add(this.selectedObjectHelper);
            }

            if (this.isEditMode) {
                this.cad.showFaceCenters(this.selectedObject, this.scene);
            }

        }


    }

    public lastClickEvent: any = null; // Store the last click event





    lastSelectedRow: number = -1;
    async handleObjectSelectionByRows(row1) {
        if (!row1) return;

        // Skip if the same row is already selected
        if (this.lastSelectedRow === row1) return;

        this.lastSelectedRow = row1;

        if (this.project.sceneSettings.showHelpers && this.isEditMode) {

            // row selection
            if (this.selectedObjectHelper)
                this.scene.remove(this.selectedObjectHelper);
            if (this.selectedObject?.material) {
                //  this.selectedObject.material.transparent = false;
                //  this.selectedObject.material.opacity = 1.0;
            }

            // Hide object menu
            this.objectMenuVisible = false;

            this.selectedObject = null;
            if (this.dataset[row1] && row1 > SheetHelper.getOutputRow(this.dataset))
                if (this.dataset[row1][0] && (this.isInList(this.autocompleteListPrimitives, this.dataset[row1][1]) || this.dataset[row1][1]?.startsWith('project'))) {
                    // 3d object selected
                    var objectname = "root^$" + this.sheetid + "#" + this.dataset[row1][0];
                    var object = this.scene.getObjectByName(objectname, true);

                    if (object) {
                        var bb = ThreeUtils.getBBox(object);
                        var box = new THREE.Box3(bb.min, bb.max);
                        const boxGeometry2 = new THREE.BoxGeometry(
                            box.max.x - box.min.x,
                            box.max.y - box.min.y,
                            box.max.z - box.min.z
                        );
                        const center = new THREE.Vector3();
                        bb.getCenter(center);

                        const edgesGeometry2 = new THREE.EdgesGeometry(boxGeometry2);
                        const lineGeometry2 = new LineSegmentsGeometry().fromEdgesGeometry(edgesGeometry2);
                        const lineMaterial = new LineMaterial({
                            color: 0xff00ff,  // Choose the color as needed
                            linewidth: 4,  // Adjust the line width for visibility
                            resolution: new THREE.Vector2(window.innerWidth, window.innerHeight),  // Necessary for LineMaterial
                            transparent: true,
                            opacity: 0.3,  // Set 0.5 opacity for bounding box edges
                            dashed: true,  // Enable dashed lines
                            dashSize: 5,   // Length of dash
                            gapSize: 5     // Length of gap between dashes
                        });
                        const wireframe2 = new Wireframe(lineGeometry2, lineMaterial);
                        wireframe2.position.copy(center);
                        wireframe2.scale.set(1.1, 1.1, 1.1);
                        wireframe2.computeLineDistances();
                        this.scene.add(wireframe2);
                        this.selectedObjectHelper = wireframe2;
                        this.selectedObject = object;
                    }
                }

            console.log("[EditorComponent] Selected object for face centers: Name:", this.selectedObject?.name, "Type:", this.selectedObject?.userData?.typ, "isRing:", this.selectedObject?.geometry?.userData?.isRing, "FaceCenters Data:", this.selectedObject?.userData?.faceCenters);
            await traverse(this.jsongui).forEach(function (value) {
                if (typeof (value) === "object" && value) {
                    value.selected = false;
                }
            });
            try {
                if (this.dataset && this.dataset[row1] && this.dataset[row1][0] && this.dataset[row1][1] && this.autocompleteListControls && this.isInList(this.autocompleteListControls, this.dataset[row1][1])) {
                    globalThis.dataset = this.dataset;
                    await traverse(this.jsongui).forEach(function (value) {
                        if (typeof (value) === "object" && value) {
                            if (value.controlName == globalThis.dataset[row1][0]) {
                                value.selected = true;
                            }
                        }
                    });
                }
            } catch (error) {
                console.warn('Error processing selection', error);
            }

            if (this.isEditMode) {
                this.cad.showFaceCenters(this.selectedObject, this.scene);
            }
            this.updateThreeFrame();
        }
    }

    state = {
        h: 150,
        s: 0.50,
        l: 0.20,
        a: 1,
    };
    mnucolorvisible = false;
    mnucolorvisible2 = false;
    primaryColor = "#ff0000";

    changeComplete($event: ColorEvent): void {
        this.state = $event.color.hsl;
        this.primaryColor = $event.color.hex;
        console.log('changeComplete', $event);
    }
    formula: string;
    curSelectedRow: number;
    curSelectedCol: number;
    outputrow: number;
    celltooltip: any = null;
    celltoolstop: string;
    celltoolsleft: string;
    celltoolsvisible = false;

    private isSelectingCell = false;
    private lastSelectionArgs: any = null;
    private selectionDebounceTimeout: any = null;

    cellSelected = async (row1, col1, row2, col2) => {
        // Store the latest selection arguments
        this.lastSelectionArgs = { row1, col1, row2, col2 };

        // Clear any pending debounce timeout
        if (this.selectionDebounceTimeout) {
            clearTimeout(this.selectionDebounceTimeout);
        }

        // Set a new debounce timeout
        this.selectionDebounceTimeout = setTimeout(async () => {
            // If already processing a selection, just return - the last selection will be processed when current one finishes
            if (this.isSelectingCell) {
                return;
            }

            try {
                this.isSelectingCell = true;
                const args = this.lastSelectionArgs;

                this.curSelectedRow = args.row1;
                this.curSelectedCol = args.col1;
                console.log("cell selected", args.row1, args.col1, args.row2, args.col2, this.formula);

                var from = await this.excels[this.PROJECT].simpleCellAddressToString({ sheet: this.sheetid, row: args.row1, col: args.col1 }, this.sheetid);
                var to = await this.excels[this.PROJECT].simpleCellAddressToString({ sheet: this.sheetid, row: args.row2, col: args.col2 }, this.sheetid);
                this.curSelectionReadable = "" + from + " : " + to;
                this.formula = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: args.row1, col: args.col1 });

                var commentrowindex = await this.excels[this.PROJECT].getCommentRowIndex({ sheet: this.sheetid, row: args.row1, col: args.col1 });
                if (commentrowindex == -1) commentrowindex - args.row1 - 1;
                var above = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: commentrowindex, col: args.col1 });

                this.outputrow = SheetHelper.getOutputRow(this.dataset);

                this.handleObjectSelectionByRows(this.curSelectedRow);
                //  this.updateThreeFrame();

                // Handle cell tools and UI elements
                var cellid = "";
                let element = this.hot?.getCell(args.row1, args.col1);
                this.showSheetsmenu = false;
                this.showOverlaymenu = false;
                this.showOverlaymenu1 = false;
                this.showothermenu = false;

                // tooltip
                if (args.col1 < 2) {
                    if (element) {
                        var clientRect = element.getBoundingClientRect();
                        const position = this.adjustCellMenuPosition(clientRect.left, clientRect.top);
                        this.cellactionleft = position.left;
                        this.cellactiontop = position.top;

                        // Set flag to prevent immediate closing
                        this.justOpenedContextMenu = true;
                        setTimeout(() => {
                            this.justOpenedContextMenu = false;
                        }, 200); // Increased to 200ms

                        this.cellactionvisible = true;
                        this.cellactionmenuvisible = false;
                        this.cellinfovisible = false;
                    }
                } else {
                    // Don't hide the cell action menu if it's already expanded/visible
                    // This prevents the menu from closing when clicking on different cells
                    if (!this.cellactionmenuvisible && !this.justOpenedContextMenu) {
                        this.cellactionvisible = false;
                    }
                }

                // cell info
                if (args.col1 >= 2) {
                    if (element) {
                        var clientRect = element.getBoundingClientRect();
                        var clientX = clientRect.left;
                        var clientY = clientRect.top;
                        this.cellinfoleft = clientX + 'px';
                        this.cellinfotop = clientY - 50 + 'px';

                        if (this.dataset?.[args.row1]?.[0] === "#") {
                            var newsnippet = null;
                            var typ = this.dataset[args.row1][1];
                            for (var i = 0; i < this.snippetManager.snippets.length; i++) {
                                var snippet = this.snippetManager.snippets[i];
                                if (snippet.name == typ) {
                                    newsnippet = this.snippetManager.snippets[i];
                                    break;
                                }
                            }

                            this.celltooltip = newsnippet?.infos;
                            this.cellinfovisible = true;
                            this.celltooltipleft = this.cellinfoleft;
                            this.celltooltiptop = (this.hot.rootElement.clientHeight - clientY + 206) + "px";
                        } else {
                            this.cellinfovisible = false;
                        }
                        this.cellinfomenuvisible = false;
                    }
                }

                // cell tools
                if (above == "material" || above == "baseplane" || above == "filename") {
                    var clientRect = element.getBoundingClientRect();
                    var clientX = clientRect.left;
                    var clientY = clientRect.top;
                    this.celltoolsleft = clientX + 'px';
                    this.celltoolstop = clientY + 30 + 'px';
                    this.celltoolsvisible = true;
                } else {
                    // Check if this is a cube row - look at the type column (col 1) of the current row to see if it contains "cube"
                    var cubeTypeCell = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: args.row1, col: 1 });
                    console.log('DEBUG: Checking cube type cell:', cubeTypeCell, 'at row:', args.row1, 'element exists:', !!element);
                    console.log('DEBUG: Cell value type:', typeof cubeTypeCell, 'exact value:', JSON.stringify(cubeTypeCell));
                    if (cubeTypeCell == "cube" && element) {
                        console.log('DEBUG: Found cube row, showing cell tools');
                        var clientRect = element.getBoundingClientRect();
                        var clientX = clientRect.left;
                        var clientY = clientRect.top;
                        this.celltoolsleft = clientX + 'px';
                        this.celltoolstop = clientY + 30 + 'px';
                        this.celltoolsvisible = true;
                        console.log('DEBUG: Set celltoolsvisible to true, position:', this.celltoolsleft, this.celltoolstop);
                    } else if (cubeTypeCell == "radio" && element) {
                        console.log('DEBUG: Found radio row, showing cell tools');
                        var clientRect = element.getBoundingClientRect();
                        var clientX = clientRect.left;
                        var clientY = clientRect.top;
                        this.celltoolsleft = clientX + 'px';
                        this.celltoolstop = clientY + 30 + 'px';
                        this.celltoolsvisible = true;
                        console.log('DEBUG: Set celltoolsvisible to true for radio row, position:', this.celltoolsleft, this.celltoolstop);
                    } else {
                        // Check for select input parameter cells in input rows (header at row 0)
                        // Look for cells with semicolon-separated options (like "entry1;entry2;entry3")
                        var currentCellValue = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: args.row1, col: args.col1 });
                        var headerAtRow0 = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: 0, col: args.col1 });

                        // Check if this cell contains semicolon-separated options OR has select input metadata
                        const hasSemicolonOptions = currentCellValue && typeof currentCellValue === 'string' &&
                            currentCellValue.includes(';') && currentCellValue.split(';').length > 1;

                        const cellMeta = this.hot?.getCellMeta(args.row1, args.col1);
                        const hasSelectMetadata = cellMeta?.type === "autocomplete" || cellMeta?.editor === "select" ||
                            (cellMeta?.source && Array.isArray(cellMeta.source) && cellMeta.source.length > 0);

                        // Show tooltip if header exists AND (has semicolon options OR select metadata)
                        if (headerAtRow0 && typeof headerAtRow0 === 'string' && headerAtRow0.length > 0 &&
                            (hasSemicolonOptions || hasSelectMetadata) && element) {
                            console.log('DEBUG: Found select input cell - header:', headerAtRow0, 'value:', currentCellValue, 'hasOptions:', hasSemicolonOptions, 'hasMetadata:', hasSelectMetadata);
                            var clientRect = element.getBoundingClientRect();
                            var clientX = clientRect.left;
                            var clientY = clientRect.top;
                            this.celltoolsleft = clientX + 'px';
                            this.celltoolstop = clientY + 30 + 'px';
                            this.celltoolsvisible = true;
                            console.log('DEBUG: Set celltoolsvisible to true for select input parameter, position:', this.celltoolsleft, this.celltoolstop);
                        } else {
                            this.celltoolsvisible = false;
                            console.log('DEBUG: Not a select input cell, hiding cell tools');
                        }
                    }
                }

                try {
                    var meta = this.hot.getCellMeta(args.row1, args.col1).stylemeta;
                    if (meta) {
                        this.color1 = meta.background;
                        this.color2 = meta.foreground;
                    }
                } catch (error) {
                }

                // get dependents
                var dependents = await this.excels[this.PROJECT].getCellDependents({ sheet: this.sheetid, row: args.row1, col: args.col1 });
                console.log('dependents', dependents);
                this.refnames2 = [];
                for (var j = 0; j < dependents?.length; j++) {
                    var dependent = dependents[j];

                    var commentrowindex = await this.excels[this.PROJECT].getCommentRowIndex(dependent);
                    if (commentrowindex == -1) commentrowindex = dependent.row - 1;
                    var above = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: commentrowindex, col: dependent.col });
                    dependent.col = 0;

                    var dependentCellValue = await this.excels[this.PROJECT].getCellValue(dependent);


                    if (!this.refnames2.includes(dependent.toString() + ": " + dependentCellValue)) {
                        this.refnames2.push(dependentCellValue + ': ' + above);
                    }


                }

                this.formulaChange(this.formula);

            }
            catch (error) {
                console.warn('Error processing cell selection', error);
            }
            finally {
                this.isSelectingCell = false;
            }
        }, 20); // 100ms debounce delay
    }

    isCubeRow(): boolean {
        try {
            // Synchronously check if current row is a cube row
            if (this.dataset && this.curSelectedRow >= 0 && this.dataset[this.curSelectedRow]) {
                const isCube = this.dataset[this.curSelectedRow][1] === "cube";
                return isCube;
            }
        } catch (error) {
            //            console.warn('Error checking if cube row:', error);
        }
        return false;
    }

    isSelectInputCell(): boolean {
        try {
            // Check if current cell is a parameter cell with select input type
            if (this.dataset && this.curSelectedRow >= 0 && this.curSelectedCol >= 0 && this.dataset[this.curSelectedRow]) {
                // Get the hot table cell metadata
                const cellMeta = this.hot?.getCellMeta(this.curSelectedRow, this.curSelectedCol);

                console.log('DEBUG isSelectInputCell: row=', this.curSelectedRow, 'col=', this.curSelectedCol, 'cellMeta=', cellMeta);

                // Check if cell has select/dropdown autocomplete type
                if (cellMeta?.type === "autocomplete" || cellMeta?.editor === "select") {
                    console.log('DEBUG: Found autocomplete/select cell');
                    return true;
                }

                // Also check if the cell has a source array (typical for select inputs)
                if (cellMeta?.source && Array.isArray(cellMeta.source) && cellMeta.source.length > 0) {
                    console.log('DEBUG: Found cell with source array');
                    return true;
                }
            }
        } catch (error) {
            console.warn('Error checking if select input cell:', error);
        }
        console.log('DEBUG: isSelectInputCell returning false');
        return false;
    }

    isImageParameter(cellValue: string): boolean {
        try {
            if (!cellValue || typeof cellValue !== 'string') return false;

            // Check if the cell contains semicolon-separated values that look like image filenames
            const values = cellValue.split(';');
            return values.some(value => {
                const trimmedValue = value.trim().toLowerCase();
                return trimmedValue.endsWith('.png') ||
                    trimmedValue.endsWith('.jpg') ||
                    trimmedValue.endsWith('.jpeg') ||
                    trimmedValue.endsWith('.svg') ||
                    trimmedValue.endsWith('.gif') ||
                    trimmedValue.endsWith('.webp');
            });
        } catch (error) {
            console.warn('Error checking if image parameter:', error);
            return false;
        }
    }

    isInputRowSelectCell(): boolean {
        try {
            // SIMPLE TEST: Check if we're in a select row
            if (this.dataset && this.curSelectedRow >= 0 && this.curSelectedCol >= 0) {
                const rowTypeCell = this.dataset[this.curSelectedRow] && this.dataset[this.curSelectedRow][1];
                const isSelectRow = rowTypeCell === "select";
                return isSelectRow;
            }
        } catch (error) {
            console.warn('Error checking input row select cell:', error);
        }
        return false;
    }

    isOutputRowSelectCell(): boolean {
        try {
            // Check if we're in an output row with select input type
            if (this.dataset && this.curSelectedRow >= 0 && this.curSelectedCol >= 0) {
                // For output rows, we look for comment row above with headers
                const cellMeta = this.hot?.getCellMeta(this.curSelectedRow, this.curSelectedCol);
                const isSelectInput = cellMeta?.type === "autocomplete" ||
                    cellMeta?.editor === "select" ||
                    (cellMeta?.source && Array.isArray(cellMeta.source) && cellMeta.source.length > 0);

                // Check if this is NOT an input row
                const isNotInputRow = this.curSelectedRow < 1 || this.curSelectedRow > 9;

                return isSelectInput && isNotInputRow;
            }
        } catch (error) {
            console.warn('Error checking output row select cell:', error);
        }
        return false;
    }

    async showMultiImageSelectDialog() {

        // Get the current cell value to pre-populate the dialog
        let existingValue = '';
        try {
            existingValue = await this.excels[this.PROJECT].getCellSerialized({
                sheet: this.sheetid,
                row: this.curSelectedRow,
                col: this.curSelectedCol
            }) || '';
        } catch (error) {
            console.log('Could not get current cell value:', error);
        }

        const dialogRef = this.dialog.open(MultiImageSelectDialogComponent, {
            width: '1400px',
            height: '900px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            data: {
                existingValue: existingValue
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && typeof result === 'string') {
                // Insert the result into the current cell
                this.insertValueIntoCurrentCell(result);
            }
        });
    }

    private async insertValueIntoCurrentCell(value: string) {
        try {
            if (this.hot && this.curSelectedRow >= 0 && this.curSelectedCol >= 0) {
                // Set the value in the cell
                this.hot.setDataAtCell(this.curSelectedRow, this.curSelectedCol, value);

                // Also update the formula input
                this.formula = value;

                // Trigger change detection
                await this.sheetChange({ row: this.curSelectedRow, col: this.curSelectedCol }, value, null);

                console.log('Inserted multi-image selection:', value, 'at row:', this.curSelectedRow, 'col:', this.curSelectedCol);
            }
        } catch (error) {
            console.error('Error inserting value into cell:', error);
        }
    }

    private isShowingCubeDialog = false;

    async showcelltools() {

        // selected cell is material? .... TODO: auch fr obere zellen (suchen nach headline)
        var commentrowindex = await this.excels[this.PROJECT].getCommentRowIndex({ sheet: this.sheetid, row: this.curSelectedRow, col: this.curSelectedCol });
        if (commentrowindex == -1) commentrowindex - this.curSelectedRow - 1;

        var above = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: commentrowindex, col: this.curSelectedCol });
        var selected = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: this.curSelectedRow, col: this.curSelectedCol });



        // Check if this is a cube row - look at the type column (col 1) of the current row to see if it contains "cube"
        var cubeTypeCell = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: this.curSelectedRow, col: 1 });
        var isCubeRow = cubeTypeCell == "cube";

        if (above == "material") {
            // For material cells in cube rows, show cube-to-extrusion dialog as it's more important
            if (isCubeRow) {
                this.isShowingCubeDialog = true;
                this.showCubeToExtrusionDialog();
                return; // Exit early to prevent any other dialogs
            } else {
                // Show regular material dialog for non-cube rows
                this.showmaterialsDialog(this.baseScene, selected);
                return; // Exit early to prevent cube dialog
            }
        }
        if (above == "baseplane") {
            this.showshapeDialog();
            return;
        }
        if (above == "filename") {
            // todo: rowtype statt dateiendung prüfen
            var cell = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: this.curSelectedRow, col: this.curSelectedCol });
            var filter = "";
            if (cell?.split('?')[0].toLowerCase().endsWith('.glb') ||
                cell?.split('?')[0].toLowerCase().endsWith('.gltf'))
                filter = "gltf";
            if (cell?.split('?')[0].toLowerCase().endsWith('.png') ||
                cell?.split('?')[0].toLowerCase().endsWith('.jpg') ||
                cell?.split('?')[0].toLowerCase().endsWith('.jpeg') ||
                cell?.split('?')[0].toLowerCase().endsWith('.svg'))
                filter = "png";

            this.showfilesDialog(filter, true);
            return;
        }

        // SIMPLE TEST: Check if we're in a row with "select" or "radio" in column 1 (type column)
        var rowType = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: this.curSelectedRow, col: 1 });

        if (rowType === "select") {
            this.showMultiImageSelectDialog();
            return;
        }

        if (rowType === "radio") {
            this.showMultiImageSelectDialog();
            return;
        }

        // Check if this is an input row select parameter cell
        if (this.isInputRowSelectCell()) {
            // Show multi-image dialog for input row select cells
            this.showMultiImageSelectDialog();
            return;
        }

        // Check if this is an output row select cell
        if (this.isOutputRowSelectCell()) {
            // For now, no specific action for output row select cells
            // You can add specific logic here later
            return;
        }

        // For non-material cells in cube rows, show cube-to-extrusion dialog
        if (isCubeRow) {
            this.isShowingCubeDialog = true;
            this.showCubeToExtrusionDialog();
        }
    }

    async showCubeToExtrusionDialog() {
        // Show confirmation dialog for cube to extrusion conversion
        const dialogRef = this.dialog.open(YesnodialogComponent, {
            width: '400px',
            data: {
                text: 'Convert this cube to an extrusion? This will allow you to modify the base shape while keeping the current dimensions and material.'
            }
        });

        dialogRef.afterClosed().subscribe(async result => {
            // Reset the flag when dialog closes regardless of result
            this.isShowingCubeDialog = false;

            if (result === 'yes') {
                // Get cube data from current row
                const row = this.curSelectedRow;
                const cubeData = {
                    name: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 0 }),
                    width: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 2 }),
                    length: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 3 }),
                    height: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 4 }),
                    material: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 5 }),
                    x: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 6 }),
                    y: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 7 }),
                    z: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 8 }),
                    rx: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 9 }),
                    ry: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 10 }),
                    rz: await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: 11 })
                };
                await this.convertCubeToExtrusion(row, cubeData);
            }
        });
    }

    async convertCubeToExtrusion(row: number, cubeData: any) {
        try {
            // Convert cube dimensions to baseplane coordinates
            // Create a rectangular baseplane from width and length
            const baseplane = `(${-cubeData.width / 2},${-cubeData.length / 2});(${cubeData.width / 2},${-cubeData.length / 2});(${cubeData.width / 2},${cubeData.length / 2});(${-cubeData.width / 2},${cubeData.length / 2})`;

            // Create extrusion vector using the height as Z component
            const extrusionvector = `(0,0,${cubeData.height})`;

            // Create extrusion row data based on extrusion snippet structure
            const extrusionData = [
                ["#", "type", "baseplane", "extrusionvector", "material", "bevelwidth", "bevelsegments", "x", "y", "z", "rx", "ry", "rz"],
                [cubeData.name, "extrusion", baseplane, extrusionvector, cubeData.material || "#445566", 0, 1, cubeData.x || 0, cubeData.y || 0, cubeData.z - cubeData.height / 2, cubeData.rx || 0, cubeData.ry || 0, cubeData.rz || 0]
            ];

            // Trigger model update
            const cell = { row: row - 1, col: 0, sheet: this.sheetid };
            await this.sheetChange(cell, extrusionData, null, true);
            this.applyCellMeta();
            if (this.isEditMode) {
                this.hot.render();
            }

            // Select the baseplane cell to show the shape dialog
            this.hot.selectCell(row, 1);
        } catch (error) {
            console.error('Error converting cube to extrusion:', error);
            this.toastr.error('Error converting cube to extrusion');
        }
    }

    async cellinput(event) {
        console.log("You entered: ", event.target.value);
        var cell = { row: this.selectedRange[0], col: this.selectedRange[1], sheet: this.sheetid };

        this.cellformulas[this.selectedRange[0]][this.selectedRange[1]] = event.target.value;

        var val = event.target.value;



        var v = null;
        var f = parseFloat(val);
        if (isNaN(f))
            v = val
        else
            v = f;

        // angezeigte Daten aktualisieren
        this.cellformulas[cell.row][cell.col] = v;


        this.sheetChange(cell, v, v);
    }

    /// HANDONSTABLE
    cellinfovisible = false;
    afterOnCellMouseOver = async (event, coords, TD) => {

    }
    afterOnCellMouseOut = async (event, coords, TD) => {
        //  console.log("afterOnCellMouseOut", event, coords, TD);
    }

    copiedformulas: string;
    cutcopyRange: any;
    afterCopy = async (data) => {
        var sr = this.selectedRange[0];
        var er = this.selectedRange[2];
        if (this.selectedRange[2] < this.selectedRange[0]) {
            sr = this.selectedRange[2];
            er = this.selectedRange[0];
        }
        var sc = this.selectedRange[1];
        var ec = this.selectedRange[3];
        if (this.selectedRange[3] < this.selectedRange[1]) {
            sc = this.selectedRange[3];
            ec = this.selectedRange[1];
        }


        // Ensure start/end values are non-negative
        sr = Math.max(0, sr);
        er = Math.max(0, er);
        sc = Math.max(0, sc);
        ec = Math.max(0, ec);

        var cellrange = {
            start: { row: sr, col: sc, sheet: this.sheetid },
            end: { row: er, col: ec, sheet: this.sheetid }
        };
        // var cellrange = {
        //   start: { row: this.selectedRange[0], col: this.selectedRange[1], sheet: this.sheetid },
        //   end: { row: this.selectedRange[2], col: this.selectedRange[3], sheet: this.sheetid }
        // };
        this.cutcopyRange = cellrange;
        var copyresult = await this.excels[this.PROJECT].copy(cellrange);
        this.keydown = null;
        return true;

    }
    isCutting = false;
    cutvalues: any;
    beforeCut = (dat, coords) => {
        console.log("beforecut", dat, coords);
        this.isCutting = true;
        return true;
    }
    afterCut = async (data, coords) => {
        console.log("aftercut", data, coords);

        // Ensure selected range values are non-negative
        this.selectedRange[0] = Math.max(0, this.selectedRange[0]);
        this.selectedRange[1] = Math.max(0, this.selectedRange[1]);
        this.selectedRange[2] = Math.max(0, this.selectedRange[2]);
        this.selectedRange[3] = Math.max(0, this.selectedRange[3]);
        var cellrange = {
            start: { row: this.selectedRange[0], col: this.selectedRange[1], sheet: this.sheetid },
            end: { row: this.selectedRange[2], col: this.selectedRange[3], sheet: this.sheetid }
        };
        this.keydown = null;
        this.cutcopyRange = cellrange;
        // TODO: sonderfaelle

        // copy 2d array from cellformulas to cutvalues
        const startRow = this.selectedRange[0];
        const endRow = this.selectedRange[2];
        const startCol = this.selectedRange[1];
        const endCol = this.selectedRange[3];
        this.cutvalues = [];

        //var test = this.cellformulas[this.selectedRange[0]][this.selectedRange[1]];
        //this.cutvalues = JSON.parse(JSON.stringify(await this.excels[this.PROJECT].getRangeSerialized(cellrange)));
        console.log('afterCut cutvalues', this.cutvalues);
        var cutresult = await this.excels[this.PROJECT].cut(cellrange);

        //  var test = await this.excels[this.PROJECT].paste({ row: 10, col: 2, sheet: this.sheetid });


        var cellranget = {
            start: { row: 10, col: 2, sheet: this.sheetid },
            end: { row: 15, col: 5, sheet: this.sheetid }
        };
        var vals = await this.excels[this.PROJECT].getRangeSerialized(cellranget);
        console.log('vals', vals);

        this.isPasting = true;
        this.isCutting = true;
        return true;
    }

    pastedresult = null;
    isPasting = false;
    beforePaste = (dat, coords) => {
        console.log("beforePaste", this.isCutting, dat, coords, this.cutvalues);
        this.isPasting = true;

        return true;
    }
    afterPaste = async (data, coords) => {

        console.log("afterPaste", data, coords, this.cutvalues);
        this.keydown = null;
        // todo: olddata
        var olddata = null;
        var topleft = { row: this.selectedRange[0], col: this.selectedRange[1], sheet: this.sheetid };

        try {
            if (this.isCutting && false) {
                pasteresult = await this.excels[this.PROJECT].paste(topleft); // nach cut seltsamerweise "nothing to paste"
                //        this.dataset[pasteresult.address.row][pasteresult.address.col] = name;
                this.isCutting = false;
                this.isPasting = false;
                navigator.clipboard.writeText('').then(function () { // TTODO: ggf "null" workaround, so das keine leeren zellen gepastet werden können
                }, function (err) {
                });
                this.cutvalues = null;
                //  console.log('pasteresult', pasteresult, formulas);
                return;
            }
            // fehler=
            var pasteresult = null; //
            // try {
            pasteresult = await this.excels[this.PROJECT].paste(topleft); // nach cut seltsamerweise leer

            //} catch (err1) {

            //      }


            console.log('pasteresult', pasteresult);
            this.pastedresult = [];
            for (var i = 0; i < pasteresult?.length; i++) {
                var s2 = await this.excels[this.PROJECT].getCellSerialized(pasteresult[i].address);

                // replace name in first col -------------------
                if (pasteresult[i][0] && pasteresult[i][1]) {
                    pasteresult[i][0] = pasteresult[i][1] + (topleft.row + i);

                }
                this.dataset[pasteresult[i].address.row][pasteresult[i].address.col] = pasteresult[i].newValue;
                this.cellformulas[pasteresult[i].address.row][pasteresult[i].address.col] = s2;
                this.dataset[pasteresult[i].address.row][pasteresult[i].address.col] = pasteresult[i].newValue;
                if (pasteresult[i].address.col == 0 && pasteresult[i].newValue != '#') {
                    var t = await this.excels[this.PROJECT].getCellSerialized({ sheet: pasteresult[i].address.sheet, row: pasteresult[i].address.row, col: 1 })
                    var t = Utils.remove_numbers_at_the_end(pasteresult[i].newValue);
                    if (t && t != 'OUTPUTID' && t != 'INPUTID') {
                        var name = t + (pasteresult[i].address.row + 1);
                        this.excels[this.PROJECT].setCellContents({ sheet: pasteresult[i].address.sheet, row: pasteresult[i].address.row, col: 0 }, name);
                        this.cellformulas[pasteresult[i].address.row][pasteresult[i].address.col] = name;
                        this.dataset[pasteresult[i].address.row][pasteresult[i].address.col] = name;
                    }

                }
                // ---------

                //        this.dataset[this.pastedresult.address.row][this.pastedresult.address.col] = await this.excels[this.PROJECT].getValueFromCell(this.pastedresult.address);

                console.log('cellformulas set', s2)

            }

            this.applyCellMeta();
            this.jsongui = await this.excels[this.PROJECT].createJsonGUI(this.sheetid);
            await this.updateModel(pasteresult, olddata, this.scene);
            if (this.isEditMode)
                this.hot.render();

        }
        catch (e) {
            console.warn(e);
            console.log('external copy?! ');
            try {

                // externe kopie => cell updates
                for (var i = parseInt(this.selectedRange[0]); i <= parseInt(this.selectedRange[2]); i++) {
                    for (var j = parseInt(this.selectedRange[1]); j <= parseInt(this.selectedRange[3]); j++) {
                        var di = i - parseInt(this.selectedRange[0]);
                        var dj = j - parseInt(this.selectedRange[1]);
                        if (data[di][dj] != null) {
                            //   this.cellformulas[i][j] = data[di][dj]; // TODO: formeln copy format von excel?
                            var exportedchagnes = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: i, col: j }, data[di][dj]);

                            for (var k = 0; k < exportedchagnes.length; k++) {
                                var s2 = await this.excels[this.PROJECT].getCellSerialized(exportedchagnes[k].address);
                                this.cellformulas[exportedchagnes[k].address.row][exportedchagnes[k].address.col] = s2;
                                this.dataset[exportedchagnes[k].address.row][exportedchagnes[k].address.col] = exportedchagnes[k].newValue;
                            }
                            //this.dataset[i][j] = data[di][dj];
                        }

                    }
                }
            } catch (err) {
                console.error(err);
            }

            ///  this.sheetChange(topleft, this.cellformulas);

        }
        if (this.isEditMode)
            this.hot.render();

        this.isPasting = false;
        this.isCutting = false;

        this.pastedresult = null;
        return true;
    }
    selectedRange: any;
    afterSelectionEnd = async (y, x, y2, x2) => {
        // TODO: strg-Taste
        this.selectedRange = [y, x, y2, x2];
        // console.log('after selection end ', y, x, y2, x2)
        //    this.info = "cell:" + a + " " + b + " " + c + " " + d;
        this.handleObjectSelectionByRows(this.curSelectedRow);
        this.refs = [];
        this.applyCellMeta();
    }

    beforeCellMouseDown = (a, b) => {
        console.log('beforeOnCellMouseDown', this.editcell, a, b);

        if (this.editcell) {
            var ce = this.hot.getActiveEditor();
            var v = ce.getValue();

            if (v.endsWith('=') || v.endsWith('+') || v.endsWith('-') || v.endsWith('*') || v.endsWith('/') || v.endsWith('&') || v.endsWith('(') || v.endsWith('$') || v.endsWith(this.lastcellrefstr)) {
                this.lastcellrefstr = Utils.indices2cellaname(b.col, b.row);
                ce.setValue(v + this.lastcellrefstr);
                // Stop event propagation
                a.stopImmediatePropagation();
            } else {
                // First commit the current value
                this.hot.setDataAtCell(this.editcell.row, this.editcell.col, v);
                // Then finish editing
                ce.finishEditing(true);
            }
        }
    }
    beforeChange = (a) => {
        //console.log('beforeChange', a)
        this.keydown = null;
    }
    afterChange = async (a) => {

        this.editcell = null;
        this.editformula = false;

        if (this.autofilling || this.isPasting || this.isCutting) // || iscopying TODO??? warum hier return???
            return;
        console.log("after change ", a)

        if (a == null) return;

        var topleft = { row: a[0][0], col: a[0][1], sheet: this.sheetid };
        //  if (!this.isPasting) this.excels[this.PROJECT].setCellContents(topleft, a[0][3]);

        // änderung zu 2d array TODO: geht vermutlich nicht immer
        var newdata = [];
        var olddata = [];
        // 0:    (4)[33, 2, 'radiusTop', null]
        // 1:    (4)[33, 3, 'radiusBottom', null]
        // 2:    (4)[34, 2, 66, null]
        // 3:    (4)[34, 3, 40, null]
        var r = []; var r2 = [];
        var currow = topleft.row;
        for (var i = 0; i < a.length; i++) {
            if (a[i][0] == currow) {
                if (a[i][3] == null) a[i][3] = '';
                r.push(a[i][3]);
                //    r2.push(a[i][2]);
                olddata.push({ address: { row: a[i][0], col: a[i][1], sheet: this.sheetid }, oldValue: a[i][2] });
            }
            else {
                newdata.push(r);
                r = [];
                currow = a[i][0];
                // neue zeile
                if (a[i][3] == null) a[i][3] = '';
                r.push(a[i][3]);
                olddata.push({ address: { row: a[i][0], col: a[i][1], sheet: this.sheetid }, oldValue: a[i][2] });
            }
        }
        newdata.push(r);

        //////////////
        // snippet?
        if (a?.length == 1) {
            try {

                var row = a[0][0];
                var col = a[0][1];
                var typ = a[0][3];
                var cell = { row: a[0][0], col: a[0][1], sheet: this.sheetid };
                var meta = this.hot.getCellMeta(cell.row, cell.col);
            } catch (error) {

            }

            // ---------------- snippet ----------------
            if (meta?.type == "autocomplete") {
                console.log('autocomplete fll');

                var newsnippet = null;
                for (var i = 0; i < this.snippetManager.snippets.length; i++) {
                    var snippet = this.snippetManager.snippets[i];
                    if (snippet.name == typ) {
                        newsnippet = this.snippetManager.snippets[i];
                        break;
                    }
                }

                // Handle copy type
                if (typ === "copy" && this.sceneobjectSelected) {
                    const sourceObjectId = this.sceneobjectSelected.name;
                    const row = a[0][0];
                    const outputid = typ + (row + 2);

                    // Set the output ID
                    this.dataset[row][0] = '#';
                    this.cellformulas[row][0] = '#';
                    this.dataset[row + 1][0] = outputid;
                    this.cellformulas[row + 1][0] = outputid;

                    // Update Excel
                    await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: row, col: 0 }, '#');
                    await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: row + 1, col: 0 }, outputid);

                    // Create copy rows
                    const copyValues = [
                        ["", "source"],
                        ["copy", sourceObjectId]
                    ];

                    const cell = { row: row, col: 1, sheet: this.sheetid };
                    await this.sheetChange(cell, copyValues, copyValues, true);

                    this.applyCellMeta();
                    return;
                }

                // sheet?
                if (typ?.indexOf("sheet: ") >= 0) {
                    // get snippet from excel
                    var sheetname = typ?.split(": ")[1];
                    var sheetid = await this.excels[this.PROJECT].getSheetId(sheetname);
                    newsnippet = await this.excels[this.PROJECT].getSnippet(sheetname);
                }
                // TODO: subproject?

                if (newsnippet) {
                    // TODO: könnte ggf auch andere Zellen ändern?
                    // primitive,sheet
                    if (this.isInList(this.autocompleteListPrimitives, typ) || typ.indexOf("sheet: ") >= 0) {
                        var outputid = typ + "" + (parseInt(row) + 2);
                        this.dataset[row][0] = '#';
                        this.cellformulas[row][0] = '#';
                        this.dataset[row + 1][0] = outputid;
                        this.cellformulas[row + 1][0] = outputid;
                        var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: row, col: 0 }, '#');
                        var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: row + 1, col: 0 }, outputid);
                    }
                    // control
                    if (this.isInList(this.autocompleteListControls, typ)) {
                        var outputid = typ + "" + (parseInt(row) + 1);
                        this.dataset[row][0] = outputid;
                        this.cellformulas[row][0] = outputid;
                        var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: row, col: 0 }, outputid);
                    }

                    console.log('call sheetshange ')
                    this.sheetChange(cell, newsnippet.values, olddata, true);

                    this.applyCellMeta();
                    return; // automplete dn
                }

            }

        }
        // ---------------- snippet ende ----------------


        /// normale änderung ----------------------------------------

        // floats parsen
        for (var i = 0; i < a?.length; i++) {
            var cell = { row: a[i][0], col: a[i][1], sheet: this.sheetid };
            var val = a[i][3];
            var v = null;
            var f = parseFloat(val);
            if (isNaN(f))
                v = val
            else
                v = f;
            // angezeigte Daten aktualisieren, nötig?
            //      this.cellformulas[cell.row][cell.col] = v;
        }

        var topleft = { row: a[0][0], col: a[0][1], sheet: this.sheetid };
        await this.sheetChange(topleft, newdata, olddata, false, false);
        console.log('sheetChange from afterchange', olddata, newdata)
        if (this.isEditMode)
            this.hot?.render();

        // Update search results if there's an active search
        if (this.searchManager?.searchResults?.length > 0) {
            this.searchManager.updateSearchResults();
        }
    }

    // TODO: olddata vorher bei allen setzen, weil das auch elemente löschen kann
    async sheetChange(topleft, data, olddata, isSnippet = false, debounce = true) {
        if (this.iscreating) return;
        // Removed loading overlay on sheet changes
        // this.processing = true;
        // this.processingMessage = 'Applying changes...';
        try {
            //  console.log('sheetChange', topleft, data);

            // TODO: alle sammeln?
            let data1 = {
                topleft: topleft,
                data: data,
                olddata: olddata,
                isSnippet: isSnippet
            }

            if (debounce)
                this.valueSubject.next(data1); // TODO: achtung! mehrere änderungen hinterneinander werden "verschluckt" nur bei änderung von gui bzw. gleichem param, sonst immer
            else
                await this.sheetChangeWrapper(data1)
        } finally {
            // Removed loading overlay on sheet changes
            // this.processing = false;
            // this.processingMessage = '';
        }
    }

    async sheetChangeWrapper(datas) {
        if (!datas) {
            console.warn('sheetChangeWrapper called with undefined datas');
            return;
        }

        var topleft = datas?.topleft;
        var data = datas?.data;
        var olddata = datas?.olddata;

        if (!topleft) return;
        //   if (data) {
        // console.log('sheetChangeWrapper data', datas);
        var isSnippet = datas?.isSnippet;
        // daten entfernt
        // if (topleft?.col == 1 && !data) {
        //   var outputrow = SheetHelper.getOutputRow(this.dataset)
        //   if (topleft.row < outputrow) {
        //   } else {
        //   }
        //   //   return;
        // }

        // snippets PLatzhalter durhc Zellen ersetzen
        if (isSnippet) {
            try {
                if (data) {

                    var replacedData = JSON.parse(JSON.stringify(data));
                    for (var i = 0; i < data.length; i++) {
                        for (var j = 0; j < data[i].length; j++) {
                            if (data[i][j]) {
                                // bisher Zelle Spalte -1 standard ersatz für ##
                                if (typeof data[i][j] === 'string')
                                    if (data[i][j].indexOf("##") > -1) {
                                        var cellstr = await this.excels[this.PROJECT].simpleCellAddressToString({ sheet: this.sheetid, row: i + topleft.row, col: j + topleft.col - 1 }, this.sheetid);
                                        replacedData[i][j] = data[i][j].replace(/##/g, cellstr);
                                        //   data[i][j] = data[i][j].replaceAll('##', cellstr);


                                    }
                            }
                        }
                    }
                }
            } catch (e) {
                console.error(e);
            }
        }

        if (!replacedData) replacedData = datas.data;


        // TODO: nicht anwenden bei copy pastE?!
        if (this.pastedresult) {

            //      this.pastedresult.push({ address: pasteresult[i].address, val: s2 });
        }
        else {

            if (this.isMainConfig) {
                var exportedchanges = await this.excels[this.PROJECT].setCellContents(topleft, replacedData);
                // update hadsontable
                if (exportedchanges)
                    for (var j = 0; j < exportedchanges.length; j++) {
                        var change = exportedchanges[j];
                        var cellAddress = change.address;
                        var cellValue = change.newValue;
                        // console.log('update handasonstable ', cellAddress, cellValue);
                        if (cellAddress) {
                            if (cellValue?.value) {

                                this.dataset[cellAddress.row][cellAddress.col] = this.handleCellError(cellValue);
                            }
                            else
                                this.dataset[cellAddress.row][cellAddress.col] = cellValue;
                        }
                    }
                if (Array.isArray(data)) {
                    for (var i = 0; i < replacedData.length; i++) {
                        for (var j = 0; j < replacedData[i].length; j++) {
                            if (replacedData[i][j] != null) {
                                this.cellformulas[i + topleft.row][j + topleft.col] = replacedData[i][j]; // TODO: formeln copy format von excel?
                            }
                        }
                    }

                }
                this.applyCellMeta();
                if (exportedchanges)
                    for (var j = 0; j < exportedchanges.length; j++) {
                        var change = exportedchanges[j];
                        var cellAddress = change.address;
                        var cellValue = change.newValue;
                        // console.log('update handasonstable ', cellAddress, cellValue);
                        // if (cellAddress?.col == 2 || cellAddress?.col == 3) {
                        try {
                            var m = this.hot.getCellMeta(cellAddress.row, cellAddress.col);

                            this.hot.setCellMeta(cellAddress.row, cellAddress.col, 'className', "pulsing " + m.className);

                            if (cellValue.value) {

                                this.hot.setCellMeta(cellAddress.row, cellAddress.col, 'className', "error");

                            } else {

                                this.hot.removeCellMeta(cellAddress.row, cellAddress.col, 'className');
                                this.hot.setCellMeta(cellAddress.row, cellAddress.col, 'value', cellValue);
                            }
                        } catch (error) {

                        }
                        //}

                    }

                if (this.isEditMode)
                    this.hot.render();
                // update model ------------------------

                try {
                    console.log('update model')
                    await this.updateModel(exportedchanges, olddata, this.scene);
                } catch (e) {
                    console.error(e);
                }

                // update controls
                // if (topleft.col != 2) {
                try {
                    console.log('update controls')
                    await this.updateControls(exportedchanges, topleft);
                } catch (e) {
                    console.error(e);
                }

                // var outputrow = this.getOutputRow(this.dataset);#
                // if (datas < outputrow) {
                //   this.excels[this.project].createJsonGUI(this.sheetid, this.dataset, this.cellformulas);
                // }
                //        }

            }

            else {
                // subconfig update
                console.log('[EditorComponent] Processing subconfig update:', {
                    selectedSubprojectID: this.selectedSubprojectID,
                    isMainConfig: this.isMainConfig,
                    hasDataset2: !!this.dataset2,
                    dataset2Length: this.dataset2?.length,
                    hasSelectedNode: !!this.selectedNode,
                    hasSelectedNodeUserData: !!this.selectedNode?.userData
                });

                // Validate dataset2 before proceeding
                if (!this.dataset2) {
                    console.error('[EditorComponent] dataset2 is null/undefined for subproject update. Cannot proceed.');
                    console.log('[EditorComponent] Attempting to refresh dataset2 from subproject...');

                    // Try to refresh dataset2 if possible
                    if (this.selectedSubprojectID && this.selectedSubprojectID !== this.PROJECT) {
                        try {
                            const subsheet = await this.excels[this.selectedSubprojectID].getSheetByIndex(0);
                            if (subsheet && subsheet.cells) {
                                this.dataset2 = subsheet.cells;
                                console.log('[EditorComponent] Successfully refreshed dataset2');
                            } else {
                                console.error('[EditorComponent] Failed to refresh dataset2: invalid subsheet data');
                                return; // Cannot proceed without valid dataset2
                            }
                        } catch (error) {
                            console.error('[EditorComponent] Error refreshing dataset2:', error);
                            return; // Cannot proceed without valid dataset2
                        }
                    } else {
                        console.error('[EditorComponent] No valid selectedSubprojectID for dataset2 refresh');
                        return; // Cannot proceed without valid dataset2
                    }
                }

                var exportedchanges = await this.excels[this.selectedSubprojectID].setCellContents(topleft, replacedData);
                if (exportedchanges) {

                    for (var j = 0; j < exportedchanges.length; j++) {
                        var change = exportedchanges[j];
                        var cellAddress = change.address;
                        var cellValue = change.newValue;

                        // Ensure we have valid dataset2 and address before updating
                        if (this.dataset2 && cellAddress &&
                            cellAddress.row >= 0 && cellAddress.col >= 0 &&
                            cellAddress.row < this.dataset2.length &&
                            cellAddress.col < this.dataset2[cellAddress.row]?.length) {
                            this.dataset2[cellAddress.row][cellAddress.col] = cellValue;
                        } else {
                            console.warn('[EditorComponent] Invalid address or dataset2 for subproject update:', {
                                cellAddress,
                                dataset2Length: this.dataset2?.length,
                                rowExists: this.dataset2?.[cellAddress?.row]?.length
                            });
                            continue; // Skip this change
                        }

                        // Update selectedNode userData if available
                        if (this.selectedNode?.userData?.commentrow && this.selectedNode?.userData?.row) {
                            var outputrow = SheetHelper.getOutputRow(this.dataset2);
                            for (var y = 1; y < outputrow; y++) {
                                for (var k = 0; k < this.selectedNode.userData.commentrow.length; k++) {
                                    if (this.dataset2[y] && this.dataset2[y][0] != "" &&
                                        this.dataset2[y][0] == this.selectedNode.userData.commentrow[k]) {
                                        this.selectedNode.userData.row[k] = this.dataset2[y][2];
                                    }
                                }
                            }
                        }
                    }

                    console.log('[EditorComponent] Calling updateModel for subproject with selectedNode');
                    await this.updateModel(exportedchanges, olddata, this.selectedNode);
                }
            }
        }

        this.updateThreeFrame();
        this.changesQueue = [];
    }


    showcodemenu = false;
    addCodeSnippet(s: any) {
        if (!this.project.scriptcode) this.project.scriptcode = "";
        this.project.scriptcode += s.code;
    }


    async addProject(findemptyrows = false, insertpos = null) {
        const dialogRef = this.dialog.open(DialogsubprojectComponent, {
            width: '980px',
            data: { excels: this.excels, hf: this.hf, sheetid: this.sheetid, showAnimations: this.project.sceneSettings.showAnimations, PROJECT: this.PROJECT, dataset: this.dataset },
        });

        dialogRef.afterClosed().subscribe(async result => {
            console.log('The dialog was closed', result);
            if (result) {
                if (result.publicCategoryID) {
                    var projectid = result.id;
                    var pr = (await this.afs.doc("/projectspublic/" + projectid).get().toPromise());
                    var newconfig = pr.data() as any;
                    var project = newconfig.userid + '_' + projectid;
                } else {

                    var projectid = result.id;
                    var project = this.customerid + '_' + projectid
                    var pr = (await this.afs.doc("/projects/userprojects/" + this.customerid + "/" + projectid).get().toPromise());
                    var newconfig = pr.data() as any; //.valueChanges().subscribe(data => {
                    newconfig.id = pr.id;
                }


                if (!this.project.configurations) this.project.configurations = {};
                this.project.configurations[this.curSelectedRow] = newconfig;

                if (this.excels[project]) {
                    //  return this.excels[configuration];
                } else {
                    var toload = [];
                    toload.push(project);

                    // alle unterkonfigs
                    await traverse(newconfig.configmodel).forEach(function (value) {
                        if (typeof (value) === "object" && value?.subproject) {
                            toload.push(value.subproject);
                        }
                    });
                    // delete duplicates from array
                    toload = toload.filter(function (item, pos) {
                        return toload.indexOf(item) == pos;
                    }).sort();
                    console.log("project data", pr);
                    var promises = [];
                    for (var i = 0; i < toload.length; i++) {
                        const w = new Worker(new URL('./../app.worker', import.meta.url), { type: 'module' });
                        this.workers.push(w);
                        this.excels[toload[i]] = Comlink.wrap(w) as any;
                        var p = this.excels[toload[i]].load(toload[i], newconfig.sheets); // TODO sheets von unterconfig
                        promises.push(p);
                    }

                    var t0 = performance.now();
                    var promisesresult = await Promise.all(promises).catch(reason => {
                        console.error(reason)
                    });
                    console.log('promisesresult', promisesresult);
                    var t1 = performance.now();
                    console.log("webworker loads took " + (t1 - t0) + " milliseconds.");
                }

                // this.dataset = promisesresult[0].cells;
                // this.datasetids = promisesresult[0].datasetids;
                // this.cellformulas = promisesresult[0].cellvalues;
                //this.CONFIGURATION = configuration;
                //var dataset = promisesresult[0].cells;
                //   this.applyCellMeta();

                // var jsongui = await this.excels[project].createJsonGUI(0);
                // var newsnippet = this.projectGUI2Snippet(jsongui, projectid, this.curSelectedRow);

                var sheetname1 = await this.excels[project].getSheetNames();
                var newsnippet = await this.excels[project].getSnippet(sheetname1[0]);
                var outputid = "project" + "" + (this.curSelectedRow + 2);
                // 
                var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: this.curSelectedRow, col: 0 }, '#');
                var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: this.curSelectedRow + 1, col: 0 }, outputid);

                newsnippet.values[0][0] = '';
                newsnippet.values[1][0] = 'project: ' + project; // deprecated + projectid; // TODO:ggf mit userid? also project?
                /// TODO: insertpoint, empty insertrow
                var cell = { row: this.curSelectedRow, col: 1, sheet: this.sheetid };
                this.sheetChange(cell, newsnippet.values, newsnippet.values, true);
                this.dataset[this.curSelectedRow][0] = '#';
                this.cellformulas[this.curSelectedRow][0] = '#';
                this.dataset[this.curSelectedRow + 1][0] = outputid;
                this.cellformulas[this.curSelectedRow + 1][0] = outputid;

                this.applyCellMeta();
                this.createModel(this.scene, this.dataset, this.PROJECT);

                // TODO: add project model
                this.loadingOverlay = false;
                //    console.log("jsongui", this.jsongui);
            }
        });
    }

    //openInsertObjectDialogFromCellMenu() {
    //  this.toggleInsertObjectDialog();
    // }

    toggleCellActionMenu(event?: Event) {
        // When clicking the menu icon, it should expand the submenu, not close the main menu
        this.cellactionmenuvisible = !this.cellactionmenuvisible;
        console.log('toggleCellActionMenu cellactionmenuvisible', this.cellactionmenuvisible);

        if (!this.cellactionmenuvisible) {
            // Hide submenus when closing the submenu
            this.showOverlaymenu = false;
            this.showOverlaymenu1 = false;
            this.showothermenu = false;
            this.showSheetsmenu = false;
        }

        // Prevent this click from triggering the document click handler
        // that would close the main context menu
        event?.stopPropagation();
    }

    toggleSceneActionMenu(event?: Event) {
        // When clicking the menu icon, it should expand the submenu, not close the main menu
        this.sceneactionmenuvisible = !this.sceneactionmenuvisible;
        console.log('toggleSceneActionMenu sceneactionmenuvisible', this.sceneactionmenuvisible);

        if (!this.sceneactionmenuvisible) {
            // Hide submenus when closing the submenu
            this.showOverlaymenu = false;
            this.showOverlaymenu1 = false;
            this.showothermenu = false;
            this.showSheetsmenu = false;
        }

        // Prevent this click from triggering the document click handler
        // that would close the main context menu
        event?.stopPropagation();
    }

    openLink(link) {
        window.open(link, "_blank");
    }

    openDisclaimer() {
        console.log('openDisclaimer');
        const dialogRef = this.dialog.open(DialogdisclaimerComponent, {
            width: '880px',
            data: { disclaimer: this.project.disclaimer },
        });

    }

    hasSelectedRefPos(): boolean {
        return this.selectedRefPos !== null || this.selectedConnectorInfo !== null;
    }

    getSelectedRefPosText(): string | null {
        if (this.selectedRefPos) {
            return this.selectedRefPos;
        }
        if (this.selectedConnectorInfo) {
            // For connectors, use consistent naming with face centers: outputid.connector
            return this.selectedConnectorInfo.outputid + '.connector';
        }
        return null;
    }

    clearSelectedRefPos(): void {
        this.selectedRefPos = null;
        this.selectedConnectorInfo = null;
    }

    async addPrimitive(typ: string, insertLocation: 'selected' | 'outputrow' | null = 'outputrow', param = null) {
        var newsnippet = null;
        for (var i = 0; i < this.snippetManager.snippets.length; i++) {
            var snippet = this.snippetManager.snippets[i];
            if (snippet.name == typ) {
                newsnippet = this.snippetManager.snippets[i];
                break;
            }
        }

        // Handle copy type
        if (typ === "copy" && this.sceneobjectSelected) {
            const sourceObjectId = this.sceneobjectSelected.name;
            const row = insertLocation === 'selected' ? this.curSelectedRow : this.findNextAvailableOutputRow();
            const outputid = typ + (row + 2);

            // Set the output ID
            this.dataset[row][0] = '#';
            this.cellformulas[row][0] = '#';
            this.dataset[row + 1][0] = outputid;
            this.cellformulas[row + 1][0] = outputid;

            // Update Excel
            await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: row, col: 0 }, '#');
            await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: row + 1, col: 0 }, outputid);

            // Create copy rows
            const copyValues = [
                ["", "source"],
                ["copy", sourceObjectId]
            ];

            const cell = { row: row, col: 1, sheet: this.sheetid };
            await this.sheetChange(cell, copyValues, copyValues, true);

            this.applyCellMeta();
            return;
        }

        // sheet?
        if (typ.indexOf("sheet: ") >= 0) {
            // get snippet from excel
            var sheetname = typ?.split(": ")[1];
            var sn = await this.excels[this.PROJECT].getSheetNames();
            var sheetid = await this.excels[this.PROJECT].getSheetId(sheetname);
            newsnippet = await this.excels[this.PROJECT].getSnippet(sheetname);
        }

        if (newsnippet) {
            const row = insertLocation === 'selected' ? this.curSelectedRow : this.findNextAvailableOutputRow();
            // TODO: könnte ggf auch andere Zellen ändern?
            var outputid = typ + "" + (row + 2);
            // primitive,sheet
            if (this.isInList(this.autocompleteListPrimitives, typ) || typ.indexOf("sheet: ") >= 0) {
                this.dataset[row][0] = '#';
                this.cellformulas[row][0] = '#';
                this.dataset[row + 1][0] = outputid;
                this.cellformulas[row + 1][0] = outputid;
                var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: row, col: 0 }, '#');
                var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: row + 1, col: 0 }, outputid);
            }

            if (param)
                newsnippet.values[1][1] = param;

            if (typ === 'profile') {
                // Add default values for profile primitive
                newsnippet.values[1][2] = '(0,0);(100,0);(100,100);(0,100)'; // Default profile points
                newsnippet.values[1][3] = '100'; // Default extrusion depth
            }

            // Add refpos from selected reference if applicable
            try {
                if (this.hasSelectedRefPos()) {
                    const refposText = this.getSelectedRefPosText();
                    if (refposText && newsnippet.values && Array.isArray(newsnippet.values) && newsnippet.values.length >= 2) {
                        // Add refpos header to the first row (row 0)
                        if (Array.isArray(newsnippet.values[0])) {
                            newsnippet.values[0].push("refpos");
                        }
                        // Add refpos value to the second row (row 1)
                        if (Array.isArray(newsnippet.values[1])) {
                            newsnippet.values[1].push(refposText);
                        }
                        // Clear the selected refpos after using it
                        this.clearSelectedRefPos();
                    }
                }
            } catch (err) {
                console.warn('Error during refpos processing:', err);
            }

            var cell = { row: row, col: 1, sheet: this.sheetid };
            this.sheetChange(cell, newsnippet.values, newsnippet.values, true);

            this.applyCellMeta();
        }
        if (typ === 'extrusion') {
            this.hot.selectCell(this.hot.getSelected()[0][0] + 1, 2);

            this.showshapeDialog(newsnippet.values[1][1]);
        }
        this.sceneactionvisible = false;
        this.sceneactionmenuvisible = false;
    }
    async addGui(typ: string, insertLocation: 'selected' | 'outputrow' | null = 'outputrow', param = null) {
        var newsnippet = null;
        for (var i = 0; i < this.snippetManager.snippets.length; i++) {
            var snippet = this.snippetManager.snippets[i];
            if (snippet.name == typ) {
                newsnippet = this.snippetManager.snippets[i];
                break;
            }
        }

        // sheet?
        if (typ.indexOf("sheet: ") >= 0) {
            // get snippet from excel
            var sheetname = typ?.split(": ")[1];
            var sheetid = await this.excels[this.PROJECT].getSheetId(sheetname);
            newsnippet = await this.excels[this.PROJECT].getSnippet(sheetname);
        }
        // TODO: subproject
        if (newsnippet) {
            if (this.project?.menuSettings?.menuminimized) {
                setTimeout(() => {
                    this.toggleMenu();
                    setTimeout(() => {
                        this.toggleMenu();
                    }, 2300);
                }, 100);
            }
            const row = insertLocation === 'selected' ? this.curSelectedRow : this.findNextAvailableOutputRow();
            // TODO: könnte ggf auch andere Zellen ändern?
            var outputid = typ + "" + (row + 1);

            // control
            if (this.isInList(this.autocompleteListControls, typ)) {
                this.dataset[row][0] = outputid;
                this.cellformulas[row][0] = outputid;
                var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: row, col: 0 }, outputid);

                if (param) {
                    newsnippet.values[0][1] = param;
                }

                // Add refpos from selected reference if applicable for GUI controls
                try {
                    if (this.hasSelectedRefPos()) {
                        const refposText = this.getSelectedRefPosText();
                        if (refposText && newsnippet.values && Array.isArray(newsnippet.values) && newsnippet.values.length >= 2) {
                            // Add refpos header to the first row (row 0)
                            if (Array.isArray(newsnippet.values[0])) {
                                newsnippet.values[0].push("refpos");
                            }
                            // Add refpos value to the second row (row 1)
                            if (Array.isArray(newsnippet.values[1])) {
                                newsnippet.values[1].push(refposText);
                            }
                            // Clear the selected refpos after using it
                            this.clearSelectedRefPos();
                        }
                    }
                } catch (err) {
                    console.warn('Error during refpos processing for GUI control:', err);
                }

            }

            var cell = { row: row, col: 1, sheet: this.sheetid };
            this.sheetChange(cell, newsnippet.values, newsnippet.values, true);

            this.applyCellMeta();
        }
        this.sceneactionvisible = false;
        this.sceneactionmenuvisible = false;
    }
    beforeAutoFillRange: SimpleCellRange;
    autofilling = false;
    beforeAutoFill = (changes, source) => {
        this.beforeAutoFillRange = this.selectedRange;
        console.log('beforeAutoFill changes', changes, 'source', source, 'selectedrange', this.selectedRange);
        this.autofilling = true;
    }
    afterAutoFill = async (startcellfill, endcellfill, fillrange) => {
        // reihenfolger events(hf): beforeautofill, beforechange, afterchagne, (verzögert sheetchange), afterauffill,  sheetchange decoubnce,
        console.log(fillrange, 'afterAutoFill startcellfill', startcellfill, 'endcellfill', endcellfill, 'beforefillautrange', this.beforeAutoFillRange);
        console.log('afterAutoFill startcellfill', startcellfill, 'endcellfill', endcellfill, 'selectedrange', this.selectedRange);

        try {
            var srcrange = {
                start: { sheet: this.sheetid, row: this.beforeAutoFillRange[0], col: this.beforeAutoFillRange[1] }, end: { sheet: this.sheetid, row: this.beforeAutoFillRange[2], col: this.beforeAutoFillRange[3] }
            };
            var src = await this.excels[this.PROJECT].getRangeSerialized(srcrange);
            var srct = src[0].map((_, colIndex) => src.map(row => row[colIndex])); // transpose
            //  var targetrange = { start: { sheet: this.sheetid, row: 0, col: 0 }, end: { sheet: this.sheetid, row: 1, col: 1 } };
            var targetrange = { start: { sheet: this.sheetid, row: fillrange.from.row, col: fillrange.from.col }, end: { sheet: this.sheetid, row: fillrange.to.row, col: fillrange.to.col } };
            var targetrowscount = fillrange.to.row - fillrange.from.row + 1;// targetrange.end.row - targetrange.start.row + 1;
            var targetcolscount = fillrange.to.col - fillrange.from.col + 1; // targetrange.end.col - targetrange.start.col + 1;
            var fill = [];
            for (var i = 0; i < targetrowscount; i++) fill.push([])

            // NaN Fehler,von llinks nach rechts erweitern, tokenisierung
            for (var i = 0; i < targetcolscount; i++) {
                var xs = srct[i].map((e, i) => { return i }); // transpose
                var ys = srct[i];
                for (var j = 0; j < ys.length; j++)
                    if (!isNaN(ys[j]))
                        // str to float
                        ys[j] = parseFloat(ys[j]);
                // TODO: tokenisierung, Cell-references
                // https://stackoverflow.com/questions/3370263/separate-integers-and-text-in-a-string


                var mb = Utils.findLineByLeastSquares(xs, ys);
                if (!isNaN(mb.m)) {
                    var fillcol = [];
                    for (var j = 0; j < targetrowscount; j++) {
                        var autofillrowindex = xs[xs.length - 1] + 1 + j;
                        var yi = mb.m * autofillrowindex + mb.b;
                        if (isNaN(yi)) yi = ys[0]; /// ggf unterste zelle?
                        fillcol.push(yi);
                        fill[j].push(yi);
                    }
                } else {
                    fill = await this.excels[this.PROJECT].getFillRangeData(
                        srcrange,
                        targetrange
                        //  { start: { sheet: this.sheetid, row: 0, col: 0 }, end: { sheet: this.sheetid, row: 1, col: 1 } },
                        //  { start: { sheet: this.sheetid, row: 1, col: 1 }, end: { sheet: this.sheetid, row: 3, col: 3 } }
                    );
                }
            }

            if (fillrange.from.col == 0) {
                for (var j = 0; j < targetrowscount; j++) {
                    var t = Utils.remove_numbers_at_the_end(fill[j][0]);
                    var name = t + (startcellfill.row + j + 1);
                    fill[j][0] = name;
                }
            }
            var r = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: fillrange.from.row, col: fillrange.from.col }, fill);
            console.log('afterAutoFill fill', fill);
            this.sheetChange({ sheet: this.sheetid, row: fillrange.from.row, col: fillrange.from.col }, fill, fill);

            this.autofilling = false;
            if (this.isEditMode)
                this.hot.render();
        } catch (e) {
            console.warn("afterAutoFill", e);
        }
    }

    setSelectionRange(input, selectionStart, selectionEnd) {
        if (input.setSelectionRange) {
            input.focus();
            input.setSelectionRange(selectionStart, selectionEnd);
        }
        else if (input.createTextRange) {
            var range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', selectionEnd);
            range.moveStart('character', selectionStart);
            range.select();
        }
    }

    setCaretToPos(input, pos) {
        this.setSelectionRange(input, pos, pos);
    }
    keydown = null;
    editval = null;
    refcell = null;
    lastcellrefstr = null;
    lastcellvalue = "";
    refs: any;
    afterDocumentKeyDown = (e) => {
        //  console.log('afterDocumentKeyDown', e.key, this.editcell);
        try {
            if (this.editcell) {
                //  var t = this.hot.getDataAtCell(this.editcell.row, this.editcell.col);

                this.keydown = e.key;
                var ce = this.hot.getActiveEditor(); //(this.editcell.row, this.editcell.col);
                var v = ce.getValue();

                //      ce.enableFullEditMode();

                if (e.key == "Tab") {
                    this.hot.selectCell(this.editcell.row, this.editcell.col + 1);
                    this.refs = null;
                    this.applyCellMeta();

                    e.preventDefault();
                }

                if (v.endsWith('=') || v.endsWith('+') || v.endsWith('-') || v.endsWith('*') || v.endsWith('/') || v.endsWith('&') || v.endsWith('(') || v.endsWith('$') || v.endsWith(this.lastcellrefstr)) {
                    if (e.key == 'ArrowUp' || e.key == 'ArrowDown' || e.key == 'ArrowLeft' || e.key == 'ArrowRight') {
                        this.refcell = this.editcell;
                        if (e.key == 'ArrowUp') this.refcell.row--;
                        if (e.key == 'ArrowDown') this.refcell.row++;
                        if (e.key == 'ArrowLeft') this.refcell.col--;
                        if (e.key == 'ArrowRight') this.refcell.col++;
                        if (v.endsWith(this.lastcellrefstr)) {
                            // remove lastcellrefstr from v
                            var lastl = this.lastcellrefstr.length;
                            this.lastcellrefstr = Utils.indices2cellaname(this.refcell.col, this.refcell.row); // await this.excels[this.PROJECT].simpleCellAddressToString(this.refcell, this.sheetid);
                            v = v.substring(0, v.length - lastl);
                            ce.setValue(v + this.lastcellrefstr);

                            this.refs = Utils.getCellReferences(v + this.lastcellrefstr);
                            //          this.colorizeCellReferences(refs);
                            this.applyCellMeta();
                            //   return
                        }
                        else {
                            this.lastcellrefstr = Utils.indices2cellaname(this.refcell.col, this.refcell.row); // await this.excels[this.PROJECT].simpleCellAddressToString(this.refcell, this.sheetid);
                            ce.setValue(v + this.lastcellrefstr);
                            this.refs = Utils.getCellReferences(v + this.lastcellrefstr);
                            //    this.colorizeCellReferences(refs);
                            this.applyCellMeta();

                            // return;
                        }

                        v = ce.getValue();
                        var txtarea = document.getElementsByClassName('handsontableInput')[0] as any;

                        this.setCaretToPos(txtarea, v.length);
                        e.preventDefault();
                        e.stopImmediatePropagation();
                    } else {
                        this.refcell = null;
                        this.applyCellMeta();
                        return;
                    }
                } else {
                    if (e.key == 'ArrowLeft' || e.key == 'ArrowRight') {
                        //  e.preventDefault();
                        //      this.hot.selectCell(this.editcell.row, this.editcell.col);

                        if (!v)
                            this.hot.selectCell(this.editcell.row, this.editcell.col);

                        this.refs = null;
                        return;
                    }
                    if (e.key == 'ArrowUp' || e.key == 'ArrowDown') {
                        // e.preventDefault();
                        this.hot.selectCell(this.editcell.row, this.editcell.col);
                        this.refs = null;
                        return;
                    }
                    this.refs = null;
                    this.applyCellMeta();
                    if (e.key == 'Enter') {

                    }
                    else {
                        e.stopImmediatePropagation();
                    }
                }
            }
            else
                if (e.key != 'ArrowUp' && e.key != 'ArrowDown' && e.key != 'ArrowLeft' && e.key != 'ArrowRight' && e.key != 'Enter') {
                    var ce = this.hot.getActiveEditor();

                    if (ce) {

                        ce.enableFullEditMode();
                        this.lastcellvalue = e.key;
                        this.keydown = e.key;
                        ce.setValue(this.lastcellvalue);
                    }

                }
            if (e.key == 'Enter') {
                this.refs = null;
                this.applyCellMeta();
            }

        } catch (e) {
            console.warn("afterDocumentKeyDown", e);
        }
    }

    editcell = null; editcelltop = null;
    editformula = null;
    afterBeginEditing = async (row, col) => {
        try {
            console.log('afterBeginEditing', row, col);
            this.editformula = true;
            this.editcell = { sheet: this.sheetid, row: row, col: col };
            var el = document.getElementsByClassName('handsontableInputHolder')[0] as any;
            this.editcelltop = parseInt(el.style.top.replace("px", ""));

            // Get the current editor value
            const editor = this.hot.getActiveEditor();
            const currentValue = editor?.getValue() || '';

            // If we're starting with an equals sign, this is a formula - don't overwrite
            if (currentValue.startsWith('=')) {
                return;
            }

            // Only get serialized data if we're not in the middle of a paste operation
            // and not starting a formula
            if (!this.isPasting && !this.keydown?.startsWith('=')) {
                var serializeddata = await this.excels[this.PROJECT].getCellSerialized({ sheet: this.sheetid, row: row, col: col });
                if ((!this.keydown || this.keydown == "Enter" || this.keydown == "Tab") && serializeddata != "" && serializeddata != null) {
                    this.dataset[row][col] = serializeddata;
                    if (this.isEditMode) {
                        editor?.setValue(serializeddata);
                        this.hot.render();
                        this.refs = Utils.getCellReferences(serializeddata);
                        this.applyCellMeta();
                    }
                }
            }
        } catch (e) {
            console.warn("afterBeginEditing", e);
        }
    }
    afterDeselect = () => {
        console.log('afterDeselect');
        this.editcell = null;
        this.editformula = false;
        this.keydown = null;
    }

    afterSetDataAtRowProp(changes, source) {
        console.log('afterSetDataAtRowProp', changes, source, this.selectedRange);
    }
    viewHelper: any; composer: any; outlinePass: any; renderPass: any;

    private setupInteractionManagerDependencies() {
        console.log('[EditorComponent] Setting up InteractionManager dependencies', {
            hasScene: !!this.scene,
            hasCamera: !!this.camera,
            hasExcels: !!this.excels,
            hasPROJECT: !!this.PROJECT,
            hasDataset: !!this.dataset,
            sheetid: this.sheetid,
            selectedprojectpath: this.selectedprojectpath,
            isEditMode: this.isEditMode
        });

        const dependencies: SceneClickDependencies = {
            // Core objects
            scene: this.scene,
            camera: this.camera,

            // State management
            mousedrag: this.mousedrag,
            setMousedrag: (value: boolean) => this.mousedrag = value,

            // Project/sheet related
            selectedprojectpath: this.selectedprojectpath,
            selectedSubprojectPath: this.selectedSubprojectPath,
            sheetid: this.sheetid,
            getSheetid: () => this.sheetid,
            selectedprojectpath_setter: (value: string) => this.selectedprojectpath = value,

            // Sprite management
            hoveredFaceCenterSprite: this.hoveredFaceCenterSprite,
            hoveredFaceCenterOriginalMaterial: this.hoveredFaceCenterOriginalMaterial,
            selectedFaceCenterSprite: this.selectedFaceCenterSprite,
            setHoveredFaceCenterSprite: (sprite: THREE.Sprite | null) => this.hoveredFaceCenterSprite = sprite,
            setHoveredFaceCenterOriginalMaterial: (material: THREE.SpriteMaterial | null) => this.hoveredFaceCenterOriginalMaterial = material,
            setSelectedFaceCenterSprite: (sprite: THREE.Sprite | null) => this.selectedFaceCenterSprite = sprite,

            // Input/Output objects
            inputSprite: this.inputSprite,
            inputPoint: this.inputPoint,
            inputPosition: this.inputPosition,
            setInputSprite: (sprite: any) => this.inputSprite = sprite,
            setInputPoint: (point: any) => this.inputPoint = point,
            setInputPosition: (position: any) => this.inputPosition = position,

            // Selection state
            selectedNode: this.selectedNode,
            selectedSubprojectID: this.selectedSubprojectID,
            selectedProjectName: this.selectedProjectName,
            selectedObject: this.selectedObject,
            sheetNode: this.sheetNode,
            sheetSelected: this.sheetSelected,
            isMainConfig: this.isMainConfig,
            uihead: this.uihead,
            setSelectedNode: (node: any) => this.selectedNode = node,
            setSelectedSubprojectID: (id: string | null) => this.selectedSubprojectID = id,
            setSelectedProjectName: (name: string | null) => this.selectedProjectName = name,
            setSelectedObject: (obj: any) => this.selectedObject = obj,
            setSheetNode: (node: any) => this.sheetNode = node,
            setSheetSelected: (selected: boolean) => this.sheetSelected = selected,
            setIsMainConfig: (isMain: boolean) => {
                console.log('[EditorComponent] isMainConfig changing from', this.isMainConfig, 'to', isMain);
                this.isMainConfig = isMain;
                // Clear dataset2 when switching to main config
                if (isMain && this.dataset2) {
                    console.log('[EditorComponent] Clearing dataset2 when switching to main config');
                    this.dataset2 = null;
                }
            },
            setUihead: (head: string) => this.uihead = head,

            // Data and formulas
            excels: this.excels,
            PROJECT: this.PROJECT,
            cellformulas: this.cellformulas,
            dataset: this.dataset,
            dataset2: this.dataset2,
            project: this.project,
            jsongui: this.jsongui,
            jsongui2: this.jsongui2,
            selectedObjectHelper: this.selectedObjectHelper,

            // Setters for data
            setCellformulas: (formulas: any) => this.cellformulas = formulas,
            setDataset: (data: any) => this.dataset = data,
            setDataset2: (data: any) => this.dataset2 = data,
            setProject: (proj: any) => this.project = proj,
            setJsongui: (gui: any) => this.jsongui = gui,
            setJsongui2: (gui: any) => this.jsongui2 = gui,
            setSelectedObjectHelper: (helper: any) => this.selectedObjectHelper = helper,

            // UI elements
            hot: this.hot,
            isEditMode: this.isEditMode,
            editorComponent: this, // Reference for direct property updates

            // Scene action menu properties
            sceneactionleft: this.sceneactionleft,
            sceneactiontop: this.sceneactiontop,
            sceneactionvisible: this.sceneactionvisible,
            sceneactionmenuvisible: this.sceneactionmenuvisible,
            setSceneactionleft: (left: string) => this.sceneactionleft = left,
            setSceneactiontop: (top: string) => this.sceneactiontop = top,
            setSceneactionvisible: (visible: boolean) => this.sceneactionvisible = visible,
            setSceneactionmenuvisible: (visible: boolean) => this.sceneactionmenuvisible = visible,

            // Methods
            updateThreeFrame: () => this.updateThreeFrame(),
            showClipboardLabelWithText: (text: string) => this.showClipboardLabelWithText(text),
            handleDimensionTextClick: (object: any) => this.handleDimensionTextClick(object),
            handleObjectSelectionByRows: (row: number) => this.handleObjectSelectionByRows(row),
            cellChanges2dataset: (changes: any[]) => this.cellChanges2dataset(changes),
            updateModel: (changes: any, oldData: any, scene: THREE.Scene) => this.updateModel(changes, oldData, scene),
            subprojectSelected: () => this.subprojectSelected(),
            createConfigModel: () => this.createConfigModel(),
            csschange: (css: string, isSubconfig?: boolean) => this.csschange(css, isSubconfig),
            triggerChangeDetection: () => this.ngZone.run(() => this.cdr.detectChanges()),
            updateBreadcrumbs: () => this.updateBreadcrumbs(),
            adjustMenuPosition: (clientX: number, clientY: number) => this.adjustMenuPosition(clientX, clientY)
        };

        this.interactionManager.setDependencies(dependencies);
        console.log('[EditorComponent] InteractionManager dependencies set successfully');
    }

    public toggleSceneSlicer() {
        this.showSceneSlicer = !this.showSceneSlicer;
        if (this.showSceneSlicer) {
            this.sceneSlicer?.enable();
        } else {
            this.sceneSlicer?.disable();
        }
        this.updateThreeFrame();
    }

    zoomall() {
        this.sceneManager.zoomall(this.selectedObject);
    }

    zoomallscene() {
        this.sceneManager.zoomallscene();
    }

    zoomAllVisible() {
        this.sceneManager.zoomAllVisible();
    }

    threecontainerwidth = 100;
    leftpanelwidth = 200;
    splitleft = 45;
    @ViewChild(SplitComponent) splitEl: SplitComponent
    @ViewChildren(SplitAreaDirective) areasEl: QueryList<SplitAreaDirective>
    // Add this as a class property
    private initialFrustumSize: number | null = null;

    async onResize(event: any) {
        console.log('onResize', event);
        if (this.isEditMode) {
            // Use displayedAreas for three split areas
            const areas = this.splitEl.displayedAreas;
            this.leftpanelwidth = Math.round(Number(areas[0].size) / 100.0 * window.innerWidth) * 1 / 1.0;
            this.threecontainerwidth = Math.round(Number(areas[1].size) / 100.0 * window.innerWidth) * 1 / 1.0;
            this.agentpanelwidth = Math.round(Number(areas[2].size) / 100.0 * window.innerWidth) * 1 / 1.0;

            // Save current split sizes to project settings during resize
            if (this.project && this.project.settings && areas && areas.length === 3) {
                this.project.settings.splitSizes = {
                    left: areas[0].size,
                    middle: areas[1].size,
                    right: areas[2].size
                };
            }
        } else {
            this.leftpanelwidth = 0;
            this.threecontainerwidth = window.innerWidth;
            this.agentpanelwidth = 0;
        }
        if (this.leftpanelwidth > 9000) this.leftpanelwidth = 0;
        var container = document.getElementById("threecontainer");

        // Use SceneManager to handle resize
        this.sceneManager.handleResize(this.threecontainerwidth, container.clientHeight);

        await this.setVars();

        this.splitleft = Number(this.splitEl.displayedAreas[0].size);
        if (this.isEditMode)
            this.hot?.render();

        if (!this.isEditMode)
            this.splitleft = 0;

        if (this.viewportGizmo) {
            //      this.viewportGizmo.left = this.threecontainerwidth - 128; // hack
        }

        this.updateThreeFrame();

        // menu
        if (window.innerWidth < 600) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }



    }


    projecthelper: any;
    higlightProject() {
        try {
            if (this.projecthelper) {
                this.scene.remove(this.projecthelper);
                this.projecthelper = null;
            }
            if (this.highlightproject) {
                this.highlightproject.updateMatrixWorld();
                this.highlightproject.updateMatrix();
                var box = ThreeUtils.getBBox(this.highlightproject);
                box = box.expandByScalar(10);
                var m2 = ThreeUtils.create3DMarker(box, 100, 5, 20, 0xff00ff);
                this.projecthelper = m2;

                const editSprite = ThreeUtils.createEditButtonSprite();

                const center = new THREE.Vector3();
                box.getCenter(center);
                editSprite.position.copy(center);

                const boxDepth = box.max.z - box.min.z;
                editSprite.position.z = center.z;

                editSprite.position.y = center.y;

                editSprite.renderOrder = 99999;
                editSprite.userData.isHelper = true;

                this.projecthelper.add(editSprite);

                const deleteSprite = ThreeUtils.createDeleteButtonSprite();

                deleteSprite.position.copy(center);
                deleteSprite.position.x = center.x + 90;
                deleteSprite.position.y = center.y;
                deleteSprite.position.z = center.z;

                deleteSprite.renderOrder = 99999;
                deleteSprite.userData.isHelper = true;
                deleteSprite.userData.isDeleteButton = true;
                deleteSprite.userData.targetProject = this.highlightproject;

                this.projecthelper.add(deleteSprite);

                this.projecthelper.renderOrder = 99999;
                this.projecthelper.userData.isHelper = true;

                this.scene.add(this.projecthelper);
            }
        }
        catch (err) {
            console.warn(err);
        }
    }



    async undo() {
        var changes = await this.excels[this.PROJECT].undo();
        this.changes2dataset(changes);
        this.hot.render();
        this.updateModel(changes, null, this.scene);
        this.updateThreeFrame();
    }
    async redo() {
        var changes = await this.excels[this.PROJECT].redo();
        this.changes2dataset(changes);
        this.hot.render();
        this.updateModel(changes, null, this.scene);
        this.updateThreeFrame();
    }

    changes2dataset(changes: any) {
        for (var i = 0; i < changes?.length; i++) {
            var change = changes[i];
            if (!change.address) continue;
            var sheet = change.address.sheet;
            var row = change.address.row;
            var col = change.address.col;
            var value = change.value;
            if (change.newValue)
                value = change.newValue;
            if (sheet == 0)
                this.dataset[row][col] = value;
        }
    }

    scenemousedown(e: any) {
        this.handleSceneEvent("MouseDown", e);
        this.mousebuttondown = true;
    }

    sceneobjectMouseOver = null;
    sceneobjectSelected = null;
    highlightproject: any = null;
    mousedrag = false;
    mousebuttondown = false;
    scenemousemove(e: any) {
        try {
            this.handleSceneEvent("MouseMove", e);
            if (this.mousebuttondown) this.mousedrag = true;

            const threeContainer = document.getElementById('threecontainer');
            const containerRect = threeContainer?.getBoundingClientRect();
            const offsetX = containerRect?.left || 0;
            const offsetY = containerRect?.top || 0;

            this.mouseScreenPosition = [e.clientX - offsetX, e.clientY - offsetY];

            if (Math.random() < 0.01) {
                console.log('[MOUSE DEBUG] Mouse position updated:', {
                    globalMouse: [e.clientX, e.clientY],
                    containerMouse: this.mouseScreenPosition,
                    containerOffset: [offsetX, offsetY],
                    containerSize: [containerRect?.width, containerRect?.height]
                });
            }

            this.updateThreeFrame();
        }
        catch (err) {
            console.warn(err);
        }
    }


    scenemouseup(e: any) {
        this.mousebuttondown = false;
        this.showObjectInfos = false;
        ThreeUtils.gltfNodeBox(null, this.scene);

        this.handleSceneEvent("MouseUp", e);

        // Reset mousedrag flag after processing
        this.mousedrag = false;
    }

    highlightNode: any;

    sceneobjectSceneSelected = null;
    overinfo = "";
    selectedprojectpath = "root^$0"; hoverObject = null;
    public cursorType = "default";

    async handleSceneEvent(type: string, e: any) {
        const canvasTarget = document.getElementById('threecontainer');
        var mouse = new THREE.Vector2();
        mouse.x = (e.layerX / canvasTarget.clientWidth) * 2 - 1;
        mouse.y = -(e.layerY / canvasTarget.clientHeight) * 2 + 1;
        this.overinfo = null;
        this.cursorType = "default";

        var raycaster = new THREE.Raycaster();
        raycaster.setFromCamera(mouse, this.camera);

        raycaster.params.Sprite = {};
        raycaster.params.Points = { threshold: 1 };

        raycaster.ray.origin.addScaledVector(
            raycaster.ray.direction,
            this.camera.near
        );
        raycaster.layers.enableAll();


        var intersects = raycaster.intersectObjects(this.scene.children, true);

        if (type === 'MouseDown' && intersects.length > 0) {
            const spriteIntersects = intersects.filter(i => i.object instanceof THREE.Sprite);
            if (spriteIntersects.length > 0) {
                console.log(`[DEBUG] Found ${spriteIntersects.length} sprite intersections:`,
                    spriteIntersects.map(i => ({
                        type: i.object.userData?.type,
                        isDeleteButton: i.object.userData?.isDeleteButton,
                        isHelper: i.object.userData?.isHelper,
                        distance: i.distance
                    }))
                );
            }
        }

        let firstIntersectedObject: THREE.Object3D | null = null;

        if (intersects.length > 0) {
            let closestSprite: THREE.Object3D | null = null;
            let closestSpriteDistance = Infinity;
            let closestNonSprite: THREE.Object3D | null = null;
            let closestNonSpriteDistance = Infinity;

            for (const intersect of intersects) {
                const object = intersect.object;
                const distance = intersect.distance;

                if (object instanceof THREE.Sprite && (object.userData?.type === 'refpoint' || object.userData?.isDeleteButton)) {
                    if (distance < closestSpriteDistance) {
                        closestSprite = object;
                        closestSpriteDistance = distance;
                    }
                }
                // Add specific handling for face center spheres (THREE.Mesh with refpoint type and isFaceCenter)
                else if (object instanceof THREE.Mesh && object.userData?.type === 'refpoint' && object.userData?.isFaceCenter) {
                    if (distance < closestSpriteDistance) {
                        closestSprite = object; // Treat face center spheres with same priority as sprites
                        closestSpriteDistance = distance;
                    }
                }
                else if (object.visible && (!object.userData || object.userData.isHelper !== true)) {
                    if (distance < closestNonSpriteDistance) {
                        closestNonSprite = object;
                        closestNonSpriteDistance = distance;
                    }
                }
            }

            if (closestSprite) {
                firstIntersectedObject = closestSprite;
            } else {
                firstIntersectedObject = closestNonSprite;
            }
        }

        if (type === 'MouseMove') {
            // Debug logging to see what object we're hovering over
            if (firstIntersectedObject) {
                //        console.log('[DEBUG] Hovering over object:', {
                //     type: firstIntersectedObject.constructor.name,
                //     userDataType: firstIntersectedObject.userData?.type,
                //     isFaceCenter: firstIntersectedObject.userData?.isFaceCenter,
                //     isHelper: firstIntersectedObject.userData?.isHelper
                // });
            }

            if (firstIntersectedObject && firstIntersectedObject instanceof THREE.Sprite && firstIntersectedObject.userData.type === 'refpoint') {
                if (this.hoveredFaceCenterSprite !== firstIntersectedObject) {
                    if (this.hoveredFaceCenterSprite && this.hoveredFaceCenterOriginalMaterial) {
                        this.hoveredFaceCenterSprite.material = this.hoveredFaceCenterOriginalMaterial;
                    }

                    this.hoveredFaceCenterSprite = firstIntersectedObject as THREE.Sprite;

                    if (Array.isArray(firstIntersectedObject.material)) {
                        console.warn("Hovered object has an array of materials, taking the first one for original material.");
                        this.hoveredFaceCenterOriginalMaterial = (firstIntersectedObject.material[0] as THREE.SpriteMaterial).clone();
                    } else {
                        this.hoveredFaceCenterOriginalMaterial = (firstIntersectedObject.material as THREE.SpriteMaterial).clone();
                    }

                    const newMaterial = this.hoveredFaceCenterOriginalMaterial.clone();
                    newMaterial.color.setHex(0xff8800);

                    this.hoveredFaceCenterSprite.material = newMaterial;
                    this.cursorType = 'pointer';
                    this.updateThreeFrame();
                }
            }
            // Add support for face center spheres (THREE.Mesh objects)
            else if (firstIntersectedObject && firstIntersectedObject instanceof THREE.Mesh &&
                firstIntersectedObject.userData.type === 'refpoint' &&
                firstIntersectedObject.userData.isFaceCenter) {
                this.cursorType = 'pointer';
                console.log('[DEBUG] Face center sphere detected, setting cursor to pointer');
            }
            else if (firstIntersectedObject && firstIntersectedObject instanceof THREE.Sprite && firstIntersectedObject.userData.type === 'connector') {
                if (this.cad.hoveredConnectorSprite !== firstIntersectedObject) {
                    if (this.cad.hoveredConnectorSprite && this.cad.hoveredConnectorOriginalMaterial) {
                        this.cad.hoveredConnectorSprite.material = this.cad.hoveredConnectorOriginalMaterial;
                    }

                    this.cad.hoveredConnectorSprite = firstIntersectedObject as THREE.Sprite;

                    if (Array.isArray(firstIntersectedObject.material)) {
                        console.warn("Hovered connector has an array of materials, taking the first one for original material.");
                        this.cad.hoveredConnectorOriginalMaterial = (firstIntersectedObject.material[0] as THREE.SpriteMaterial).clone();
                    } else {
                        this.cad.hoveredConnectorOriginalMaterial = (firstIntersectedObject.material as THREE.SpriteMaterial).clone();
                    }

                    const newMaterial = this.cad.hoveredConnectorOriginalMaterial.clone();
                    newMaterial.color.setHex(0xff8800);

                    this.cad.hoveredConnectorSprite.material = newMaterial;
                    this.cursorType = 'pointer';
                    this.updateThreeFrame();
                }
            }
            else {
                let needsUpdate = false;

                if (this.hoveredFaceCenterSprite && this.hoveredFaceCenterOriginalMaterial) {
                    if (this.hoveredFaceCenterSprite !== this.selectedFaceCenterSprite) {
                        console.log('[DEBUG] Resetting hovered face center sprite (not selected)');
                        this.hoveredFaceCenterSprite.material = this.hoveredFaceCenterOriginalMaterial;
                        this.hoveredFaceCenterSprite = null;
                        this.hoveredFaceCenterOriginalMaterial = null;
                        needsUpdate = true;
                    } else {
                        console.log('[DEBUG] Not resetting hovered face center sprite because it is selected');
                        this.hoveredFaceCenterSprite = null;
                        this.hoveredFaceCenterOriginalMaterial = null;
                    }
                }

                if (this.cad.hoveredConnectorSprite && this.cad.hoveredConnectorOriginalMaterial) {
                    if (this.cad.hoveredConnectorSprite !== this.cad.selectedConnectorSprite) {
                        console.log('[DEBUG] Resetting hovered connector sprite (not selected)');
                        this.cad.hoveredConnectorSprite.material = this.cad.hoveredConnectorOriginalMaterial;
                        this.cad.hoveredConnectorSprite = null;
                        this.cad.hoveredConnectorOriginalMaterial = null;
                        needsUpdate = true;
                    } else {
                        console.log('[DEBUG] Not resetting hovered connector sprite because it is selected');
                        this.cad.hoveredConnectorSprite = null;
                        this.cad.hoveredConnectorOriginalMaterial = null;
                    }
                }

                if (needsUpdate) {
                    this.updateThreeFrame();
                }

                // Handle 3D object hover highlighting
                this.handleObjectHover(firstIntersectedObject);
            }
        } else if (type === 'MouseDown') {
            // Only handle delete button clicks on MouseDown (immediate action needed)
            if (firstIntersectedObject && firstIntersectedObject instanceof THREE.Sprite && firstIntersectedObject.userData.isDeleteButton) {
                console.log('Delete button sprite clicked:', firstIntersectedObject.userData);

                const targetProject = firstIntersectedObject.userData.targetProject;
                if (targetProject) {
                    try {
                        await this.deleteSubproject(targetProject);
                        console.log('Successfully deleted subproject');
                    } catch (error) {
                        console.error('Error deleting subproject:', error);
                    }
                }
                this.updateThreeFrame();
                return;
            }

            // Store the clicked object for potential selection on mouse up (if no drag occurred)
            this.potentialSelectionObject = firstIntersectedObject;
            this.potentialSelectionEvent = e;
        } else if (type === 'MouseUp') {
            // Only process selections on MouseUp if no dragging occurred
            // This ensures that camera movements don't trigger object selection
            if (this.potentialSelectionObject && !this.mousedrag) {
                this.processObjectSelection(this.potentialSelectionObject, this.potentialSelectionEvent);
            }

            // Clear potential selection
            this.potentialSelectionObject = null;
            this.potentialSelectionEvent = null;
        } else if (type === 'MouseOut' || type === 'MouseLeave') {
            let needsUpdate = false;

            if (this.hoveredFaceCenterSprite && this.hoveredFaceCenterOriginalMaterial) {
                this.hoveredFaceCenterSprite.material = this.hoveredFaceCenterOriginalMaterial;
                this.hoveredFaceCenterSprite = null;
                this.hoveredFaceCenterOriginalMaterial = null;
                needsUpdate = true;
            }

            if (this.cad.hoveredConnectorSprite && this.cad.hoveredConnectorOriginalMaterial) {
                this.cad.hoveredConnectorSprite.material = this.cad.hoveredConnectorOriginalMaterial;
                this.cad.hoveredConnectorSprite = null;
                this.cad.hoveredConnectorOriginalMaterial = null;
                needsUpdate = true;
            }

            if (needsUpdate) {
                this.updateThreeFrame();
            }
        }


        if (intersects.length > 0) {
            var obj = firstIntersectedObject;

            if (!obj) {
                if (this.hoveredFaceCenterSprite && this.hoveredFaceCenterOriginalMaterial) {
                    if (this.hoveredFaceCenterSprite !== this.selectedFaceCenterSprite) {
                        console.log('[DEBUG] Resetting hovered sprite on helper/empty space (not selected)');
                        this.hoveredFaceCenterSprite.material = this.hoveredFaceCenterOriginalMaterial;
                        this.hoveredFaceCenterSprite = null;
                        this.hoveredFaceCenterOriginalMaterial = null;
                        this.updateThreeFrame();
                    } else {
                        console.log('[DEBUG] Not resetting hovered sprite on helper/empty space because it is selected');
                        this.hoveredFaceCenterSprite = null;
                        this.hoveredFaceCenterOriginalMaterial = null;
                    }
                }
                this.highlightproject = null;
                this.higlightProject();
                this.updateThreeFrame();
                return;
            }

            const currentTransformObject = this.transformControl.object;
            if (this.isShiftDown && currentTransformObject && Object.keys(currentTransformObject).length === 0 && obj instanceof THREE.Mesh) {
                const initialMeshNode: THREE.Mesh = obj;
                let targetNodeForAttachment: THREE.Object3D = initialMeshNode;

                while (targetNodeForAttachment.parent && targetNodeForAttachment.parent.name !== "root" &&
                    !targetNodeForAttachment.userData?.issubproject &&
                    !targetNodeForAttachment.userData?.issheet) {
                    if (!targetNodeForAttachment.parent) break;
                    targetNodeForAttachment = targetNodeForAttachment.parent;
                }

                if (targetNodeForAttachment && (targetNodeForAttachment.userData?.issubproject || targetNodeForAttachment.userData?.issheet)) {
                    this.transformControl.setSpace("local");
                    this.transformControl.attach(targetNodeForAttachment);
                    this.transformControl.enabled = true;
                    this.transformControl.setMode('translate');
                    if (!this.transformControl.parent) {
                        this.scene.add(this.transformControl);
                    }
                    this.updateThreeFrame();
                }
            }
            try {

                if (Object.keys(this.transformControl.object).length !== 0 && !this.isShiftDown) {
                    this.transformControl.enabled = false;
                    this.transformControl.detach(this.transformControl.object);
                    console.log("detach", this.transformControl.object);
                    this.scene.remove(this.transformControl);
                }
            }
            catch (err) {
                console.warn(err);
            }


            if (ThreeUtils.isGltfNode(obj) && this.isControlDown || this.scenemode == "info") {
                try {

                    this.showObjectInfos = true;

                    var bb = ThreeUtils.gltfNodeBox(obj, this.scene);
                    console.log("gltf obj", obj, ThreeUtils.isGltfNode(obj), obj.name, intersects[0].point);
                    this.hoverObject = JSON.parse(JSON.stringify(obj)).object;
                    var m = JSON.parse(JSON.stringify((obj as THREE.Mesh).material));
                    this.hoverObject.material = m;
                    var m2 = JSON.parse(JSON.stringify(obj.position));
                    this.hoverObject.position = m2;
                    var normal = intersects[0].face?.normal;

                    var w = Math.round(bb.max.x - bb.min.x);
                    var h = Math.round(bb.max.y - bb.min.y);
                    var d = Math.round(bb.max.z - bb.min.z);

                    this.datasetsel = [
                        ["Name", obj.name, "", ""],
                        ["Position", intersects[0].point.x.toFixed(2), intersects[0].point.y.toFixed(2), intersects[0].point.z.toFixed(2)],
                        ["Normal", normal.x.toFixed(2), normal.y.toFixed(2), normal.z.toFixed(2)],
                        ["Size", w, h, d]
                    ];
                } catch (e) {
                    console.warn("gltf infos", e);
                }
                return;

            }

            while (obj?.userData?.isGltf) {
                obj = obj.parent;
                parent = obj;
            }


            this.mouse.x = e.clientX + 2;
            this.mouse.y = e.clientY - 35;
            if (obj?.parent?.userData?.isSheet) {
                this.cursorType = "pointer";

                if (obj?.parent?.userData?.rowParams["tooltip"]) {
                    this.overinfo = obj?.parent?.userData?.rowParams["tooltip"];
                } else {
                    this.overinfo = obj?.parent?.userData?.rowParams["tooltip"];
                }

                if (obj?.parent?.userData?.rowParams["tooltip"] == "") {
                    this.overinfo = null;
                }
            }

            if (obj?.parent?.userData?.subproject || obj?.parent?.parent?.userData?.subproject) {
                var projectpath = "root^$" + this.sheetid + "#" + obj.userData?.path?.split("^")[1];
                projectpath = projectpath?.replace('$' + this.sheetid + '$' + this.sheetid, '$' + this.sheetid);
                var nobj = null;

                if (obj?.parent?.userData?.subproject) {
                    nobj = obj.parent;
                }
                if (obj?.parent?.parent?.userData?.subproject) {
                    nobj = obj.parent.parent;
                }

                if (obj.parent.name == "root") {

                    nobj = this.scene.getObjectByName(projectpath);
                }
                else {

                }

                this.highlightproject = nobj;
                this.cursorType = "pointer";

            }
            else {
                this.highlightproject = null;
            }

        }
        else {
            if (this.hoveredFaceCenterSprite && this.hoveredFaceCenterOriginalMaterial) {
                this.hoveredFaceCenterSprite.material = this.hoveredFaceCenterOriginalMaterial;
                this.hoveredFaceCenterSprite = null;
                this.hoveredFaceCenterOriginalMaterial = null;
                this.updateThreeFrame();
            }
            this.highlightproject = null;
        }

        this.higlightProject();


        if (type == "MouseMove" && this.sceneobjectSceneSelected) {
        }
        if (type == "MouseDown" && this.sceneobjectSceneSelected) {
        }

        if (this.sceneobjectMouseOver != obj) {
            var jsfunction2 = this.sceneobjectMouseOver?.userData?.row[this.sceneobjectMouseOver?.userData?.commentrow.indexOf("MouseLeave")];
            if (jsfunction2) {
                var es = JSON.stringify(eventinfo);
                if (!es) es = "null";
                jsfunction2 = jsfunction2.replace("event", es);
                var ud: any = this.sceneobjectMouseOver;
                if (ud) ud = JSON.stringify(ud);
                else ud = "null";

                globalThis["leavedobject"] = this.sceneobjectMouseOver;
                jsfunction2 = jsfunction2.replace("object", "globalThis['leavedobject']");
                eval(this.project.scriptcode + "  " + jsfunction2 + ";");
            }
            this.sceneobjectMouseOver = null;
        }


        // neue beredchnung
        if (intersects.length > 0) {
            this.updateThreeFrame();
            obj = intersects[0].object;
            if (obj.parent?.parent?.userData?.gizmo) return; // Changed to userData.gizmo
            for (var i = 0; i < intersects.length; i++)
                if (!obj.userData?.commentrow)
                    if (intersects[i].object.visible)
                        obj = intersects[i].object;
            if (obj.parent?.parent?.userData?.gizmo) return; // Changed to userData.gizmo

            var parent = obj.parent;
            //   console.log("obj", obj.name);
            var eventinfo = {
                point: intersects[0].point,
                distance: intersects[0].distance,
                normal: intersects[0].face?.normal,
            }



            /*   if (type == "MouseDown") {
                if (this.sceneobjectSceneSelected && this.sceneobjectSceneSelected != obj && !obj.parent?.parent?.gizmo) {
                  // deselect
                  try {
                    console.log("deselected1", this.sceneobjectSceneSelected);
                    var jsfunction2b = this.sceneobjectSceneSelected?.userData?.row[this.sceneobjectSceneSelected?.userData?.commentrow.indexOf("DeSelected")];
                    if (jsfunction2b) {
                      var es = JSON.stringify(e);
                      if (!es) es = "null";
                      jsfunction2b = jsfunction2b.replace("event", es);
                      var ud = this.sceneobjectSceneSelected;
                      globalThis["sceneobjectDeSelected"] = ud;
                      if (ud) ud = JSON.stringify(ud);
                      else ud = "null";
                      jsfunction2b = jsfunction2b.replace("object", ud);
                      eval(this.project.scriptcode + "  " + jsfunction2b + ";");
                    }
                  } catch (ex) {
                    console.warn(ex);
                  }
                  this.sceneobjectSceneSelected = null;
                }
              } */

            if (obj?.userData?.commentrow) {
                //   console.log('scenemousemove', obj?.userData?.commentrow);

                if (type == "MouseMove") {
                    // Mouse-Handling unabhaening von definierten events auf sceneobjekte ------
                    if (this.sceneobjectMouseOver != obj) {

                        // mouseenter
                        //    console.log("mouseenter", obj);
                        var jsfunction3 = obj?.userData?.row[obj?.userData?.commentrow.indexOf("MouseEnter")];
                        if (jsfunction3) {
                            var es = JSON.stringify(eventinfo);
                            if (!es) es = "null";
                            jsfunction3 = jsfunction3.replace("event", es);
                            var ud: any = obj; // Explicitly type ud as any
                            var test = this.scene.getObjectByProperty('uuid', obj.uuid);
                            globalThis["enteredobject"] = obj;
                            if (ud) ud = JSON.stringify(ud);
                            else ud = "null";
                            jsfunction3 = jsfunction3.replace("object", "globalThis['enteredobject']");
                            eval(this.project.scriptcode + " " + jsfunction3 + ";"); // TODO: parameter ersetzen, position, userdata==objectdata, ...
                        }
                        this.sceneobjectMouseOver = obj;
                    }
                }
                if (type == "MouseDown" && !obj.parent?.parent?.userData?.gizmo && obj != this.sceneobjectSceneSelected) { // Changed to userData.gizmo
                    this.sceneobjectSceneSelected = obj;
                    globalThis["sceneobjectSelected"] = obj;
                    if (obj?.userData?.commentrow.indexOf("Selected") > -1) {
                        var jsfunctions = obj?.userData?.row[obj?.userData?.commentrow.indexOf("Selected")];
                        if (jsfunctions) {
                            var es = JSON.stringify(eventinfo);
                            if (!es) es = "null";
                            jsfunctions = jsfunctions.replace("event", es);
                            var ud: any = obj; // Explicitly type ud as any
                            if (ud) ud = JSON.stringify(ud);
                            else ud = "null";
                            jsfunctions = jsfunctions.replace("object", ud);
                            try {

                                eval(this.project.scriptcode + "  " + jsfunctions + ";"); // TODO: parameter ersetzen, position, userdata==objectdata, ...
                            } catch (ex) {
                                console.warn(ex);
                            }
                        }
                        return;
                    }
                }

                if (type == "MouseUp") {
                    this.vba.activateMouse();
                    // this.sceneobjectSelected = null;
                    // globalThis["sceneobjectMouseDown"] = null;
                }

                // alle ereignisse von Objekten -----
                if (obj?.userData?.commentrow.indexOf(type) > -1) {

                    var jsfunction = obj?.userData?.row[obj?.userData?.commentrow.indexOf(type)];
                    if (jsfunction) {
                        var es = JSON.stringify(eventinfo);
                        if (!es) es = "null";
                        jsfunction = jsfunction.replace("event", es);
                        var ud: any = obj; // Explicitly type ud as any
                        if (ud) ud = JSON.stringify(ud);
                        else ud = "null";
                        jsfunction = jsfunction.replace("object", ud);
                        eval(this.project.scriptcode + "  " + jsfunction + ";"); // TODO: parameter ersetzen, position, userdata==objectdata, ...
                    }
                    return;
                }
            }
            //  }
        } else {
            // keine intersection
            if (this.sceneobjectSceneSelected && type == "MouseUp") {
                // deselect 
                console.log("deselected2", this.sceneobjectSceneSelected);
                var jsfunction2b = this.sceneobjectSceneSelected?.userData?.row[this.sceneobjectSceneSelected?.userData?.commentrow.indexOf("DeSelected")];
                if (jsfunction2b) {
                    var es = JSON.stringify(e);
                    if (!es) es = "null";
                    jsfunction2b = jsfunction2b.replace("event", es);
                    var ud = this.sceneobjectSceneSelected;
                    globalThis["sceneobjectDeSelected"] = ud;
                    if (ud) ud = JSON.stringify(ud);
                    else ud = "null";
                    jsfunction2b = jsfunction2b.replace("object", ud);
                    eval(this.project.scriptcode + "  " + jsfunction2b + ";");
                }
                //  this.sceneobjectMouseOver = null;
            }
            if (this.sceneobjectMouseOver) {
                // mouseleave 
                //  console.log("mouseleave2", this.sceneobjectMouseOver);
                var jsfunction2 = this.sceneobjectMouseOver?.userData?.row[this.sceneobjectMouseOver?.userData?.commentrow.indexOf("MouseLeave")];
                if (jsfunction2) {
                    var es = JSON.stringify(e);
                    if (!es) es = "null";
                    jsfunction2 = jsfunction2.replace("event", es);
                    var ud = this.sceneobjectMouseOver;

                    if (ud) ud = JSON.stringify(ud);
                    else ud = "null";
                    jsfunction2 = jsfunction2.replace("object", ud);
                    eval(this.project.scriptcode + "  " + jsfunction2 + ";");
                }
                this.sceneobjectMouseOver = null;
            }

        }
        this.updateThreeFrame();
    }


    selectedSubprojectID = null;
    selectedSubprojectPath = null;
    meshes: any;
    isMainConfig = true;
    sheetSelected = false;
    sheetNode = null;
    uihead = "";
    async sceneClick(e) {
        console.log('[EditorComponent] sceneClick called, delegating to InteractionManager', {
            hasInteractionManager: !!this.interactionManager,
            eventType: e.type,
            eventTarget: e.target?.tagName,
            clientX: e.clientX,
            clientY: e.clientY,
            timestamp: Date.now()
        });

        // Store the click event for menu positioning
        this.lastClickEvent = e;

        // Delegate to InteractionManager
        if (this.interactionManager) {
            console.log('[EditorComponent] Calling InteractionManager.sceneClick');
            try {
                // Adjust position before calling interaction manager
                const adjustedPosition = this.adjustMenuPosition(e.clientX, e.clientY);
                e.adjustedX = adjustedPosition.left;
                e.adjustedY = adjustedPosition.top;

                await this.interactionManager.sceneClick(e);
                console.log('[EditorComponent] InteractionManager.sceneClick completed successfully');


            } catch (error) {
                console.error('[EditorComponent] Error in InteractionManager.sceneClick:', error);
                throw error;
            }
        } else {
            console.warn('[EditorComponent] InteractionManager not available, sceneClick ignored');
        }
    }



    cellChanges2dataset(cellchanges: any[]) {
        for (var i = 0; i < cellchanges?.length; i++) {
            var a = cellchanges[i].address;
            if (a)
                this.dataset[a.row][a.col] = cellchanges[i].newValue;
        }
    }

    async subprojectSelected() {
        // Delegate to InteractionManager
        if (this.interactionManager) {
            await this.interactionManager.subprojectSelected();
        } else {
            console.warn('[EditorComponent] InteractionManager not available for subprojectSelected');
        }
    }


    gridchange() {
        this.sceneManager.gridchange(this.project.sceneSettings.showGrid);
    }

    async logout() {
        var r = await this.auth.signOut();
        console.log('logout', r);
        this.router.navigate(['login']);
    }

    mouseWheel(event) {
        this.sceneManager.mouseWheel(event, this.threecontainerwidth, this.project);
    }


    handleAngleChange(angle: number) {
        console.log('Angle changed to:', angle);
        //   this.baseScene.dirLight.position.set(Math.cos(angle) * 2000, Math.sin(angle) * 2000, 1000.75);
        //    this.baseScene.dirLight.position.set(-1, -1.45, 1.75);

        //   this.baseScene.dirLightHelper.parent.updateMatrixWorld();
        // this.baseScene.dirLightHelper.update();
        this.project.sceneSettings.dirAngle = angle;
        this.updateScene(null);
        this.updateThreeFrame();
    }

    changeHandling() {
        console.log('changeHandling', this.project.settings.subprojectSelectable, this.project.cameraPan, this.project.settings.midpontNavigation);
        if (this.project.settings.subprojectSelectable) {
        }
        // if (this.chkCameraPan) {
        this.controls.enablePan = this.project.settings.cameraPan;

        this.controls.enableZoom = this.project.settings.cameraZoom;
    }

    isLocalhost() {
        return location.hostname === 'localhost';
    }
    // composer: EffectComposer;
    animate(time) {
        if (!this.scene) return;
        requestAnimationFrame(this.animate.bind(this));

        this.animateFrameCount++;

        // Debug: Log animate function calls occasionally
        if (this.animateFrameCount % 120 === 0) { // Log every 120 frames (roughly 2 seconds at 60fps)
            console.log('[ANIMATE DEBUG] Frame', this.animateFrameCount, 'scene exists:', !!this.scene, 'camera exists:', !!this.camera);
        }

        // Update face center sprite scales based on camera distance
        this.scene.traverse((object) => {
            if (object.userData.type === "refpoint" && object instanceof THREE.Sprite) {
                // Get world position of sprite for accurate distance calculation
                const worldPosition = new THREE.Vector3();
                object.getWorldPosition(worldPosition);

                // Get distance from camera to sprite world position
                const distance = this.camera.position.distanceTo(worldPosition);

                // Scale based on distance with adjusted base size
                const scale = Math.max(distance * 0.02, 5);  // Minimum scale of 5 to ensure visibility
                object.scale.set(scale, scale, 1);
            }
        });

        // Update connector proximity effects
        this.updateConnectorProximityEffect();

        // Rest of animate code...
        if (this.stats) this.stats.begin();
        if (this.controls) this.controls.update();
        if (this.transformControl) this.transformControl.update();

        // Update camera flight animations
        if (this.cameraFlight) {
            // Update TWEEN animations with timestamp
            TWEEN.update(time);
            this.cameraFlight.update();

            // Debug camera position during flight
            if (this.cameraFlight.isPlaying && Math.random() < 0.01) {
                console.log("Camera position during flight:", this.camera.position.clone());
            }
        }

        if (this.composer && this.viewHelper) {
            this.composer.render();
            this.viewHelper.render(this.renderer);
        }
        else
            if (this.renderer && this.scene && this.camera)
                this.renderer.render(this.scene, this.camera);

        this.viewportGizmo?.update();
        this.viewportGizmo?.render();

        if (this.stats) this.stats.end();

        // Update timers
        if (this.timersEnabled) {
            this.clocks.forEach((clock) => {
                if (clock.running) {
                    const delta = clock.getDelta();
                    const elapsed = clock.getElapsedTime();
                    this.timerfunction({ delta: delta, elapsed: elapsed }, clock);
                }
            });
        }
    }

    async takeScreenshot(overwrite: boolean = false) {
        await this.exportManager.takeScreenshot(overwrite);
    }
    updateThreeFrame() {
        this.sceneManager.updateThreeFrame();
    }

    raycaster = null;
    mouse = new THREE.Vector2();
    INTERSECTED = null;
    agentpanelwidth = 0;
    mousemove(event: any) {
        this.updateThreeFrame();
        var container = document.getElementById("threecontainer");
        this.camera.aspect = container.clientWidth / container.clientHeight;
        this.mouse.x = (event.layerX / container.clientWidth) * 2 - 1;
        this.mouse.y = -(event.layerY / container.clientHeight) * 2 + 1;

        // Update mouse screen position
        this.mouseScreenPosition = [event.clientX, event.clientY];
    }
    async splitDragEnd(x: any) {
        try {
            console.log('splitDragEnd', x);
            // Calculate panel widths for three split areas
            this.leftpanelwidth = Math.round(Number(x.sizes[0]) / 100 * window.innerWidth) * 1 / 1.0;
            this.threecontainerwidth = Math.round(Number(x.sizes[1]) / 100 * window.innerWidth) * 1 / 1.0;
            this.agentpanelwidth = Math.round(Number(x.sizes[2]) / 100 * window.innerWidth) * 1 / 1.0;
            this.splitleft = Number(x.sizes[0] * 1 / 1.0);

            // Save split sizes to project settings
            if (this.project && this.project.settings) {
                this.project.settings.splitSizes = {
                    left: x.sizes[0],
                    middle: x.sizes[1],
                    right: x.sizes[2]
                };
                console.log('Saved split sizes to project:', this.project.settings.splitSizes);
            }

            // Get container and ensure it exists
            const container = document.getElementById("threecontainer");
            if (!container) throw new Error("Container 'threecontainer' not found");

            // Update container style if needed
            container.style.width = `${this.threecontainerwidth}px`;

            if (this.camera instanceof THREE.OrthographicCamera) {
                const aspect = this.threecontainerwidth / container.clientHeight;
                const currentZoom = this.camera.zoom;

                // Store initial size only once when first switching to orthographic
                if (this.initialFrustumSize === null) {
                    this.initialFrustumSize = this.camera.top - this.camera.bottom;
                }

                // Always use the initial size for calculations
                const size = this.initialFrustumSize;

                // Update all frustum planes using the initial size
                this.camera.left = -size * aspect / 2;
                this.camera.right = size * aspect / 2;
                this.camera.top = size / 2;
                this.camera.bottom = -size / 2;

                this.camera.zoom = currentZoom;
            } else {
                // Handle perspective camera
                this.camera.aspect = this.threecontainerwidth / container.clientHeight;
            }

            this.camera.updateProjectionMatrix();
            this.renderer.setSize(this.threecontainerwidth, container.clientHeight);
            this.renderer.autoClear = false;
            this.renderer.setClearColor(0x000000, 0.0);

            await this.setVars();

            if (this.isEditMode) {
                this.hot?.refreshDimensions();
                this.hot?.render();
            }

            if (this.viewportGizmo) {
                //    (this.viewportGizmo as any).left = this.threecontainerwidth - 128;
                //  this.viewportGizmo.left = this.threecontainerwidth - 128;
            }

            this.updateThreeFrame();
        } catch (error) {
            console.warn("splitDragEnd error:", error);
        }
    }

    async setVars() {

        try {

            // API vars
            var changes = await this.excels[this.PROJECT].changeNamedExpression('screensize', this.threecontainerwidth + "," + window.innerHeight);
            console.log('setvars changes', changes);

            this.updateHotChanges(changes);

            var changes2 = await this.excels[this.PROJECT].changeNamedExpression('screenwidth', this.threecontainerwidth);
            this.updateHotChanges(changes2);
            var changes3 = await this.excels[this.PROJECT].changeNamedExpression('screenheight', window.innerHeight);
            this.updateHotChanges(changes3);
            // TODO
            // var changes4 = await this.excels[this.PROJECT].addNamedExpression('window.height', 123);
            // this.updateHotChanges(changes4);
            // var changes5 = await this.excels[this.PROJECT].changeNamedExpression('window_width', 234324);
            // this.updateHotChanges(changes5);


            var dataset = this.dataset;
            var sheetid = this.sheetid; //TODO: muss nicht stimmen!

            var allchanges = changes.concat(changes2).concat(changes3);

            // TODO: update model/  verweise => setcontens
            for (var j = 0; j < allchanges?.length; j++) {
                var a = allchanges[j].address;
                if (a)
                    if (dataset[a.row][1] != null && dataset[a.row][1] != "" && a.row > this.outputrow && dataset[a.row][0] != "#") {

                        var typ = dataset[a.row][1];
                        var objectname = "$" + sheetid + "#" + dataset[a.row][0];
                        var commentrow = SheetHelper.getCommentRow(dataset, a.row); // dataset[a.row - 1]

                        if (this.isInList(this.overlayTypes, typ)) {
                            // 2d overlays 
                            var overlay = await this.updateOverlay(j, objectname, dataset[a.row], commentrow, typ);
                        }
                        else {
                            //    var newnode = await this.cad.createOrUpdateCADNode(a.row, sheetid, objectname, dataset[a.row], commentrow, scenenode, this.excels, this.selectedSubprojectID, this.toload, this.workers, this.customerid, this.projectid, this.project.configModel);
                        }
                    }
            }
        }
        catch (e) {
            console.log(e);
        }
    }


    refnames = [];
    refnames2 = [];
    async formulaChange(event: any) {
        console.log("formulaChange", this.formula);
        try {
            this.refnames = [];
            // bezeichnungen aus referenzen
            var cellValue = this.formula;
            if (cellValue) {
                this.refs = Utils.getCellReferences(cellValue);
                for (var i = 0; i < this.refs?.length; i++) {
                    var ref = this.refs[i];
                    var cellAddress = await this.excels[this.PROJECT].simpleCellAddressFromString(ref, this.sheetid);
                    var cell = await this.excels[this.PROJECT].getCellValue(cellAddress);
                    this.outputrow = SheetHelper.getOutputRow(this.dataset);
                    if (cellAddress.row > this.outputrow) {
                        var c = { sheet: this.sheetid, row: cellAddress.row, col: 0 };
                        var rightCellValue = await this.excels[this.PROJECT].getCellValue(c);
                    } else {
                        var c = { sheet: this.sheetid, row: cellAddress.row, col: 5 };
                        var rightCellValue = await this.excels[this.PROJECT].getCellValue(c);
                    }
                    if (!this.refnames.includes(ref + ": " + rightCellValue)) {
                        this.refnames.push(ref + ": " + rightCellValue);
                    }
                }




            }

            //  this.applyCellMeta();

        } catch (error) {
            console.warn('Error in afterSelection:', error);
        }
    }

    private updateHotChanges(changes) {
        if (changes)
            for (var j = 0; j < changes.length; j++) {
                var change = changes[j];
                var cellAddress = change.address;
                var cellValue = change.newValue;
                if (cellAddress)
                    this.dataset[cellAddress.row][cellAddress.col] = cellValue;
            }

    }
    openfunctionsdialog() {

        const dialogRef = this.dialog.open(DialogfunctionsComponent, {
            width: '980px',
            data: {
            }
        });

    }
    restrictMove = false
    selectedName = "";
    selectedNode: any;

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    /// --- für javascript api vbaapi
    async getactiveconfig() {
        var configModel = await this.createConfigModel();
        console.log('getactiveconfig', configModel);
        console.log('projectconfig', this.project.configmodel);
        return configModel;
    }
    async overwriteconfig() {
        var configModel = await this.createConfigModel();
        this.project.configmodel = configModel;
        console.log('overwriteconfig', this.project.configmodel);
    }

    async saveconfig(id?: string) {
        console.log("save config", this.project.type);
        if (this.project.type && this.project.type.includes("public")) {
            try {
                var configModel = await this.createConfigModel();
                this.project.configmodel = configModel;
                const dialogRef = this.dialog.open(DialogsaveconfigComponent, {
                    width: '980px',
                    data: {
                        configModel: JSON.parse(JSON.stringify(configModel)),
                        project: JSON.parse(JSON.stringify(this.project)),
                        projectid: this.projectid
                    },
                });

                dialogRef.afterClosed().subscribe(async result => {
                    console.log('The dialog was closed', result);
                    if (result) {
                        configModel.enduserdata = JSON.parse(JSON.stringify(result));

                        // Generate a short ID for the config
                        const configid = Utils.generateShortId();

                        // Use the generated short ID for the document
                        var r = await this.afs.collection("configs/" + this.customerid + "/" + this.projectid).doc(configid).set(
                            JSON.parse(JSON.stringify(configModel)));
                        var text = "";
                        console.log("config saved with ID:", configid);

                        // Save last config time to project
                        this.project.lastConfigTime = new Date().toISOString();

                        // Update the project document with the new lastConfigTime
                        await this.afs.collection("projectspublic").doc(this.projectid).update({
                            lastConfigTime: this.project.lastConfigTime
                        });

                        console.log("Updated project with lastConfigTime:", this.project.lastConfigTime);

                        // save glb and collada
                        //   var blob = Utils.saveGltf(this.scene, this.projectid, this.customerid, configid, this.afs);

                        if (result.mail && this.project.userformsendmail) {
                            console.log("send mail");
                            var text = "You will receive an email shortly with your configuration.";
                            // // send maill 

                            // Prepare email data from project properties
                            let mailSubject = this.project.usermailsubject || "Your Configuration";
                            let mailText = this.project.usermailtext || "You can download your configuration from the link below:";
                            const configUrl = `https://app.confbuild.com/p/${this.projectid}/${configid}`;
                            mailText = mailText.replace(/%link%/g, configUrl);
                            if (!mailText.includes('app.confbuild.com/p/')) {
                                mailText += " <a href='https://app.confbuild.com/p/" + this.projectid + "/" + configid + "'>" + 'https://app.confbuild.com/p/' + this.projectid + '/' + configid + "</a>";
                            }

                            this.http.post('https://us-central1-xbuild3d.cloudfunctions.net/sendMail', {
                                topic: mailSubject,
                                receiver: result.mail,
                                msg: mailText
                            }).subscribe(result => {
                                console.log("mail sent", result);
                            });

                        }
                        this.snackBar.open("Configuration saved. " + text + " " + configid, "", { duration: 5000 });
                    }
                });
            } catch (error) {
                console.error('Error saving configuration:', error);
                this.snackBar.open("Error saving configuration: " + error.message, "", { duration: 5000 });
            }
        } else {
            // Handle private project configuration
            var configModel = await this.createConfigModel();
            this.project.configmodel = configModel;
            const dialogRef = this.dialog.open(DialogsaveconfigComponent, {
                width: '980px',
                data: {
                    configModel: configModel,
                    project: this.project,
                    projectid: this.projectid
                },
            });

            dialogRef.afterClosed().subscribe(async result => {
                console.log('The dialog was closed', result);
                if (result) {
                    configModel.enduserdata = JSON.parse(JSON.stringify(result));

                    // Generate a short ID for the config
                    const configid = Utils.generateShortId();

                    // Use the generated short ID for the document
                    var r = await this.afs.collection("configs/" + this.customerid + "/" + this.projectid).doc(configid).set(
                        JSON.parse(JSON.stringify(configModel)));
                    var text = "";
                    console.log("config saved with ID:", configid);

                    // Save last config time to project
                    this.project.lastConfigTime = new Date().toISOString();

                    // Update the project document with the new lastConfigTime
                    await this.afs.collection("projectspublic").doc(this.projectid).update({
                        lastConfigTime: this.project.lastConfigTime
                    });

                    console.log("Updated project with lastConfigTime:", this.project.lastConfigTime);

                    // save glb and collada
                    //   var blob = Utils.saveGltf(this.scene, this.projectid, this.customerid, configid, this.afs);

                    if (result.mail && this.project.userformsendmail) {
                        console.log("send mail");
                        var text = "You will receive an email shortly with your configuration.";
                        // // send maill 

                        // Prepare email data from project properties
                        let mailSubject = this.project.usermailsubject || "Your Configuration";
                        let mailText = this.project.usermailtext || "You can download your configuration from the link below:";
                        if (!mailText.includes('app.confbuild.com/p/')) {
                            mailText += " <a href='http://app.confbuild.com/p/" + this.projectid + "/" + configid + "'>" + configid + "</a>";
                        }
                        // Replace %link% placeholder in mailText with the actual configuration URL
                        const configUrl = `http://app.confbuild.com/p/${this.projectid}/${configid}`;
                        mailText = mailText.replace(/%link%/g, configUrl);

                        // Check if mail sending is enabled in project settings
                        if (this.project.userformsendmail) {
                            console.log("Sending mail with custom subject and text from project settings");
                        } else {
                            console.log("Using default mail template");
                        }


                        this.http.post('https://us-central1-xbuild3d.cloudfunctions.net/sendMail', {
                            topic: mailSubject,
                            receiver: result.mail,
                            msg: mailText
                        }).subscribe(result => {
                            console.log("mail sent", result);
                        });

                    }
                    this.snackBar.open("Configuration saved. " + text + " " + configid, "", { duration: 5000 });
                }
            });
        }
    }


    setIsometricView(initial: boolean = false) {
        this.sceneManager.setIsometricView(initial);
        // Update the reference to the camera after switching
        this.camera = this.sceneManager.camera;
        this.controls = this.sceneManager.controls;
    }

    resetToPerspective() {
        this.sceneManager.resetToPerspective();
        // Update the reference to the camera after switching
        this.camera = this.sceneManager.camera;
        this.controls = this.sceneManager.controls;
    }
    async loadconfig(configid) { // TODO
        var r = await this.afs.collection("configs/" + this.customerid + "/" + this.projectid).doc(configid).get();
        return r;
    }
    /// --- für javascript api vbaapi ende


    running = false;
    async controlC(val: any) {
        if (!this.project) return;

        // Handle GUI changes that don't have sheet context
        if (val.source === 'gui' && !val.sheet && val.controlName) {
            // Provide default sheet context for GUI controls
            val.sheet = {
                sheet: this.sheetid,
                row: -1, // Will be found by control name search
                col: -1  // Will be found by control name search
            };
        }

        // Initialize userinputs in configmodel if it doesn't exist
        if (!this.project?.configmodel) {
            this.project.configmodel = {};
        }
        if (!this.project?.configmodel?.userinputs) {
            this.project.configmodel.userinputs = {};
        }

        // Store user input in configmodel with correct path
        if (val.controlName) {
            let path = this.selectedNode?.userData?.path;
            if (!path && this.selectedProjectName === "Main") {
                path = "root";
            }
            if (path?.startsWith("^")) {
                path = "root" + path;
            }

            const inputPath = path ? `${path}^${val.controlName}` : val.controlName;

            this.project.configmodel.userinputs[inputPath] = {
                value: val.outputValue,
                type: val.typ,
                timestamp: new Date().toISOString(),
                sheetid: this.sheetid
            };
        }

        console.log('project.configmodel', this.project.configmodel);

        // nur zumtetst    
        if (val.typ == "BUTTON" && val.outputValue == "save") {
            if (!this.isEditMode) {
                var configModel = await this.createConfigModel();
                this.project.configmodel = configModel;
                const dialogRef = this.dialog.open(DialogsaveconfigComponent, {
                    width: '980px',
                    data: {
                        configModel: configModel,
                        project: this.project,
                        projectid: this.projectid
                    },
                });

                dialogRef.afterClosed().subscribe(async result => {
                    console.log('The dialog was closed', result);
                    if (result) {
                        configModel.enduserdata = JSON.parse(JSON.stringify(result));

                        // Generate a short ID for the config
                        const configid = Utils.generateShortId(4);

                        // Use the generated short ID for the document
                        var r = await this.afs.collection("configs/" + this.customerid + "/" + this.projectid).doc(configid).set(
                            JSON.parse(JSON.stringify(configModel)));
                        var text = "";
                        console.log("config saved with ID:", configid);
                        // var configid = r.id;
                        console.log("config saved", r);

                        // Save last config time to project
                        this.project.lastConfigTime = new Date().toISOString();

                        // Update the project document with the new lastConfigTime
                        await this.afs.collection("projectspublic").doc(this.projectid).update({
                            lastConfigTime: this.project.lastConfigTime
                        });

                        console.log("Updated project with lastConfigTime:", this.project.lastConfigTime);

                        // save glb and collada
                        //   var blob = Utils.saveGltf(this.scene, this.projectid, this.customerid, configid, this.afs);

                        if (result.mail && this.project.userformsendmail) {
                            console.log("send mail");
                            var text = "You will receive an email shortly with your configuration.";
                            // // send maill 

                            // Prepare email data from project properties
                            let mailSubject = this.project.usermailsubject || "Your Configuration";
                            let mailText = this.project.usermailtext || "You can download your configuration from the link below:";
                            if (!mailText.includes('app.confbuild.com/p/')) {
                                mailText += " <a href='http://app.confbuild.com/p/" + this.projectid + "/" + configid + "'>" + configid + "</a>";
                            }
                            // Replace %link% placeholder in mailText with the actual configuration URL
                            const configUrl = `http://app.confbuild.com/p/${this.projectid}/${configid}`;
                            mailText = mailText.replace(/%link%/g, configUrl);

                            // Check if mail sending is enabled in project settings
                            if (this.project.userformsendmail) {
                                console.log("Sending mail with custom subject and text from project settings");
                            } else {
                                console.log("Using default mail template");
                            }


                            this.http.post('https://us-central1-xbuild3d.cloudfunctions.net/sendMail', {
                                topic: mailSubject,
                                receiver: result.mail,
                                msg: mailText
                            }).subscribe(result => {
                                console.log("mail sent", result);
                            });

                        }
                        this.snackBar.open("Configuration saved. " + text + " " + configid, "", { duration: 5000 });
                    }
                });
            }
        }
        if (val.typ == "BUTTON" && val.outputValue == "export") {
            console.log("exportScene");
            this.exportManager.exportScene();
            return;
        }
        if (val.typ == "BUTTON" && (val.outputValue != "save" && val.outputValue != "export")) {
            console.log("BUTTON", this.project.scriptcode);
            eval(this.project.scriptcode + "  " + val.onclick + ";    console.log('excels. ', this.project)");
            //      eval(val.onclick)
            return;
        }
        if (val.typ == "CHECKBOX") {
            val.outputValue = !val.outputValue;
        }
        if (val.typ == "RADIO") {
            // For radio buttons with selectOptions (image/value radio buttons), preserve the selected value
            // For traditional boolean radio buttons, use true/false logic
            const preserveSelectedValue = val.selectOptions && Array.isArray(val.selectOptions) && val.selectOptions.length > 0;
            const selectedValue = preserveSelectedValue ? val.outputValue : true;

            console.log('🔘 [Editor controlC] Radio button value handling:', {
                controlName: val.controlName,
                cell: val.cell,
                hasSelectOptions: !!val.selectOptions,
                selectOptionsLength: val.selectOptions?.length || 0,
                preserveSelectedValue: preserveSelectedValue,
                currentOutputValue: val.outputValue,
                finalValue: selectedValue
            });

            // Set other radio buttons in group to false
            var r = val.sheet.row - 1;
            while (r >= 0 && this.cellformulas[r] && this.cellformulas[r][1]?.indexOf("radio") > -1) {
                this.cellformulas[r][2] = false;
                this.dataset[r][2] = false;
                var cell = JSON.parse(JSON.stringify(val.sheet)); cell.row = r;
                await this.sheetChange(cell, false, true, false, false);
                r--;
            }
            r = val.sheet.row + 1;
            while (r < this.cellformulas.length && this.cellformulas[r] && this.cellformulas[r][1]?.indexOf("radio") > -1) {
                this.cellformulas[r][2] = false;
                this.dataset[r][2] = false;
                var cell = JSON.parse(JSON.stringify(val.sheet)); cell.row = r;
                await this.sheetChange(cell, false, true, false, false);
                r++;
            }

            // Set the final value - preserve selectOptions value or use true for boolean radio
            val.outputValue = selectedValue;
            //       this.cellformulas[cell.row][cell.col] = false;
            //      await this.sheetChange(cell, v, v);

        }

        var cell = val.sheet;
        if (cell) {
            // Use cellValue if provided (for image select), otherwise use outputValue
            var valtemp = val.cellValue || val.outputValue;
            var v = null;
            if (!isNaN(valtemp))
                var f = parseFloat(valtemp);
            if (isNaN(f))
                v = valtemp
            else
                v = f;

            // If row/col are -1 (from GUI), find them by control name
            if (cell.row === -1 || cell.col === -1) {
                try {
                    // Search for the control name in the sheet to find its position
                    const searchResult = await Utils.searchCellByValue(this.excels[this.PROJECT],
                        { col: 0, row: 0, sheet: cell.sheet }, val.controlName, 0);
                    if (searchResult) {
                        cell.row = searchResult.row;
                        cell.col = searchResult.col + 1; // Value is typically in next column
                    }
                } catch (error) {
                    console.warn('Could not find cell position for control:', val.controlName, error);
                    return; // Skip update if we can't find the cell
                }
            }

            // untersheet aktiviert -> Wert von UI als Parameter in Mainsheet
            if (this.sheetSelected) {// && this.isEditMode) {
                cell.sheet = this.sheetid;
                var paramname = val.controlName;
                cell.row = this.sheetNode.userData.rowindex;

                // search col for paramname
                var ca1 = await Utils.searchCellByValue(this.excels[this.PROJECT], { col: 0, row: cell.row, sheet: cell.sheet }, "#", 1);
                cell.col = (await Utils.searchCellByValue(this.excels[this.PROJECT], { col: 0, row: ca1.row, sheet: ca1.sheet }, paramname, 2))?.col;

                //var address = await Utils.searchControlNameAddress(this.excels[this.PROJECT], paramname);

            }
            if (this.isMainConfig && this.isEditMode && cell.row >= 0 && cell.col >= 0)
                this.cellformulas[cell.row][cell.col] = v;


            var exportedchanges = await this.sheetChange(cell, v, v);
            //  this.jsongui = await this.excels[this.PROJECT].createJsonGUI(this.sheetid);
            //  this.valueSubject.next(v);
        }


    }

    openDialog(): void {
        // this.saveproject();

        const dialogRef = this.dialog.open(PublishDialog, {
            width: '1100px',
            height: '615px',
            data: { project: this.project, userid: this.customerid, dataset: this.dataset } // Pass dataset here
            //   data: { name: this.name, animal: this.animal },
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed', result);
        });
    }

    openMenuDialog(): void {
        const dialogRef = this.dialog.open(DialogmenuComponent, { width: '980px', height: '615px', data: { project: this.project, userid: this.customerid } });
        dialogRef.afterClosed().subscribe(result => { console.log('The dialog was closed', result); });
    }

    openSubProjectDialog(): void {
        const dialogRef = this.dialog.open(DialogsubprojectComponent, {
            width: '980px', data: { excels: this.excels, hf: this.hf, sheetid: this.sheetid, showAnimations: this.project.sceneSettings.showAnimations, PROJECT: this.PROJECT, dataset: this.dataset },
        });

        dialogRef.afterClosed().subscribe(result => { console.log('project dialog was closed', result); });
    }

    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
    showfilesDialog(filter, edit = false, primitive = false) {
        const dialogRef = this.dialog.open(FilesDialog, { width: '1250px', height: '95%', data: { filter: filter }, });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed', result);

            if (result) {
                this.copyMessage(result)

                // hack
                if (filter == "png")
                    if (!edit)
                        if (primitive)
                            this.addPrimitive('image3d', result)
                        else
                            this.addGui('image', result)

                if (edit)
                    this.cellSelected = result;

            }
            if (filter == "gltf") {
                if (!edit)
                    this.addPrimitive('gltf', result);
                if (edit) {

                    var cell = { row: this.curSelectedRow, col: this.curSelectedCol, sheet: this.sheetid };
                    this.sheetChange(cell, [[result]], [[result]], true);
                }
            }

        });

    }
    async showmaterialsDialog(baseScene, selected) {
        // Prevent material dialog from showing if cube dialog is already showing
        if (this.isShowingCubeDialog) {
            return;
        }

        const dialogRef = this.dialog.open(MaterialbComponent, { width: '800px', data: { baseScene: baseScene, val: selected }, });

        dialogRef.afterClosed().subscribe(async result => {
            console.log('The dialog was closed', result);
            if (result) {
                var sc = this.hot.getSelected();
                var col = sc[0][1];
                var row1 = sc[0][0];
                var changes = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, col: col, row: row1 }, result);
                this.dataset[row1][col] = result;
                this.cellformulas[row1][col] = result;
                this.sheetChange({ sheet: this.sheetid, row: row1, col: col }, result, result);

                this.hot.render();
                // todo applyc
            }
        });

    }

    async showshapeDialog(data = null) {
        var selected = data;
        var test = this.hot.getSelected();
        if (!selected) {
            selected = this.dataset[this.hot.getSelected()[0][0]][this.hot.getSelected()[0][1]];
        }

        const dialogRef = this.dialog.open(DialogshapeComponent, { width: '1150px', data: { value: selected, }, });

        dialogRef.afterClosed().subscribe(async result => {
            console.log('The dialog was closed', result);
            if (result) {

                var ij = result.cellref;
                // var changes = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, col: ij[1], row: ij[0] }, result.val);

                ///////
                // Add spline parameters if they don't exist
                // const splineDivisionsCol = await this.excels[this.PROJECT].findColumnByHeader(this.sheetid, 'splineDivisions');
                // const splinePathCol = await this.excels[this.PROJECT].findColumnByHeader(this.sheetid, 'splinePath');

                // if (splineDivisionsCol === -1) {
                //   // Add splineDivisions column if it doesn't exist
                //   const newCol = this.dataset[0].length;
                //   this.dataset[0].push('splineDivisions');
                //   this.cellformulas[0].push('splineDivisions');
                //   await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, col: newCol, row: 0 }, 'splineDivisions');
                // }

                // if (splinePathCol === -1) {
                //   // Add splinePath column if it doesn't exist
                //   const newCol = this.dataset[0].length;
                //   this.dataset[0].push('splinePath');
                //   this.cellformulas[0].push('splinePath');
                //   await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, col: newCol, row: 0 }, 'splinePath');
                // }

                // // Set the values for each row in the copied table
                // for (let i = 0; i < result.td.length; i++) {
                //   const rowIndex = ij[0] + i;
                //   const splineDivisionsColIndex = splineDivisionsCol === -1 ? this.dataset[0].length - 2 : splineDivisionsCol;
                //   const splinePathColIndex = splinePathCol === -1 ? this.dataset[0].length - 1 : splinePathCol;

                //   // Set splineDivisions value
                //   await this.excels[this.PROJECT].setCellContents(
                //     { sheet: this.sheetid, col: splineDivisionsColIndex, row: rowIndex },
                //     30
                //   );
                //   this.dataset[rowIndex][splineDivisionsColIndex] = 30;
                //   this.cellformulas[rowIndex][splineDivisionsColIndex] = 30;

                //   // Set splinePath value
                //   await this.excels[this.PROJECT].setCellContents(
                //     { sheet: this.sheetid, col: splinePathColIndex, row: rowIndex },
                //     '(0,0);(100,0);(200,100);(0,100)'
                //   );
                //   this.dataset[rowIndex][splinePathColIndex] = '(0,0);(100,0);(200,100);(0,100)';
                //   this.cellformulas[rowIndex][splinePathColIndex] = '(0,0);(100,0);(200,100);(0,100)';
                // }

                // for (var i = 0; i < result.td.length; i++)
                //   for (var j = 0; j < result.td[i].length; j++) {
                //     this.dataset[ij[0] + i][ij[1] + j] = result.td[i][j];
                //     this.cellformulas[ij[0] + i][ij[1] + j] = result.td[i][j];
                //     //   this.sheetChange({ sheet: this.sheetid, row: ij[0] + i, col: ij[1] + j }, result.td[i][j], result.td[i][j]);
                //   }
                /////

                // this.sheetChange({ sheet: this.sheetid, row: row1, col: col }, result.val, result.val);
            }

            var sc = this.hot.getSelected();
            var col = sc[0][1];
            var row1 = sc[0][0];



            var changes = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, col: col, row: row1 }, result.val);
            this.dataset[row1][col] = result.val;
            this.cellformulas[row1][col] = result.val;
            this.sheetChange({ sheet: this.sheetid, row: row1, col: col }, result.val, result.val);
            this.hot.render();


        });

    }

    private lastSaveTime: number = Date.now();
    public isSaving = false;  // Add new flag for saving state
    public saveSuccess = false; // Add new flag for save success animation
    public processingMessage = ''; // Track the current processing message
    public isCloning = false; // Flag for clone operation loading state

    // Update this whenever you save
    private updateLastSaveTime() {
        this.lastSaveTime = Date.now();
    }

    // Call this in your save method
    async save() {
        if (this.isSaving) return;  // Prevent multiple simultaneous saves

        this.isSaving = true;
        try {
            await this.saveproject();  // Your existing save logic
            this.updateLastSaveTime();
            if (!this.project?.image) {
                console.log('Project image not found, taking initial screenshot during save.');
                // Use the core screenshot logic directly to avoid recursion with takeScreenshot()
                // Pass false for the 'overwrite' parameter to ensure we only create if missing.
                this.screenshotService2.takeScreenshot(this.scene, this.camera, this.renderer, this.projectid, this.customerid, this.project, this.afs, false);
                // Note: Depending on how ScreenshotService2 updates the project data,
                // you might need to manually refresh this.project or handle async updates if required later.
            }
            this.saveSuccess = true;
            setTimeout(() => {
                this.saveSuccess = false;
            }, 2000); // Reset after 2 seconds
        } finally {
            this.isSaving = false;
        }
    }

    canDeactivate(): Observable<boolean> | boolean {
        // If navigation was already confirmed through our router events handler, allow it
        if (this.deactivating.observers.length > 0) {
            return this.deactivating.asObservable();
        }

        const timeSinceLastSave = Date.now() - this.lastSaveTime;
        if (timeSinceLastSave > 10000) {
            // Only show dialog if it wasn't already shown by router events
            const dialogRef = this.dialog.open(ConfirmLeaveDialogComponent, {
                width: '400px',
                disableClose: true,
                data: { timeSinceLastSave: Math.floor(timeSinceLastSave / 1000) }
            });

            dialogRef.afterClosed().subscribe(result => {
                this.deactivating.next(result);
                this.deactivating.complete();
            });

            return this.deactivating.asObservable();
        }

        return true;
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        const timeSinceLastSave = Date.now() - this.lastSaveTime;
        if (timeSinceLastSave > 10000) {
            // This empty string is required to prevent the browser dialog in some browsers
            $event.returnValue = '';
            return '';
        }
        return null;
    }

    private handleNavigation(allow: boolean) {
        if (allow) {
            this.deactivating.next(true);
            this.deactivating.complete();
            window.history.back();
        } else {
            this.deactivating.next(false);
            this.deactivating.complete();
            // Stay on current page
            history.pushState(null, '', window.location.pathname);
        }
    }

    ngOnDestroy() {
        if (this.interactionManager) {
            this.interactionManager.dispose();
        }
        if (this.cursorSubscription) {
            this.cursorSubscription.unsubscribe();
        }
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
        if (this.sceneManager) {
            this.sceneManager.dispose();
        }
        if (this.exportManager) {
            this.exportManager.dispose();
        }
    }



    private cursorSubscription: Subscription;
    private subscriptions = new Subscription();  // Add subscriptions property

    public exportToSTEP(): void {
        this.exportManager.exportToSTEP();
    }

    public exportScene(): void {
        this.exportManager.exportScene();
    }

    public createPartList(): void {
        this.partListManager.createPartList(this.scene, this.cad);
    }

    private async loadOwnProjectsCache(): Promise<void> {
        if (this.ownProjectsLoaded) {
            return;
        }

        try {
            const user = await firstValueFrom(this.auth.authState);
            if (user && user.uid) {
                const projectsSnapshot = await this.afs.collection(`projects/userprojects/${user.uid}`, ref => ref.orderBy('date', 'desc'))
                    .get()
                    .toPromise();

                this.ownProjectsCache = projectsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...(doc.data() as object)
                }));
                this.ownProjectsLoaded = true;
                console.log('Own projects cache loaded:', this.ownProjectsCache.length);
            } else {
                this.ownProjectsCache = [];
                this.ownProjectsLoaded = true;
                console.log('No user logged in, own projects cache empty');
            }
        } catch (error) {
            console.error('Error loading own projects cache:', error);
            this.ownProjectsCache = [];
            this.ownProjectsLoaded = true;
        }
    }

    ngOnInit() {
        // Initialize theme from localStorage or default to dark mode
        const savedTheme = localStorage.getItem('theme') || 'dark';
        this.isDarkMode = savedTheme === 'dark';
        if (this.isDarkMode) {
            document.body.classList.add('darkmode');
        } else {
            document.body.classList.remove('darkmode');
        }

        // Subscribe to authentication state
        this.auth.authState.subscribe(user => {
            this.isAuthenticated = !!user;
            if (user) {
                this.customerid = user.uid; // Ensure customerid is set for credit deduction
                // Load own projects cache when user is authenticated
                this.loadOwnProjectsCache();
            }
            console.log('Authentication state changed:', this.isAuthenticated);
        });

        // Get route parameters
        this.route.params.subscribe(params => {
            if (params['projectid']) {
                this.projectid = params['projectid'];
                console.log('Project ID from route params:', this.projectid);
            }

            if (params['configid']) {
                this.configid = params['configid'];
                console.log('Config ID from route params:', this.configid);
            }
        });

        // Get URL parameters for AI model and run number
        this.route.queryParams.subscribe(params => {
            if (params['prompt'] && params['model']) {
                // Wait for aiPromptEditor to be available
                const checkEditor = setInterval(() => {
                    if (this.aiPromptEditor) {
                        clearInterval(checkEditor);

                        // Show the editor
                        this.showAIPromptEditor = true;

                        // Configure the editor
                        this.aiPromptEditor.aiProvider = params['model'];

                        // Set the prompt directly in the current tab
                        const decodedPrompt = decodeURIComponent(params['prompt']);
                        this.aiPromptEditor.aiPrompt = decodedPrompt;

                        // If do5runs is specified, trigger the 5x run after a delay
                        if (params['do5runs']) {
                            setTimeout(() => {
                                // For multi-prompt mode, we want to run just this single prompt 5 times
                                if (params['multiPrompt']) {
                                    if (this.aiPromptEditor) {
                                        this.aiPromptEditor.submit5x(params['model']);
                                    }
                                } else {
                                    if (this.aiPromptEditor) {
                                        this.aiPromptEditor.submit5x();
                                    }
                                }
                            }, 2000);
                        }
                    }
                }, 100);

                // Clear interval after 10 seconds if editor is not found
                setTimeout(() => clearInterval(checkEditor), 10000);
            }
        });

        // ... rest of existing ngOnInit code ...
    }

    // Add this new method
    toggleTheme() {
        this.isDarkMode = !this.isDarkMode;
        if (this.isDarkMode) {
            document.body.classList.add('darkmode');
        } else {
            document.body.classList.remove('darkmode');
        }
        // Save preference to localStorage
        localStorage.setItem('theme', this.isDarkMode ? 'dark' : 'light');
    }

    handleAISuggestion(suggestion: { cell: string, value: string }) {
        // Convert cell reference (e.g. 'A1') to row and column indices
        const col = suggestion.cell.match(/[A-Z]+/)[0];
        const row = parseInt(suggestion.cell.match(/\d+/)[0]) - 1;
        const colIndex = col.split('').reduce((acc, char) => acc * 26 + char.charCodeAt(0) - 64, 0) - 1;

        // Update the cell value
        if (this.hot) {
            this.hot.setDataAtCell(row, colIndex, suggestion.value);
        }
    }

    showAIAgent = false;  // Add this property

    // Clipboard label properties
    showClipboardLabel = false;
    clipboardLabelText = '';

    toggleAIAgent() {
        if (this.isAIAgentMinimized) {
            this.isAIAgentMinimized = false;
        } else {
            this.showAIAgent = !this.showAIAgent;
            if (this.showAIAgent) {
                // Trigger initial analysis when showing the agent
                const aiAgent = this.aiAgentComponent;
                if (aiAgent) {
                    aiAgent.analyzeModel();
                }
            }
        }
    }

    @ViewChild(AIAgentComponent) aiAgentComponent: AIAgentComponent;

    minimizeAIAgent() {
        this.isAIAgentMinimized = true;
    }

    isAIAgentMinimized = false;

    showClipboardLabelWithText(text: string) {
        this.clipboardLabelText = text;
        this.showClipboardLabel = true;
    }

    closeClipboardLabel() {
        this.showClipboardLabel = false;
        this.clipboardLabelText = '';
        // Clear selected refpos when label is closed
        this.clearSelectedRefPos();
    }

    private updateTitle() {
        if (this.project?.name) {
            this.titleService.setTitle(`${this.project.name} - confBuild`);
        } else {
            this.titleService.setTitle('confBuild');
        }
    }

    // Breadcrumbs methods
    updateBreadcrumbs() {
        console.log('[EditorComponent] Updating breadcrumbs', {
            isMainConfig: this.isMainConfig,
            selectedNode: this.selectedNode?.name,
            selectedSubprojectID: this.selectedSubprojectID,
            selectedProjectName: this.selectedProjectName
        });

        this.breadcrumbs = [];

        // Always start with Main
        this.breadcrumbs.push({
            name: 'Main',
            path: 'main',
            isMain: true
        });

        if (!this.isMainConfig && this.selectedNode) {
            // Build breadcrumb path from selectedNode
            this.buildBreadcrumbPath(this.selectedNode);
        }

        this.showBreadcrumbs = this.breadcrumbs.length > 1;
        console.log('[EditorComponent] Updated breadcrumbs:', this.breadcrumbs);
    }

    private buildBreadcrumbPath(node: any) {
        if (!node || !node.userData) return;

        // Extract project identifier from various sources
        let projectIdentifier = null;
        let projectName = null;

        // Try to get identifier from the object name pattern
        if (node.name) {
            const nameMatch = node.name.match(/#([^#^]+)\^?\$/);
            if (nameMatch && nameMatch[1]) {
                projectIdentifier = nameMatch[1];
            }
        }

        // Try to get identifier from userData.subproject (format: "userId_projectId")
        if (!projectIdentifier && node.userData.subproject) {
            // userData.subproject format is usually "userId_projectId", we want the projectId part
            projectIdentifier = node.userData.subproject.split('_').pop();
        }

        // Try to get identifier from row data
        if (!projectIdentifier && node.userData.row && node.userData.row[0]) {
            projectIdentifier = node.userData.row[0];
        }

        // Now try to find the actual project name from configurations
        if (projectIdentifier && this.project?.configurations) {
            console.log('[EditorComponent] Looking for project name for identifier:', projectIdentifier);

            // Look through all configurations to find the one matching this project identifier
            for (const configKey in this.project.configurations) {
                const config = this.project.configurations[configKey];
                if (config && config.id === projectIdentifier) {
                    projectName = config.name;
                    console.log('[EditorComponent] Found project name from configurations:', projectName, 'for identifier:', projectIdentifier);
                    break;
                }
            }
        }

        // Fallback to the identifier if we couldn't find the project name
        if (!projectName) {
            projectName = projectIdentifier || 'Subproject';
            console.log('[EditorComponent] Using fallback project name:', projectName);
        }

        // Add this level to breadcrumbs
        this.breadcrumbs.push({
            name: projectName,
            path: node.name || projectName,
            isMain: false
        });

        // Check if this node has a parent that's also a project/sheet
        if (node.parent && node.parent !== this.scene && node.parent.userData?.typ) {
            const parentType = node.parent.userData.typ.toUpperCase();
            if (parentType.startsWith('PROJECT') || parentType.startsWith('SHEET')) {
                this.buildBreadcrumbPath(node.parent);
            }
        }
    }

    navigateToBreadcrumb(breadcrumb: { name: string, path: string, isMain: boolean }) {
        console.log('[EditorComponent] Navigating to breadcrumb:', breadcrumb);

        if (breadcrumb.isMain) {
            // Return to main project
            this.returnToMainProject();
        } else {
            // Navigate to specific subproject
            const targetNode = this.scene.getObjectByName(breadcrumb.path);
            if (targetNode) {
                // Simulate a click on this node to select it
                this.selectSubproject(targetNode);
            }
        }
    }

    private returnToMainProject() {
        console.log('[EditorComponent] Returning to main project');

        // Reset selection state
        if (this.selectedObjectHelper) {
            this.scene.remove(this.selectedObjectHelper);
        }

        this.selectedNode = null;
        this.selectedSubprojectID = this.PROJECT;
        this.selectedProjectName = null;
        this.selectedSubprojectPath = null;
        this.selectedprojectpath = "root^$" + this.sheetid;
        this.isMainConfig = true;
        this.jsongui2 = null;
        this.dataset2 = null;

        // Reset materials/opacity
        this.scene.traverse((child) => {
            if (child.material) {
                if (child.userData.opacity > 0.99)
                    child.material.transparent = false;
                if (child.userData.opacity)
                    child.material.opacity = child.userData.opacity;
            }
        });

        // Recreate main JSON GUI
        this.excels[this.PROJECT].createJsonGUI(this.sheetid).then(gui => {
            this.jsongui = gui;
            this.csschange(this.project.csscode);
            this.subprojectSelected();
            this.updateThreeFrame();
            this.updateBreadcrumbs();
        });
    }

    private async selectSubproject(node: any) {
        console.log('[EditorComponent] Selecting subproject node:', node.name);

        if (node.userData?.typ?.toUpperCase().startsWith('PROJECT')) {
            // Set selection state
            this.selectedNode = node;
            this.selectedSubprojectID = node.userData?.subproject;
            this.selectedProjectName = node.name;
            this.selectedSubprojectPath = node.name;
            this.isMainConfig = false;

            // Update scene opacity
            this.scene.traverse((child) => {
                if (child.material) {
                    child.material.transparent = true;
                    if (!child.userData) child.userData = {};
                    if (child.userData.opacity === undefined) {
                        child.userData.opacity = child.material.opacity;
                    }
                    child.material.opacity = 0.1;
                }
            });

            // Restore opacity for selected node
            node.traverse((child) => {
                if (child.material) {
                    const originalOpacity = child.userData?.opacity !== undefined ? child.userData.opacity : 1.0;
                    child.material.opacity = originalOpacity;
                    if (originalOpacity >= 0.99) {
                        child.material.transparent = false;
                    }
                }
            });

            // Update JSON GUI
            if (this.selectedSubprojectID && this.selectedSubprojectID !== this.PROJECT) {
                const subprojectJsonGui = await this.excels[this.selectedSubprojectID].createJsonGUI(0);
                this.jsongui = subprojectJsonGui;
                this.jsongui2 = null;
            }

            await this.subprojectSelected();
            this.updateThreeFrame();
            this.updateBreadcrumbs();
        }
    }

    public isRecreating = false;
    public hasRecreated = false;

    // Mouse proximity effect for connectors
    private mouseScreenPosition: [number, number] = [0, 0];
    private readonly CONNECTOR_PROXIMITY_RADIUS = 300; // pixels - made bigger
    private readonly CONNECTOR_MIN_SCALE = 0.5;
    private readonly CONNECTOR_MAX_SCALE = 2.5; // much bigger effect
    private readonly CONNECTOR_MIN_OPACITY = 0.2;
    private readonly CONNECTOR_MAX_OPACITY = 1.0;
    private lastProximityDebugTime: number = 0; // For debug timing

    async recreateModel() {
        // Start fade out animation
        this.isRecreating = true;
        this.processing = true;
        this.processingMessage = 'Recreating model...';

        try {
            // Wait for fade out animation to complete
            await new Promise(resolve => setTimeout(resolve, 300));

            // Clear existing scene objects except lights and camera

            await ThreeUtils.clearScene(this.scene);
            await this.applyCellMeta();
            this.jsongui = await this.excels[this.PROJECT].createJsonGUI(this.sheetid);
            console.log("jsongui", this.jsongui);
            var newnodes = await this.createModel(this.scene, this.dataset, this.PROJECT);


            // Start fade in animation
            this.isRecreating = false;
            this.hasRecreated = true;

            // Reset hasRecreated after animation completes
            setTimeout(() => {
                this.hasRecreated = false;
            }, 300);

            // Refresh interactive objects after model recreation
            if (this.interactionManager) {
                this.interactionManager.refreshInteractiveObjects();
            }

            return newnodes;

        } catch (error) {
            console.error('Error recreating model:', error);
            this.toastr.error('Error recreating model');
            this.isRecreating = false;
        } finally {
            this.processing = false;
            this.processingMessage = '';
        }
    }

    async deleteSubproject(targetProject: THREE.Object3D) {
        try {
            if (!targetProject || !targetProject.userData) {
                console.warn('Cannot delete: Invalid target project');
                return;
            }

            console.log('Deleting subproject:', targetProject.name, targetProject.userData);

            // Find the corresponding row in the spreadsheet
            const projectUserData = targetProject.userData;
            let rowToDelete = -1;

            // Look for the row that corresponds to this object
            for (let i = 0; i < this.dataset.length; i++) {
                const row = this.dataset[i];
                if (row && row[0] && row[0] === projectUserData.outputid) {
                    rowToDelete = i;
                    break;
                }
            }

            if (rowToDelete === -1) {
                console.warn('Could not find corresponding row for deletion');
                return;
            }

            // Clear the row in the dataset
            const emptyRow = new Array(this.dataset[rowToDelete].length).fill('');

            // Update the dataset locally
            this.dataset[rowToDelete] = emptyRow;
            this.cellformulas[rowToDelete] = emptyRow;

            // Update the spreadsheet - wrap emptyRow in array to make it 2D
            const changes = await this.excels[this.PROJECT].setCellContents(
                { sheet: this.sheetid, row: rowToDelete, col: 0 },
                [emptyRow]
            );

            // Remove the object from the scene
            if (targetProject.parent) {
                targetProject.parent.remove(targetProject);
            } else {
                this.scene.remove(targetProject);
            }

            // Clear the highlight
            this.highlightproject = null;
            this.higlightProject();

            // Update the model to reflect changes
            await this.updateModel(changes, this.dataset, this.scene);

            // Refresh the spreadsheet view
            this.hot.render();
            this.updateThreeFrame();

            console.log('Subproject deleted successfully');

        } catch (error) {
            console.error('Error deleting subproject:', error);
        }
    }

    async handleRecreateModelRequest(event: { sheetId: number, resolve: () => void }) {
        console.log(`Handling recreateModelRequest for sheet ${event.sheetId}`);
        try {
            // Ensure the correct sheet is active if needed, although recreateModel might handle this
            if (this.sheetid !== event.sheetId) {
                console.warn(`Recreate request for sheet ${event.sheetId} but active sheet is ${this.sheetid}. Proceeding with recreateModel.`);
                // Optionally switch sheet: await this.setSheetIndex(null, event.sheetId);
            }
            await this.recreateModel(); // Call the existing async method
        } catch (error) {
            console.error(`Error during model recreation requested by agent for sheet ${event.sheetId}:`, error);
            this.toastr.error('Failed to recreate model during agent operation.', 'Recreation Error');
        } finally {
            console.log(`Resolving recreateModelRequest for sheet ${event.sheetId}`);
            event.resolve(); // Call the resolver function passed via the event
        }
    }

    applyGuiPanelSettings() {
        if (!this.project?.menuSettings) return;

        const guiPanel = document.getElementById('gui-panel');
        if (!guiPanel) {
            // Retry after a short delay if panel not found
            setTimeout(() => this.applyGuiPanelSettings(), 100);
            return;
        }

        // Apply saved dimensions
        if (this.project.menuSettings.width) {
            guiPanel.style.width = `${this.project.menuSettings.width}px`;
        }
        if (this.project.menuSettings.height) {
            guiPanel.style.height = `${this.project.menuSettings.height}px`;
        }

        // Apply saved position based on float alignment
        if (this.project.menuSettings.menufloat === 'right') {
            // For right-aligned panels
            guiPanel.style.right = this.project.menuSettings.menuleft || '10px';
            guiPanel.style.left = 'auto';
        } else {
            // For left-aligned panels (default)
            guiPanel.style.left = this.project.menuSettings.menuleft || '10px';
            guiPanel.style.right = 'auto';
        }

        if (this.project.menuSettings.menutop) {
            guiPanel.style.top = this.project.menuSettings.menutop;
        }

        console.log("Applied GUI panel settings:", this.project.menuSettings);

        // IMMEDIATELY update toggle button position after applying settings
        this.cdr.detectChanges();

        // Also do it after a delay to ensure DOM updates are complete
        setTimeout(() => {
            this.cdr.detectChanges();
        }, 10);
    }

    onGuiDragEnd(event: any) {
        console.log("onGuiDragEnd", event);
        if (this.project?.menuSettings) {
            // Get the final position from the transform style
            const transform = event.source.element.nativeElement.style.transform;

            // Handle different transform formats (translate3d or translate)
            let x = 0, y = 0;

            if (transform) {
                const translate3dMatch = transform.match(/translate3d\((-?\d+(?:\.\d+)?)px,\s*(-?\d+(?:\.\d+)?)px/);
                const translateMatch = transform.match(/translate\((-?\d+(?:\.\d+)?)px,\s*(-?\d+(?:\.\d+)?)px/);

                if (translate3dMatch && translate3dMatch.length === 3) {
                    x = parseFloat(translate3dMatch[1]);
                    y = parseFloat(translate3dMatch[2]);
                } else if (translateMatch && translateMatch.length === 3) {
                    x = parseFloat(translateMatch[1]);
                    y = parseFloat(translateMatch[2]);
                }
            }

            // Get the current position values (without 'px')
            let currentLeft = this.project.menuSettings.menuleft || '0px';
            currentLeft = parseInt(currentLeft.replace('px', ''), 10) || 0;

            let currentTop = this.project.menuSettings.menutop || '0px';
            currentTop = parseInt(currentTop.replace('px', ''), 10) || 0;

            // Calculate the new position
            const newLeft = currentLeft + x;
            const newTop = currentTop + y;

            // Update the position in the project settings
            this.project.menuSettings.menuleft = `${newLeft}px`;
            this.project.menuSettings.menutop = `${newTop}px`;

            // Update original position and dimensions if not minimized
            if (!this.project.menuSettings.menuminimized) {
                if (!this.project.menuSettings.originalPosition) {
                    this.project.menuSettings.originalPosition = {};
                }
                this.project.menuSettings.originalPosition.left = `${newLeft}px`;
                this.project.menuSettings.originalPosition.top = `${newTop}px`;

                // Also update original dimensions to current size
                if (!this.project.menuSettings.originalDimensions) {
                    this.project.menuSettings.originalDimensions = {};
                }
                this.project.menuSettings.originalDimensions.width = this.project.menuSettings.width;
                this.project.menuSettings.originalDimensions.height = this.project.menuSettings.height;
            }

            // Reset the transform to avoid accumulating transforms
            event.source.reset();

            // Save the project to persist the changes
            this.updateLastSaveTime();

            // Trigger change detection to update toggle button position
            this.cdr.detectChanges();
        }
    }

    async generateReport() {
        await this.exportManager.generateReport();
    }


    getCurrentModelShareUrl(): string {
        return this.exportManager.getCurrentModelShareUrl(this.customerid, this.projectid);
    }

    async checkFormula() {
        this.isCheckingFormula = true;

        // Get the selected cell coordinates from Handsontable
        const selectedRange = this.hot.getSelectedLast(); // Returns [startRow, startCol, endRow, endCol]
        if (!selectedRange) {
            this.toastr.warning('No cell selected', null, { positionClass: 'toast-bottom-center' });
            this.isCheckingFormula = false;
            return;
        }

        const [row, col] = selectedRange; // Use the starting cell of the last selection

        // Get the formula from HyperFormula using the coordinates
        const cellAddress: SimpleCellAddress = { sheet: this.sheetid, row: row, col: col };
        let formula: CellValue = null;
        try {
            formula = await this.excels[this.PROJECT].getCellSerialized(cellAddress);
        } catch (error) {
            console.warn(`Error getting formula for cell (${row}, ${col}) on sheet ${this.sheetid}:`, error);
        }

        if (!formula || typeof formula !== 'string' || !formula.startsWith('=')) {
            this.toastr.warning('No formula found in selected cell', null, { positionClass: 'toast-bottom-center' });
            this.isCheckingFormula = false;
            return;
        }

        console.log('Checking formula with Gemini Flash:', formula);

        // Find parameter context by looking for header row above
        let parameterContext = '';
        try {
            parameterContext = this.getParameterContext(row, col);
        } catch (error) {
            console.warn('Could not determine parameter context:', error);
        }

        // Prepare request with context and userId
        const requestBody: any = { formula, userId: this.customerid };
        if (parameterContext) {
            requestBody.context = parameterContext;
            console.log('Adding parameter context:', parameterContext);
        }

        console.log('Sending checkFormulaWithGemini request with userId:', this.customerid);
        console.log('Full request body:', requestBody);

        // Call the new Gemini cloud function to check formula validity
        this.http.post<any>(`${this.SERVER}/checkFormulaWithGemini`, requestBody)
            .pipe(
                finalize(() => {
                    this.isCheckingFormula = false;
                })
            )
            .subscribe({
                next: (response) => {
                    if (response.success) {
                        const analysis = response.analysis;
                        const tokenUsage = response.tokenUsage;
                        console.log('Gemini Formula Analysis:', analysis);
                        console.log('Token Usage:', tokenUsage);

                        // Show token usage in a toast notification
                        if (tokenUsage && tokenUsage.totalTokens > 0) {
                            this.toastr.info(`AI Analysis complete. Used ${tokenUsage.totalTokens} tokens (${tokenUsage.promptTokens} input + ${tokenUsage.responseTokens} output)`, 'Token Usage', {
                                positionClass: 'toast-top-right',
                                timeOut: 4000
                            });
                        }

                        // Open dialog with formula check results
                        const dialogRef = this.dialog.open(FormulaCheckDialogComponent, {
                            width: '600px',
                            maxWidth: '90vw',
                            disableClose: false,
                            data: {
                                isValid: analysis.isValid,
                                explanation: analysis.explanation,
                                currentFormula: formula,
                                correctedFormula: analysis.correctedFormula,
                                suggestions: analysis.suggestions,
                                context: parameterContext,
                                tokenUsage: tokenUsage
                            }
                        });

                        dialogRef.afterClosed().subscribe(result => {
                            if (result && result.action === 'apply' && result.correctedFormula) {
                                // Apply the corrected formula to the selected cell
                                this.excels[this.PROJECT].setCellContents(cellAddress, result.correctedFormula);
                                // Update the formula input field
                                this.formula = result.correctedFormula;
                                // Re-render the hot table
                                if (this.hot) {
                                    this.hot.render();
                                }
                                this.toastr.success(`✅ Formula corrected and applied successfully!`, 'AI Formula Check', {
                                    positionClass: 'toast-bottom-center',
                                    timeOut: 5000
                                });
                            }
                        });

                    } else {
                        this.toastr.error(`Error checking formula: ${response.error}`, 'AI Formula Check Error', { positionClass: 'toast-bottom-center' });
                    }
                },
                error: (err) => {
                    console.error('HTTP error during Gemini formula check:', err);
                    this.toastr.error('Failed to connect to AI formula check service.', 'Network Error', { positionClass: 'toast-bottom-center' });
                }
            });
    }

    private getParameterContext(row: number, col: number): string {
        if (!this.hot) return '';

        // Look backwards from current row to find the header row (starts with "#")
        let headerRow = -1;
        for (let r = row - 1; r >= 0; r--) {
            const firstCellValue = this.hot.getDataAtCell(r, 0);
            if (firstCellValue && typeof firstCellValue === 'string' && firstCellValue.startsWith('#')) {
                headerRow = r;
                break;
            }
        }

        if (headerRow === -1) {
            return ''; // No header row found
        }

        // Get the parameter name from the header row at the same column
        const parameterName = this.hot.getDataAtCell(headerRow, col);
        if (!parameterName || typeof parameterName !== 'string') {
            return '';
        }

        // Get object name and type
        const objectName = this.hot.getDataAtCell(headerRow + 1, 0); // Object name is in first column of next row
        const objectType = this.hot.getDataAtCell(headerRow + 1, 1); // Object type is in second column of next row

        let context = `Parameter "${parameterName}"`;

        if (objectType && typeof objectType === 'string') {
            context += ` of ${objectType}`;

            // Add specific context based on parameter type
            switch (parameterName.toLowerCase()) {
                case 'baseplane':
                    context += ' (expects a string with points in format "(x1,y1);(x2,y2);..." - use # to separate holes from main shape)';
                    break;
                case 'extrusionvector':
                    context += ' (expects a 3D vector in format "(x,y,z)" where z defines depth)';
                    break;
                case 'p1':
                case 'p2':
                    context += ' (expects a 3D point in format "(x,y,z)")';
                    break;
                case 'path':
                    context += ' (expects a string with 3D points in format "(x1,y1,z1);(x2,y2,z2);...")';
                    break;
                case 'material':
                    context += ' (expects hex color "#RRGGBB" or advanced format "color;roughness;metalness;reflectivity;opacity")';
                    break;
                case 'textflat':
                    context += ' (expects text content as string)';
                    break;
                case 'visible':
                    context += ' (expects boolean true/false or conditional formula like =IF(D2>100;true;false))';
                    break;
                default:
                    if (parameterName.toLowerCase().includes('radius') ||
                        parameterName.toLowerCase().includes('width') ||
                        parameterName.toLowerCase().includes('height') ||
                        parameterName.toLowerCase().includes('length') ||
                        ['x', 'y', 'z', 'rx', 'ry', 'rz'].includes(parameterName.toLowerCase())) {
                        context += ' (expects numeric value or formula)';
                    }
                    break;
            }
        }

        if (objectName && typeof objectName === 'string') {
            context += ` in object "${objectName}"`;
        }

        return context;
    }

    toggleInsertObjectDialog() {
        const dialogRef = this.dialog.open(InsertObjectDialogComponent, {
            width: '1400px',
            maxWidth: '95vw',
            height: 'auto',
            maxHeight: '90vh',
            disableClose: false,
            autoFocus: false,
            data: {
                ownProjects: this.ownProjectsCache
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.handleInsertObjectDialogClose(result);
            }
        });
    }

    openInsertObjectDialogFromCellMenu() {
        this.toggleInsertObjectDialog();
        this.cellactionvisible = false;
        this.cellactionmenuvisible = false;
    }

    openObjectParametersDialog(targetObject: THREE.Object3D) {
        if (!targetObject || !targetObject.userData) {
            console.warn('Cannot open parameters dialog: Invalid target object');
            return;
        }

        console.log('Opening parameters dialog for object:', targetObject.name, targetObject.userData);

        // Extract object information
        const userData = targetObject.userData;
        const outputid = userData.outputid || userData.name;
        const rowindex = userData.rowindex;

        if (rowindex === undefined || !this.dataset || !this.dataset[rowindex]) {
            console.warn('Cannot find object row in dataset:', { rowindex, hasDataset: !!this.dataset });
            return;
        }

        // Get the header row (comment row)
        const headerRowIndex = rowindex - 1;
        if (headerRowIndex < 0 || !this.dataset[headerRowIndex]) {
            console.warn('Cannot find header row for object');
            return;
        }

        const headers = this.dataset[headerRowIndex];
        const rowData = this.dataset[rowindex];

        console.log('Object parameters data:', {
            headers,
            rowData,
            outputid,
            rowindex
        });

        // Prepare dialog data
        const dialogData: ObjectParametersDialogData = {
            object: targetObject,
            parameters: userData,
            headers: headers,
            rowData: rowData
        };

        // Open the dialog
        const dialogRef = this.dialog.open(ObjectParametersDialogComponent, {
            width: '30%',
            minWidth: '300px',
            maxWidth: '500px',
            height: 'auto',
            maxHeight: '80vh',
            hasBackdrop: true,
            disableClose: false,
            panelClass: 'draggable-dialog',
            data: dialogData
        });

        // Handle dialog result
        dialogRef.afterClosed().subscribe(async (result) => {
            if (result && result.changes) {
                console.log('Applying parameter changes:', result.changes);
                await this.applyParameterChanges(rowindex, result.changes, headers);
            }
        });
    }

    private async applyParameterChanges(rowindex: number, changes: { [key: string]: any }, headers: string[]) {
        try {
            // Apply each change to the corresponding cell
            for (const [paramName, newValue] of Object.entries(changes)) {
                // Find the column index for this parameter
                const colIndex = headers.indexOf(paramName);
                if (colIndex === -1) {
                    console.warn(`Parameter ${paramName} not found in headers`);
                    continue;
                }

                console.log(`Updating ${paramName} at row ${rowindex}, col ${colIndex} to:`, newValue);

                // Update the dataset locally
                this.dataset[rowindex][colIndex] = newValue;
                this.cellformulas[rowindex][colIndex] = newValue;

                // Update the Excel backend
                const cellAddress = { sheet: this.sheetid, row: rowindex, col: colIndex };
                await this.excels[this.PROJECT].setCellContents(cellAddress, newValue);
            }

            // Apply cell metadata and re-render the spreadsheet
            this.applyCellMeta();
            if (this.hot) {
                this.hot.render();
            }

            // Recreate the 3D model to reflect the changes
            await this.recreateModel();

            this.toastr.success('Object parameters updated successfully', 'Parameters Applied');

        } catch (error) {
            console.error('Error applying parameter changes:', error);
            this.toastr.error('Failed to apply parameter changes: ' + error.message, 'Error');
        }
    }

    // Object menu methods
    toggleObjectMenu(event: Event) {
        event.stopPropagation();
        this.objectMenuVisible = !this.objectMenuVisible;
    }

    copyObject(object: THREE.Object3D) {
        // TODO: Implement object copying functionality
        console.log('Copy object:', object.name);
        this.snackBar.open('Object copied (feature coming soon)', '', { duration: 2000 });
        this.hideObjectMenu();
    }

    deleteObject(object: THREE.Object3D) {
        // TODO: Implement object deletion functionality
        console.log('Delete object:', object.name);
        this.snackBar.open('Object deleted (feature coming soon)', '', { duration: 2000 });
        this.hideObjectMenu();
    }

    isolateObject(object: THREE.Object3D) {
        // TODO: Implement object isolation functionality
        console.log('Isolate object:', object.name);
        this.snackBar.open('Object isolated (feature coming soon)', '', { duration: 2000 });
        this.hideObjectMenu();
    }

    hideObject(object: THREE.Object3D) {
        // TODO: Implement object hiding functionality
        console.log('Hide object:', object.name);
        this.snackBar.open('Object hidden (feature coming soon)', '', { duration: 2000 });
        this.hideObjectMenu();
    }

    centerCameraOnObject(object: THREE.Object3D) {
        // TODO: Implement camera centering functionality
        console.log('Center camera on object:', object.name);
        this.snackBar.open('Camera centered on object (feature coming soon)', '', { duration: 2000 });
        this.hideObjectMenu();
    }

    private hideObjectMenu() {
        this.objectMenuVisible = false;
    }

    async handleInsertObjectDialogClose(selectedProject: any) {
        if (selectedProject) {
            console.log('Selected project from insert object dialog:', selectedProject);

            // Import the selected project using the same logic as addProject
            try {
                let projectid = selectedProject.id;
                let project, newconfig, pr;

                if (selectedProject.publicCategoryID) {
                    pr = (await this.afs.doc("/projectspublic/" + projectid).get().toPromise());
                    newconfig = pr.data() as any;
                    project = newconfig.userid + '_' + projectid;
                } else {
                    project = this.customerid + '_' + projectid;
                    pr = (await this.afs.doc("/projects/userprojects/" + this.customerid + "/" + projectid).get().toPromise());
                    newconfig = pr.data() as any;
                    newconfig.id = pr.id;
                }

                if (!this.project.configurations) this.project.configurations = {};
                this.project.configurations[this.curSelectedRow] = newconfig;

                if (!this.excels[project]) {
                    var toload = [];
                    toload.push(project);

                    // Load all subconfigs
                    await traverse(newconfig.configmodel).forEach(function (value) {
                        if (typeof (value) === "object" && value?.subproject) {
                            toload.push(value.subproject);
                        }
                    });

                    // Remove duplicates from array
                    toload = toload.filter(function (item, pos) {
                        return toload.indexOf(item) == pos;
                    }).sort();

                    console.log("Loading project data", pr);
                    var promises = [];

                    for (var i = 0; i < toload.length; i++) {
                        const w = new Worker(new URL('./../app.worker', import.meta.url), { type: 'module' });
                        this.workers.push(w);
                        this.excels[toload[i]] = Comlink.wrap(w) as any;
                        var p = this.excels[toload[i]].load(toload[i], newconfig.sheets);
                        promises.push(p);
                    }

                    var t0 = performance.now();
                    var promisesresult = await Promise.all(promises).catch(reason => {
                        console.error(reason)
                    });
                    console.log('promisesresult', promisesresult);
                    var t1 = performance.now();
                    console.log("webworker loads took " + (t1 - t0) + " milliseconds.");
                }

                var sheetname1 = await this.excels[project].getSheetNames();
                var newsnippet = await this.excels[project].getSnippet(sheetname1[0]);
                var outputid = "project" + "" + (this.curSelectedRow + 2);

                // Set the row and output IDs
                var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: this.curSelectedRow, col: 0 }, '#');
                var exportedchanges = await this.excels[this.PROJECT].setCellContents({ sheet: this.sheetid, row: this.curSelectedRow + 1, col: 0 }, outputid);

                newsnippet.values[0][0] = '';
                newsnippet.values[1][0] = 'project: ' + project;

                var cell = { row: this.curSelectedRow, col: 1, sheet: this.sheetid };
                this.sheetChange(cell, newsnippet.values, newsnippet.values, true);
                this.dataset[this.curSelectedRow][0] = '#';
                this.cellformulas[this.curSelectedRow][0] = '#';
                this.dataset[this.curSelectedRow + 1][0] = outputid;
                this.cellformulas[this.curSelectedRow + 1][0] = outputid;

                this.applyCellMeta();
                this.createModel(this.scene, this.dataset, this.PROJECT);

                this.loadingOverlay = false;
                console.log("Project imported successfully from insert object dialog");

            } catch (error) {
                console.error("Error importing project:", error);
                this.toastr.error("Error importing project: " + error.message);
            }
        }
    }

    private async deductUserCredits(userId: string, cost: number = 1): Promise<boolean> {
        if (!userId) {
            this.toastr.error('User not authenticated. Cannot proceed with AI operation.', 'Authentication Error');
            return false;
        }

        const userRef = this.afs.doc(`users/${userId}`);
        const userSnap = await userRef.get().toPromise();

        if (!userSnap.exists) {
            this.toastr.error('User profile not found.', 'Credit Error');
            // Optionally, create the user profile with default credits here if desired
            // await userRef.set({ credits: 100, email: this.auth.currentUser.email }); // Example initialization
            // this.toastr.info('User profile created with 100 credits.', 'Profile Created');
            // return true; // Or false depending on desired behavior after creation
            return false;
        }

        const userData = userSnap.data() as { credits?: number };
        let currentCredits = userData.credits;

        // Grant default credits if they don't exist
        if (currentCredits === undefined || currentCredits === null) {
            await userRef.update({ credits: 100 });
            currentCredits = 100;
            this.toastr.info('Initialized with 100 credits.', 'Credits Update');
        }

        if (currentCredits < cost) {
            this.toastr.error('Insufficient credits for this AI operation.', 'Credit Error');
            return false;
        }

        await userRef.update({ credits: currentCredits - cost });
        //  this.toastr.success(`Successfully deducted ${cost} credit(s). Remaining: ${currentCredits - cost}`, 'Credits Update');
        return true;
    }

    /**
     * Handle individual cell error
     */
    private handleCellError(cell: any): any {
        if (cell?.type == 'VALUE' || cell?.type == 'ERROR') {
            // address = 'Sheet2!D9'
            // message = 'Value cannot be coerced to number.'
            // type = 'VALUE'
            // value = '#VALUE!'
            return "#." + cell?.message;
        }
        return cell;
    }

    debugConnectorsInScene() {
        console.log('[CONNECTOR DEBUG] Checking scene for connectors...');
        let connectorSprites = 0;
        let connectorSpheres = 0;
        let connectorGroups = 0;
        let totalObjects = 0;
        let connectorObjects = [];

        this.scene.traverse((object) => {
            totalObjects++;

            if (object.userData.type === "connector" && object instanceof THREE.Sprite) {
                connectorSprites++;
                connectorObjects.push({
                    type: 'sprite',
                    name: object.name,
                    userData: object.userData,
                    position: object.position.toArray()
                });
            }

            if (object.userData.isConnectorSphere && object instanceof THREE.Mesh) {
                connectorSpheres++;
                connectorObjects.push({
                    type: 'sphere',
                    name: object.name,
                    userData: object.userData,
                    position: object.position.toArray()
                });
            }

            if (object.userData.isConnector) {
                connectorGroups++;
                connectorObjects.push({
                    type: 'group',
                    name: object.name,
                    userData: object.userData,
                    position: object.position.toArray(),
                    children: object.children.length
                });
            }
        });

        console.log('[CONNECTOR DEBUG] Found in scene:', {
            totalObjects,
            connectorSprites,
            connectorSpheres,
            connectorGroups,
            connectorObjects
        });
    }

    updateConnectorProximityEffect() {
        if (!this.camera || !this.renderer) {
            console.log('[PROXIMITY DEBUG] Missing camera or renderer:', { camera: !!this.camera, renderer: !!this.renderer });
            return;
        }

        let connectorCount = 0;
        let spriteConnectorCount = 0;
        let meshConnectorCount = 0;
        let faceCenterCount = 0;
        let totalObjects = 0;

        this.scene.traverse((object) => {
            totalObjects++;

            // Handle connector sprites
            if (object.userData.type === "connector" && object instanceof THREE.Sprite) {
                connectorCount++;
                spriteConnectorCount++;
                this.applyProximityEffect(object);
            }
            // Handle connector spheres (mesh objects)
            if (object.userData.isConnectorSphere && object instanceof THREE.Mesh) {
                connectorCount++;
                meshConnectorCount++;
                this.applyProximityEffect(object);
            }
            // Handle face center spheres (new sphere-based face centers)
            if (object.userData.type === "refpoint" && object instanceof THREE.Mesh && object.userData.isFaceCenter) {
                faceCenterCount++;
                this.applyProximityEffect(object);
            }
            // Handle face center sprites (legacy refpoints)
            if (object.userData.type === "refpoint" && object instanceof THREE.Sprite) {
                faceCenterCount++;
                this.applyProximityEffect(object);
            }
            // Handle face center labels (sprites above spheres)
            if (object.userData.type === "refpoint_label" && object instanceof THREE.Sprite) {
                faceCenterCount++;
                this.applyProximityEffect(object);
            }
            // Handle normal arrows (refnormal)
            if (object.userData.type === "refnormal" && object instanceof THREE.ArrowHelper) {
                faceCenterCount++;
                this.applyProximityEffect(object);
            }
        });

        // Debug log every 5 seconds (reduced frequency since it's working)
        if (Date.now() - (this.lastProximityDebugTime || 0) > 5000) {
            console.log('[PROXIMITY DEBUG] Scene stats:', {
                totalObjects,
                connectorCount,
                spriteConnectorCount,
                meshConnectorCount,
                faceCenterCount,
                mousePosition: this.mouseScreenPosition,
                cameraExists: !!this.camera,
                rendererExists: !!this.renderer,
                proximityRadius: this.CONNECTOR_PROXIMITY_RADIUS,
                scaleRange: `${this.CONNECTOR_MIN_SCALE} - ${this.CONNECTOR_MAX_SCALE}`
            });
            this.lastProximityDebugTime = Date.now();
        }
    }

    private applyProximityEffect(object: THREE.Object3D) {
        // Get world position of object
        const worldPosition = new THREE.Vector3();
        object.getWorldPosition(worldPosition);

        // Convert 3D world position to screen coordinates
        const vector = worldPosition.clone();
        vector.project(this.camera);

        // Convert normalized device coordinates (-1 to 1) to screen coordinates (0 to container size)
        const threeContainer = document.getElementById('threecontainer');
        const containerRect = threeContainer?.getBoundingClientRect();
        const containerWidth = containerRect?.width || window.innerWidth;
        const containerHeight = containerRect?.height || window.innerHeight;

        const screenX = (vector.x * 0.5 + 0.5) * containerWidth;
        const screenY = (vector.y * -0.5 + 0.5) * containerHeight;

        // Calculate distance between mouse and connector in screen space
        const distance = Math.sqrt(
            Math.pow(this.mouseScreenPosition[0] - screenX, 2) +
            Math.pow(this.mouseScreenPosition[1] - screenY, 2)
        );

        // Calculate scale factor based on distance
        const normalizedDistance = Math.min(distance / this.CONNECTOR_PROXIMITY_RADIUS, 1);
        const scaleRange = this.CONNECTOR_MAX_SCALE - this.CONNECTOR_MIN_SCALE;
        const scaleFactor = this.CONNECTOR_MIN_SCALE + (scaleRange * (1 - normalizedDistance));
        const finalScale = Math.max(this.CONNECTOR_MIN_SCALE, Math.min(this.CONNECTOR_MAX_SCALE, scaleFactor));

        // Calculate opacity factor based on distance
        const opacityRange = this.CONNECTOR_MAX_OPACITY - this.CONNECTOR_MIN_OPACITY;
        const opacityFactor = this.CONNECTOR_MIN_OPACITY + (opacityRange * (1 - normalizedDistance));
        const finalOpacity = Math.max(this.CONNECTOR_MIN_OPACITY, Math.min(this.CONNECTOR_MAX_OPACITY, opacityFactor));

        // Apply scale
        if (object.userData.originalScale === undefined) {
            object.userData.originalScale = object.scale.x;
        }
        object.scale.setScalar(object.userData.originalScale * finalScale);

        // Apply material effects (opacity and color)
        if (object instanceof THREE.ArrowHelper) {
            // Handle ArrowHelper line and cone materials
            this.applyArrowHelperEffects(object, finalOpacity, normalizedDistance);
        } else {
            const materialObject = object as any; // Type assertion to access material
            if (materialObject.material && typeof materialObject.material.opacity !== 'undefined') {
                // Store original values
                if (object.userData.originalOpacity === undefined) {
                    object.userData.originalOpacity = materialObject.material.opacity;
                }
                if (object.userData.originalColor === undefined) {
                    object.userData.originalColor = materialObject.material.color.clone();
                }

                // Apply opacity
                materialObject.material.opacity = object.userData.originalOpacity * finalOpacity;
                materialObject.material.transparent = true;

                // Apply pink/purple color effect based on proximity
                const proximityStrength = 1 - normalizedDistance; // 0 = far, 1 = close
                if (proximityStrength > 0.1) { // Only apply color when reasonably close
                    // Interpolate between original color and pink/purple
                    const originalColor = object.userData.originalColor;
                    const targetColor = new THREE.Color(0xff69b4); // Hot pink
                    const purple = new THREE.Color(0x9966cc); // Purple

                    // Mix pink and purple based on proximity strength
                    const effectColor = targetColor.clone().lerp(purple, proximityStrength);

                    // Interpolate between original and effect color
                    const finalColor = originalColor.clone().lerp(effectColor, proximityStrength * 0.8);
                    materialObject.material.color.copy(finalColor);
                } else {
                    // Restore original color when far away
                    materialObject.material.color.copy(object.userData.originalColor);
                }
            }
        }
    }

    private applyArrowHelperEffects(arrowHelper: THREE.ArrowHelper, finalOpacity: number, normalizedDistance: number) {
        // Store original values for line and cone
        if (arrowHelper.userData.originalLineColor === undefined && arrowHelper.line) {
            arrowHelper.userData.originalLineColor = (arrowHelper.line.material as any).color.clone();
            arrowHelper.userData.originalLineOpacity = (arrowHelper.line.material as any).opacity || 1.0;
        }
        if (arrowHelper.userData.originalConeColor === undefined && arrowHelper.cone) {
            arrowHelper.userData.originalConeColor = (arrowHelper.cone.material as any).color.clone();
            arrowHelper.userData.originalConeOpacity = (arrowHelper.cone.material as any).opacity || 1.0;
        }

        const proximityStrength = 1 - normalizedDistance; // 0 = far, 1 = close

        // Calculate pink/purple color effect
        const hotPink = new THREE.Color(0xff69b4); // Hot pink
        const purple = new THREE.Color(0x9966cc); // Purple
        const effectColor = hotPink.clone().lerp(purple, proximityStrength);

        // Apply effects to line
        if (arrowHelper.line && arrowHelper.line.material) {
            const lineMaterial = arrowHelper.line.material as any;
            lineMaterial.opacity = arrowHelper.userData.originalLineOpacity * finalOpacity;
            lineMaterial.transparent = true;

            if (proximityStrength > 0.1) {
                const originalColor = arrowHelper.userData.originalLineColor;
                const finalColor = originalColor.clone().lerp(effectColor, proximityStrength * 0.8);
                lineMaterial.color.copy(finalColor);
            } else {
                lineMaterial.color.copy(arrowHelper.userData.originalLineColor);
            }
        }

        // Apply effects to cone
        if (arrowHelper.cone && arrowHelper.cone.material) {
            const coneMaterial = arrowHelper.cone.material as any;
            coneMaterial.opacity = arrowHelper.userData.originalConeOpacity * finalOpacity;
            coneMaterial.transparent = true;

            if (proximityStrength > 0.1) {
                const originalColor = arrowHelper.userData.originalConeColor;
                const finalColor = originalColor.clone().lerp(effectColor, proximityStrength * 0.8);
                coneMaterial.color.copy(finalColor);
            } else {
                coneMaterial.color.copy(arrowHelper.userData.originalConeColor);
            }
        }
    }

    /**
     * Handle 3D object hover highlighting
     */
    private handleObjectHover(object: THREE.Object3D | null) {
        if (this.interactionManager) {
            this.interactionManager.handleObjectHover(object);
        }
    }

    /**
     * Process object selection - moved from MouseDown to MouseUp to prevent selection during camera movements
     */
    private async processObjectSelection(firstIntersectedObject: THREE.Object3D, e: any) {
        console.log('[DEBUG] Processing object selection after mouse up (no drag detected)');

        // Handle face center sprites (legacy refpoint sprites)
        if (firstIntersectedObject && firstIntersectedObject instanceof THREE.Sprite && firstIntersectedObject.userData.type === 'refpoint') {
            if (this.selectedFaceCenterSprite && this.selectedFaceCenterSprite !== firstIntersectedObject) {
                if (this.hoveredFaceCenterSprite === this.selectedFaceCenterSprite && this.hoveredFaceCenterOriginalMaterial) {
                    this.selectedFaceCenterSprite.material = this.hoveredFaceCenterOriginalMaterial;
                } else {
                    this.selectedFaceCenterSprite.material = this.selectedFaceCenterSprite.userData.originalMaterial || this.selectedFaceCenterSprite.material;
                }
            }

            this.selectedFaceCenterSprite = firstIntersectedObject as THREE.Sprite;

            if (!this.selectedFaceCenterSprite.userData.originalMaterial) {
                this.selectedFaceCenterSprite.userData.originalMaterial = (this.selectedFaceCenterSprite.material as THREE.SpriteMaterial).clone();
            }

            const selectedMaterial = (this.selectedFaceCenterSprite.userData.originalMaterial as THREE.SpriteMaterial).clone();
            selectedMaterial.color.setHex(0xff0000);
            this.selectedFaceCenterSprite.material = selectedMaterial;

            const worldPos = new THREE.Vector3();
            this.selectedFaceCenterSprite.getWorldPosition(worldPos);

            console.log('Face center sprite clicked:', {
                outputid: firstIntersectedObject.userData.outputid,
                index: firstIntersectedObject.userData.index,
                localPosition: firstIntersectedObject.position.toArray(),
                worldPosition: worldPos.toArray()
            });

            if (firstIntersectedObject.userData.outputid && firstIntersectedObject.userData.index !== undefined) {
                this.selectedRefPos = firstIntersectedObject.userData.outputid + "." + firstIntersectedObject.userData.index;
                console.log('[DEBUG] Selected refpos from sprite:', this.selectedRefPos);
            }

            // Show scene action menu instead of cell action menu
            const position = this.adjustMenuPosition(e.clientX, e.clientY);
            this.sceneactionleft = position.left;
            this.sceneactiontop = position.top;

            // Set a flag to prevent immediate closing
            console.log('[DEBUG] Setting justOpenedContextMenu = true');
            this.justOpenedContextMenu = true;
            setTimeout(() => {
                console.log('[DEBUG] Setting justOpenedContextMenu = false after timeout');
                this.justOpenedContextMenu = false;
            }, 200);

            this.sceneactionvisible = true;
            this.sceneactionmenuvisible = true;

            // Set correct row selection for the context menu to work
            this.curSelectedRow = this.findNextAvailableOutputRow();

            // Store face center information for potential use
            this.selectedConnectorInfo = {
                label: firstIntersectedObject.userData.outputid + "." + firstIntersectedObject.userData.index,
                position: firstIntersectedObject.position.toArray(),
                normal: firstIntersectedObject.userData.normal,
                type: 'facecenter_sprite',
                outputid: firstIntersectedObject.userData.outputid || 'face_center_sprite'
            };

            // Prevent event from bubbling to document click handler
            e.stopPropagation();
            e.preventDefault();

            // Trigger change detection to update the UI
            this.ngZone.run(() => this.cdr.detectChanges());

            console.log('[DEBUG] Face center sprite scene action menu configured:', {
                visible: this.sceneactionvisible,
                left: this.sceneactionleft,
                top: this.sceneactiontop,
                faceCenterLabel: this.selectedConnectorInfo.label,
                faceCenterOutputId: this.selectedConnectorInfo.outputid
            });

            this.updateThreeFrame();
            return;
        }

        // Add handling for face center sphere clicks (THREE.Mesh objects)
        if (firstIntersectedObject && firstIntersectedObject instanceof THREE.Mesh &&
            firstIntersectedObject.userData.type === 'refpoint' &&
            firstIntersectedObject.userData.isFaceCenter) {

            const worldPos = new THREE.Vector3();
            firstIntersectedObject.getWorldPosition(worldPos);

            console.log('Face center sphere clicked:', {
                outputid: firstIntersectedObject.userData.outputid,
                index: firstIntersectedObject.userData.index,
                localPosition: firstIntersectedObject.position.toArray(),
                worldPosition: worldPos.toArray()
            });

            // Store refpos selection
            if (firstIntersectedObject.userData.outputid && firstIntersectedObject.userData.index !== undefined) {
                this.selectedRefPos = firstIntersectedObject.userData.outputid + "." + firstIntersectedObject.userData.index;
                console.log('[DEBUG] Selected refpos from sphere:', this.selectedRefPos);
            }

            // Show scene action menu instead of cell action menu
            const position = this.adjustMenuPosition(e.clientX, e.clientY);
            this.sceneactionleft = position.left;
            this.sceneactiontop = position.top;

            // Set a flag to prevent immediate closing
            console.log('[DEBUG] Setting justOpenedContextMenu = true');
            this.justOpenedContextMenu = true;
            setTimeout(() => {
                console.log('[DEBUG] Setting justOpenedContextMenu = false after timeout');
                this.justOpenedContextMenu = false;
            }, 200);

            this.sceneactionvisible = true;
            this.sceneactionmenuvisible = true;

            // Set correct row selection for the context menu to work
            this.curSelectedRow = this.findNextAvailableOutputRow();

            // Store face center information for potential use
            this.selectedConnectorInfo = {
                label: firstIntersectedObject.userData.outputid + "." + firstIntersectedObject.userData.index,
                position: firstIntersectedObject.position.toArray(),
                normal: firstIntersectedObject.userData.normal,
                type: 'facecenter',
                outputid: firstIntersectedObject.userData.outputid || 'face_center'
            };

            // Prevent event from bubbling to document click handler
            e.stopPropagation();
            e.preventDefault();

            // Trigger change detection to update the UI
            this.ngZone.run(() => this.cdr.detectChanges());

            console.log('[DEBUG] Face center scene action menu configured:', {
                visible: this.sceneactionvisible,
                left: this.sceneactionleft,
                top: this.sceneactiontop,
                faceCenterLabel: this.selectedConnectorInfo.label,
                faceCenterOutputId: this.selectedConnectorInfo.outputid
            });

            this.updateThreeFrame();
            return;
        }

        if (firstIntersectedObject && firstIntersectedObject instanceof THREE.Sprite && firstIntersectedObject.userData.type === 'connector') {
            if (this.cad.selectedConnectorSprite && this.cad.selectedConnectorSprite !== firstIntersectedObject) {
                if (this.cad.hoveredConnectorSprite === this.cad.selectedConnectorSprite && this.cad.hoveredConnectorOriginalMaterial) {
                    this.cad.selectedConnectorSprite.material = this.cad.hoveredConnectorOriginalMaterial;
                } else {
                    this.cad.selectedConnectorSprite.material = this.cad.selectedConnectorSprite.userData.originalMaterial || this.cad.selectedConnectorSprite.material;
                }
            }

            this.cad.selectedConnectorSprite = firstIntersectedObject as THREE.Sprite;

            if (!this.cad.selectedConnectorSprite.userData.originalMaterial) {
                this.cad.selectedConnectorSprite.userData.originalMaterial = (this.cad.selectedConnectorSprite.material as THREE.SpriteMaterial).clone();
            }

            const selectedMaterial = (this.cad.selectedConnectorSprite.userData.originalMaterial as THREE.SpriteMaterial).clone();
            selectedMaterial.color.setHex(0xff0000);
            this.cad.selectedConnectorSprite.material = selectedMaterial;

            const worldPos = new THREE.Vector3();
            this.cad.selectedConnectorSprite.getWorldPosition(worldPos);

            const connectorGroup = firstIntersectedObject.parent;
            const outputid = connectorGroup?.userData?.outputid;

            console.log('Connector sprite clicked:', {
                label: firstIntersectedObject.userData.label,
                outputid: outputid,
                localPosition: firstIntersectedObject.position.toArray(),
                worldPosition: worldPos.toArray()
            });

            if (outputid) {
                this.selectedConnectorInfo = {
                    label: firstIntersectedObject.userData.label,
                    outputid: outputid,
                    localPosition: firstIntersectedObject.position.toArray(),
                    worldPosition: worldPos.toArray()
                };
                console.log('[DEBUG] Selected connector info:', this.selectedConnectorInfo);
            }

            // Prevent event from bubbling to document click handler
            e.stopPropagation();
            e.preventDefault();

            this.updateThreeFrame();
            return;
        }
    }

    private adjustMenuPosition(clientX: number, clientY: number): { left: string, top: string } {
        const menuWidth = 460; // Approximates .grid-panel width (450px) + padding
        const menuHeight = window.innerHeight * 0.65; // Matches max-height: 65vh in the CSS
        const margin = 10;

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        let left = clientX;
        let top = clientY;

        // Adjust horizontal position to prevent overflow
        if (left + menuWidth > viewportWidth - margin) {
            left = viewportWidth - menuWidth - margin;
        }

        // Adjust vertical position to prevent overflow
        if (top + menuHeight > viewportHeight - margin) {
            // If it overflows the bottom, place its bottom edge just above the cursor
            top = clientY - menuHeight - margin;
        }

        // Ensure the menu does not go off the top or left of the screen
        left = Math.max(margin, left);
        top = Math.max(margin, top);

        return {
            left: left + 'px',
            top: top + 'px'
        };
    }

    private adjustCellMenuPosition(clientX: number, clientY: number): { left: string, top: string } {
        const menuWidth = 250; // Estimated width of the default dropdown
        const menuHeight = 450; // Estimated max height for the dropdown with submenus
        const margin = 10;

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        let left = clientX;
        let top = clientY - 45; // The original vertical offset

        // Adjust horizontal position to prevent overflow
        if (left + menuWidth > viewportWidth - margin) {
            left = viewportWidth - menuWidth - margin;
        }
        left = Math.max(margin, left);

        // Adjust vertical position to prevent overflow
        if (top + menuHeight > viewportHeight - margin) {
            top = viewportHeight - menuHeight - margin;
        }
        top = Math.max(margin, top);

        return {
            left: left + 'px',
            top: top + 'px'
        };
    }

}

